// import axios from "axios"
import React from "react";
import ReactDOM from "react-dom";
import { post } from "./http";
import langCN from "../language/zh_cn";
// eslint-disable-next-line no-undef
import tipAlert from "../Login/BsyAlertTip/Staticize";
import BsyAlert from "../components/BsyAlert";
import { BsyConfig } from "../global/BsyConfig";

import Big from "big-js";
import CryptoJS from "crypto-js";
import { BsyFilterText } from "../components/filterField/BsyFilterText";

import BsyDept from "../components/BsyDept/";
import dayjs from "dayjs";
import _ from "lodash";
import get from "lodash/get";
import isEqual from "lodash/isEqual";
import toInteger from "lodash/toInteger";
import { CacheUtils } from "./cacheUtils.js";

import { BsyFilterComboCheck } from "../components/filterField/BsyFilterComboCheck";
import { BsyFilterTextArea } from "../components/filterField/BsyFilterTextArea";
import { BsyFilterFile } from "../components/filterField/BsyFilterFile";
import { BsyFilterUser } from "../components/filterField/BsyFilterUser";
import { BsyFilterUserGroup } from "../components/filterField/BsyFilterUserGroup";
import { BsyFilterNumber } from "../components/filterField/BsyFilterNumber";
import { BsyFilterFlowState } from "../components/filterField/BsyFilterFlowState";
import { BsyFilterNode } from "../components/filterField/BsyFilterNode";
import { BsyFilterDeptGroup } from "../components/filterField/BsyFilterDeptGroup";
import { BsyFilterDept } from "../components/filterField/BsyFilterDept";
import { BsyFilterDate } from "../components/filterField/BsyFilterDate";
import { BsyFilterFlowNode } from "../components/filterField/BsyFilterFlowNode";
import { BsyFilterFlowBackNode } from "../components/filterField/BsyFilterFlowBackNode";
import { BsyFilterFlowDecision } from "../components/filterField/BsyFilterFlowDecision";
import { BsyFilterAddress } from "../components/filterField/BsyFilterAddress";
import { BsyFilterFlowChargers } from "../components/filterField/BsyFilterFlowChargers";
import BsyTextEditor from "../components/BsyTextEditor";
import BsyDateTime from "../components/BsyDateTime";
import BsyCheckGroup from "../components/BsyCheckGroup";
import BsyRadioGroup from "../components/BsyRadioGroup";
import BsyDeptGroup from "../components/BsyDeptGroup";
import BsyUser from "../components/BsyUser";
import BsyUserGroup from "../components/BsyUserGroup";
import BsyTextArea from "../components/BsyTextArea";
import BsyNumber from "../components/BsyNumber";
import BsyMsgBubble from "../components/BsyMsgBubble";
import BsyComboBox from "../components/BsyComboBox";
import BsyComboCheckBox from "../components/BsyComboCheckBox";
import BsyButton from "../components/BsyButton";
import BsySeparator from "../components/BsySeparator";
import BsyAddress from "../components/BsyAddress";
import BsySerialNum from "../components/BsySerialNum";
import BsyLocation from "../components/BsyLocation";
import { BsyFilterFlowAssistFlowid } from "../components/filterField/BsyFilterFlowAssistFlowid";
import { BsyFilterFlowAssistProstatus } from "../components/filterField/BsyFilterFlowAssistProstatus";
import BsyImageUpload from "../components/BsyImageUpload";
import BsyFileUpload from "../components/BsyFileUpload";
import BsySignature from "../components/BsySignature";
import BsyLinkData from "../components/BsyLinkData";
import BsySubform from "../components/BsySubform";
import BsyLinkQuery from "../components/BsyLinkQuery";
import BsyDataLoad from "../components/BsyDataLoad";
import BsySubformLinkQuery from "../components/BsySubformLinkQuery";
import BsyDeptUserPane from "../components/BsyDeptUserPane";
import { BsyFormulaCalcParser } from "../global/FormulaCalcParser.js";
import { BsyFormula } from "../global/Formula.js";
import { dayjsUtils } from "./dayjsUtils.jsx";
import {
  getBrowser,
  getChromeVersion,
  getFirefoxVersion,
  getSafariVersion,
} from "./os.js";
import { getAfterSuffix } from "./getAfterSuffix.jsx";

export const BsyUtils = {
  getParameterByName: (name) => {
    name = name.replace(/[\[\]]/g, "\\$&");
    const url = window.location.href;
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    const results = regex.exec(url);

    if (!results) {
      return "";
    }

    if (!results[2]) {
      return "";
    }

    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },
  newWidget: (res) => {
    switch (res.type) {
      case "sn":
      case "text": {
        return new BsyTextEditor({ ...res });
      }
      case "textarea": {
        return new BsyTextArea({ ...res });
      }
      case "number": {
        return new BsyNumber({ ...res });
      }
      case "user": {
        return new BsyUser({ ...res });
      }
      case "usergroup": {
        return new BsyUserGroup({ ...res });
      }

      case "dept": {
        return new BsyDept({ ...res });
      }
      case "deptgroup": {
        return new BsyDeptGroup({ ...res });
      }

      case "checkboxgroup": {
        return new BsyCheckGroup({ ...res });
      }
      case "combocheck": {
        return new BsyComboCheckBox({ ...res });
      }
      case "combo": {
        return new BsyComboBox({ ...res });
      }
      case "button": {
        return new BsyButton({ ...res });
      }
      case "datetime": {
        return new BsyDateTime({ ...res });
      }
      case "linkdata": {
        return new BsyLinkData({ ...res });
      }
      case "linkquery": {
        return new BsySubformLinkQuery({ ...res });
      }
      case "radiogroup": {
        return new BsyRadioGroup({ ...res });
      }
      case "address": {
        return new BsyAddress({ ...res });
      }
      case "location": {
        return new BsyLocation({ ...res });
      }
      case "dataload": {
        return new BsyDataLoad({ ...res });
      }
      case "image": {
        return new BsyImageUpload({ ...res });
      }
      case "upload": {
        return new BsyFileUpload({ ...res });
      }
      case "signature": {
        return new BsySignature({ ...res });
      }
      case "assist_flowid": {
        return new BsyTextEditor({ ...res });
      }
      case "assist_prostatus": {
        return new BsyTextEditor({ ...res });
      }

      default:
        return null;
      // console.log(res.type)
      // return <div >无效的组件</div>
    }
  },
  clearHttpRequest: (e) => {
    CacheUtils.clearCache(e);
  },
  getDomOffset: function (e, i) {
    if (!e || !i) return null;
    var a = BsyUtils.elemoffset(e),
      s = BsyUtils.elemoffset(i);
    return {
      top: a.top - s.top,
      left: a.left - s.left,
    };
  },
  getUserDeptId: (id) => {
    if (BsyUtils.isArray(id)) {
      let isd = [];
      for (let i = 0; i < id.length; i++) {
        if (BsyUtils.isString(id[i])) {
          isd.push(id[i]);
        } else {
          isd.push(id[i].id || id[i]._id);
        }
      }
      return isd;
    } else {
      let isd = null;
      if (BsyUtils.isString(id)) {
        isd = id;
      } else {
        isd = id.id || id._id;
      }
      return isd;
    }
  },
  checkImg: function (file) {
    const ext = file.name ? file.name.split(".").pop() : ""
    if (file.mime.indexOf("image") > -1) {
      return true;
    } else if (BsyUtils.isImageExt(ext)) {
      return true;
    }
    return false;
  },
  createWidget: (res) => {
    switch (res.type) {
      case "text": {
        return <BsyTextEditor {...res} />;
      }
      case "textarea": {
        return <BsyTextArea {...res} />;
      }
      case "number": {
        return <BsyNumber {...res} />;
      }
      case "user": {
        return <BsyUser {...res} ftoken={window.FX.STATIC.FTOKEN} />;
      }
      case "button": {
        return <BsyButton {...res} />;
      }
      case "usergroup": {
        return <BsyUserGroup {...res} ftoken={window.FX.STATIC.FTOKEN} />;
      }
      case "upload": {
        return <BsyFileUpload {...res} />;
      }
      case "image": {
        return <BsyImageUpload {...res} />;
      }
      case "signature": {
        return <BsySignature {...res} />;
      }
      case "dept": {
        return <BsyDept {...res} ftoken={window.FX.STATIC.FTOKEN} />;
      }
      case "deptgroup": {
        return <BsyDeptGroup {...res} ftoken={window.FX.STATIC.FTOKEN} />;
      }

      case "linkdata": {
        return <BsyLinkData {...res} />;
      }
      case "linkquery": {
        return <BsyLinkQuery {...res} />;
      }
      case "checkboxgroup": {
        return <BsyCheckGroup {...res} />;
      }
      case "combocheck": {
        return <BsyComboCheckBox {...res} />;
      }
      case "combo": {
        return <BsyComboBox {...res} />;
      }

      case "datetime": {
        return <BsyDateTime {...res} />;
      }
      case "radiogroup": {
        return <BsyRadioGroup {...res} />;
      }
      case "subform": {
        // console.log('bsyutils.createWidget.subform',JSON.stringify(res))
        return <BsySubform {...res} />;
      }

      case "separator": {
        return <BsySeparator {...res} />;
      }

      case "address": {
        return <BsyAddress {...res} />;
      }

      case "sn": {
        return <BsySerialNum {...res} />;
      }

      case "location": {
        return <BsyLocation {...res} />;
      }
      case "dataload": {
        return <BsyDataLoad {...res} />;
      }

      case "combo_filter":
      case "sn_filter":
      case "radiogroup_filter":
      case "text_filter": {
        return <BsyFilterText {...res}></BsyFilterText>;
      }
      case "checkboxgroup_filter":
      case "combocheck_filter": {
        return <BsyFilterComboCheck {...res}></BsyFilterComboCheck>;
      }
      case "textarea_filter": {
        return <BsyFilterTextArea {...res}></BsyFilterTextArea>;
      }
      case "upload_filter":
      case "image_filter":
      case "signature_filter":
      case "filelist_filter": {
        return <BsyFilterFile {...res}></BsyFilterFile>;
      }
      case "flownode":
      case "backflowid": {
        return <BsyFilterNode {...res}></BsyFilterNode>;
      }
      case "flowcreator_filter":
      case "user_filter": {
        return <BsyFilterUser {...res}></BsyFilterUser>;
      }
      case "number_filter": {
        return <BsyFilterNumber {...res}></BsyFilterNumber>;
      }
      case "flowstate_filter": {
        return <BsyFilterFlowState {...res}></BsyFilterFlowState>;
      }
      case "flowdecision_filter": {
        return <BsyFilterFlowDecision {...res}></BsyFilterFlowDecision>;
      }
      case "location_filter":
      case "address_filter": {
        return <BsyFilterAddress {...res} format={"pcd"} />;
      }
      case "address_province_filter": {
        return <BsyFilterAddress {...res} format={"p"}></BsyFilterAddress>;
      }
      case "address_city_filter": {
        return <BsyFilterAddress {...res} format={"pc"}></BsyFilterAddress>;
      }
      case "usergroup_filter": {
        return <BsyFilterUserGroup {...res}></BsyFilterUserGroup>;
      }
      case "dept_filter": {
        return <BsyFilterDept {...res}></BsyFilterDept>;
      }
      case "deptgroup_filter": {
        return <BsyFilterDeptGroup {...res}></BsyFilterDeptGroup>;
      }
      case "flownode_filter": {
        return <BsyFilterFlowNode {...res}></BsyFilterFlowNode>;
      }
      case "backflowid_filter": {
        return <BsyFilterFlowBackNode {...res}></BsyFilterFlowBackNode>;
      }
      case "date_filter":
      case "datetime_filter":
      case "datemonth_filter":
      case "dateyear_filter": {
        return <BsyFilterDate {...res} />;
      }

      case "flow_chargers_filter": {
        return <BsyFilterFlowChargers {...res} />;
      }
      case "assist_prostatus_filter": {
        return <BsyFilterFlowAssistProstatus {...res} />;
      }
      case "assist_flowid_filter": {
        return <BsyFilterFlowAssistFlowid {...res} />;
      }
      default:
        console.log(res.type);
        return <div>无效的组件</div>;
    }
  },
  //交换两个元素的位置
  swapArrayElements: (array, index1, index2) => {
    // 检查索引是否有效
    if (
      index1 < 0 ||
      index1 >= array.length ||
      index2 < 0 ||
      index2 >= array.length
    ) {
      return array;
    }

    let temp = JSON.stringify(array[index1]);
    array[index1] = JSON.parse(JSON.stringify(array[index2]));
    array[index2] = JSON.parse(temp);

    return _.cloneDeep(array);
  },
  _isSubformWidget: (a) => {
    // console.log('_isSubformWidget', a);
    if (BsyUtils.isString(a)) {
      return a.indexOf(".") > -1;
    }
    return false;
  },
  _getTeamName: (CorpID) => {
    let teamName = "";
    BsyUtils.forEach(window?.localDevInfo?.corps, function (a, b) {
      if (CorpID === b.id) {
        teamName = b.name;
        return !1;
      }
    });
    return teamName;
  },
  createFooterLogo: () => {
    window.FX.STATIC.VIP_PACK = null;
    if (!BsyUtils.Vip.hasCustomTheme()) {
      var herf =
        window.rootDirectroy +
        "/index.php?dashboard/f&v1=report&ext_url=" +
        window.location.href;

      return (
        <div className="footer-logo">
          <p>
            <span>
              {React.language("external.link.tip2", {
                site_name: window._bby_config.site_name,
              })}{" "}
            </span>
            <a
              target="_blank"
              rel="noreferrer"
              id="me_report"
              style={{ color: "#0c9ef2" }}
              href={herf}
            >
              {React.language("abuseReport")}
            </a>
            <a target="_blank" className="right">
              Powered by {window._bby_config.site_name}{" "}
            </a>
          </p>
        </div>
      );
    }
    return "";
  },
  getSubformWidgetWidth: function (t) {
    var e = 150;
    switch (t.type) {
      case "button":
        e = 80;
        break;
      case "datetime":
        e = 180;
        break;
      case "radiogroup":
      case "combo":
      case "combocheck":
      case "checkboxgroup":
        e = 220;
        break;
      case "user":
      case "usergroup":
      case "dept":
      case "deptgroup":
        e = 200;
        break;
      case "address":
      case "textarea":
      case "location":
        e = 250;
        break;
      case "upload":
      case "image":
      case "signature":
        e = 200;
        break;
      case "linkquery":
        e = t.linkFields ? t.linkFields.length * 150 + 10 : 150 + 10;
        break;
      case "linkdata":
        e = t.linkFields ? t.linkFields.length * 150 + 45 : 150 + 10;
        break;
      default:
    }
    switch (t.fieldWidth) {
      case BsyConfig().CONST.FIELD_WIDTH.FIVE:
        "datetime" === t.type ? (e = (3 * e) / 5) : (e /= 5);
        break;
      case BsyConfig().CONST.FIELD_WIDTH.FOUR:
        "datetime" === t.type ? (e = (3 * e) / 4) : (e /= 4);
        break;
      case BsyConfig().CONST.FIELD_WIDTH.THIRD:
        "datetime" === t.type ? (e = (2 * e) / 3) : (e /= 3);
        break;
      case BsyConfig().CONST.FIELD_WIDTH.HALF:
        "datetime" === t.type ? (e = (2 * e) / 3) : (e /= 2);
        break;
      case BsyConfig().CONST.FIELD_WIDTH.TWICE:
        e *= 2;
        break;
      case BsyConfig().CONST.FIELD_WIDTH.CUSTOM:
        // if("datetime" == t.type)
        //     e = 2 * e;
        t.customWith = t.customWith || 100;
        // e = e / 100 * parseFloat(t.customWith)
        e = t.customWidth || (e / 100) * parseFloat(t.customWith);
        break;
      default:
    }
    return e;
  },
  escapeRegexp: function (t) {
    if ("string" != typeof t) return "";
    var e = /[|\\{}()[\]^$+*?.]/g;
    return t.replace(e, "\\$&");
  },
  byteFormat2: function (a, n) {
    return BsyUtils.isNumber(a)
      ? a >= 1073741824
        ? (a / 1073741824).toFixed(n) + " GB"
        : a >= 1e6
          ? (a / 1048576).toFixed(n) + " MB"
          : (a / 1024).toFixed(n) + " KB"
      : React.language("unknown");
  },
  openHelpMenu: (event) => {
    let jsonHelp = window.siteDevInfo.sitesetting.help_page;
    BsyMsgBubble({
      anchor: event.currentTarget,
      contentHTML: () => {
        return (
          <div className="bsy-help-center">
            <div className="helpinfo">
              {jsonHelp.map((val) => {
                return (
                  <a
                    className="helpItem"
                    rel="noreferrer"
                    target="_blank"
                    href={val.url}
                  >
                    <i className={"icon-bsy-help-" + val.icon} />
                    <span>{val.title}</span>
                  </a>
                );
              })}
            </div>
          </div>
        );
      },
      text4Cancel: null,
      text4Ok: null,
      minWidth: 130,
      width: 150,
      contentPadding: 0,
      edge: 200,
      hAdjust: 72,
      dockPosition: "right",
      // "marginTop":20,
      onClose: function () {
        return !1;
      },
    });
  },
  arrayUnique: function (arr) {
    if (!arr) return [];
    var res = [];
    var seen = {};
    for (var i = 0; i < arr.length; i++) {
      if (!seen[arr[i]]) {
        res.push(arr[i]);
        seen[arr[i]] = true;
      }
    }
    return res;
  },
  toStringDetailed: function (value) {
    function toStr(value) {
      // 处理 null 和 undefined
      if (value === null) return "";
      if (value === undefined) return "";
      if (typeof value === "number" && isNaN(value)) return "";

      // 处理基本类型
      if (typeof value !== "object") return String(value);

      // 处理数组
      if (Array.isArray(value)) {
        return value.map((item) => toStr(item)).join(",");
      }

      // 处理日期对象
      if (value instanceof Date) {

        const timezone = BsyUtils.getSysTimeZone();
        if (!timezone) {
          return value + '';
        }

        const formattedDate = dayjs(value)
          .tz(timezone)
          .format('ddd MMM D YYYY HH:mm:ss ZZ');

        let strs = formattedDate.split(' ');
        strs[strs.length - 1] = 'GMT' + strs[strs.length - 1];
        return strs.join(' ');
      }

      // 处理正则表达式
      if (value instanceof RegExp) {
        return value.toString();
      }

      // 处理普通对象
      try {
        return JSON.stringify(value);
      } catch (e) {
        // 处理循环引用等JSON.stringify无法处理的情况
        return Object.prototype.toString.call(value);
      }
    }
    return toStr(value);
  },
  getAddressText: function (a) {
    try {
      if (BsyUtils.isString(a)) {
        let a1 = JSON.parse(a);
        if (!BsyUtils.isObjectEmpty(a1)) {
          if (
            a1.hasOwnProperty("province") ||
            a1.hasOwnProperty("city") ||
            a1.hasOwnProperty("district") ||
            a1.hasOwnProperty("detail")
          ) {
            a = BsyUtils.address2Str(a1, "pcda");
          }
        }
      }
    } catch (e) {
      a = a + "";
    }
    return a;
  },
  highlighterText: (keyword, text, color) => {
    color = color || "#0265ff";

    if (!keyword) {
      return text;
    }

    if (!text) {
      return text;
    }

    if (BsyUtils.isArray(text)) {
      text = text.join("");
    }

    let maths = text.split(keyword);

    if (maths.length === 1) {
      return text;
    }

    if (maths.length) {
      return (
        <>
          {maths.map((item, index) => {
            if (index == maths.length - 1) {
              return item;
            }
            return (
              <>
                {item}
                <span style={{ color: color }}>{keyword}</span>
              </>
            );
          })}
        </>
      );
    }
    return text;
  },
  getUrl: function (data, i) {
    var strs = "";
    //替换内容

    if (
      "internalFrom" == i.urlmode &&
      !BsyUtils.isObjectEmpty(i.internalFrom)
    ) {
      var routUrl = window.root_directroy ? window.root_directroy + "/" : "";
      //i.internalFrom.entryId ? (_bby_config.site + "dashboard/app/" +  (i.internalFrom.appId ? i.internalFrom.appId : FX.STATIC.APPID )  + "#/" + i.internalFrom.type + "/" + i.internalFrom.entryId) : "",//_bby_config.site+"dashboard/app/" + FX.STATIC.APPID + "/entry/" + FX.STATIC.ENTRYID
      var url = i.internalFrom.entryId
        ? window._bby_config.site +
        routUrl +
        "team/app/" +
        (i.internalFrom.appId
          ? i.internalFrom.appId
          : window.FX.STATIC.APPID) +
        "/" +
        i.internalFrom.type +
        "/" +
        i.internalFrom.entryId
        : "";
      var args = i.internalFrom.urlcode;

      if (args) {
        //拿对应 关系
        BsyUtils.forEach(i.internalFrom.args, function (a1, b1) {
          if (a1 != 0) {
            strs += "&";
          }
          //取报表筛选条件的结构
          var widgetarts = args[b1.field || b1.widgetId];
          strs += (b1.field || b1.widgetId) + "=";
          var re = /\${[0-9\._a-zA-Z\-\>]+}/g;
          //匹配表单字段
          var fields = [];
          if (i.internalFrom.type == "form") {
            if (b1.depend) {
              var name = b1.depend.field;
              if (
                !BsyUtils.isObjectEmpty(data[name]) &&
                !BsyUtils.isObjectEmpty(data[name].data)
              ) {
                if (["datetime", "number"].indexOf(b1.type) > -1) {
                  widgetarts = data[name].data;
                } else if (
                  [
                    "text",
                    "combo",
                    "radiogroup",
                    "sn",
                    "dept",
                    "user",
                    "textarea",
                  ].indexOf(b1.type) > -1
                ) {
                  widgetarts = data[name].data;
                } else if (
                  [
                    "deptgroup",
                    "usergroup",
                    "address",
                    "location",
                    "checkboxgroup",
                    "combocheck",
                  ].indexOf(b1.type) > -1
                ) {
                  widgetarts = JSON.stringify(data[name].data);
                } else {
                  widgetarts = "";
                }
              } else {
                widgetarts = "";
              }
            }
          } else fields = widgetarts.match(re);
          BsyUtils.forEach(fields, function (a2, b2) {
            //拿真实字段
            var name = b2.substr(2, b2.length - 3);

            if (
              !BsyUtils.isObjectEmpty(data[name]) &&
              !BsyUtils.isObjectEmpty(data[name].data)
            ) {
              var re1 = new RegExp('"\\${' + name + '}"', "g"); ///\"\${[0-9\._a-zA-Z\-\>]+}\"/g;

              if (i.internalFrom.type == "form") {
                re1 = new RegExp("\\${" + name + "}", "g");
              }

              if (["datetime", "number"].indexOf(b1.type) > -1) {
                widgetarts = widgetarts.replace(re1, data[name].data);
              } else if (
                [
                  "text",
                  "combo",
                  "radiogroup",
                  "sn",
                  "dept",
                  "user",
                  "textarea",
                ].indexOf(b1.type) > -1
              ) {
                if (["in", "nin"].indexOf(b1.method) > -1) {
                  re1 = new RegExp('\\["\\${' + name + '}"\\]', "g");
                  widgetarts = widgetarts.replace(
                    re1,
                    JSON.stringify(data[name].data)
                  );
                } else {
                  re1 = new RegExp("\\${" + name + "}", "g");
                  widgetarts = widgetarts.replace(re1, data[name].data);
                }
              } else if (
                [
                  "deptgroup",
                  "usergroup",
                  "address",
                  "location",
                  "checkboxgroup",
                  "combocheck",
                ].indexOf(b1.type) > -1
              ) {
                widgetarts = widgetarts.replace(
                  re1,
                  JSON.stringify(data[name].data)
                );
              } else {
                widgetarts = widgetarts.replace(re1, "");
              }
            } else if (name == "currentUser") {
              if (window.FX.STATIC.user && window.FX.STATIC.user._id)
                widgetarts = widgetarts.replace(re, window.FX.STATIC.user._id);
            } else {
              var re1 = new RegExp('"\\${' + name + '}"', "g");
              if (i.internalFrom.type == "form") {
                re1 = new RegExp("\\${" + name + "}", "g");
              }
              if (["datetime", "number"].indexOf(b1.type) > -1) {
                widgetarts = widgetarts.replace(re1, "null");
              } else if (
                [
                  "deptgroup",
                  "usergroup",
                  "address",
                  "location",
                  "checkboxgroup",
                  "combocheck",
                ].indexOf(b1.type) > -1
              ) {
                widgetarts = widgetarts.replace(re1, "[]");
              } else if (
                [
                  "text",
                  "combo",
                  "radiogroup",
                  "sn",
                  "dept",
                  "user",
                  "textarea",
                ].indexOf(b1.type) > -1
              ) {
                re1 = new RegExp("\\${" + name + "}", "g");
                widgetarts = widgetarts.replace(re1, "");
              }
            }
          });
          strs += encodeURIComponent(widgetarts);
        });
      }
      url = url + "?" + strs;
      return url;
    }
    return "";
  },
  loadData: (deptid, userid, appId, is_dock_form, cb) => {
    if (is_dock_form) {
      return;
    }

    let url = "/data/department/hover_detail";
    if (userid) {
      url = "/data/member/hover_detail";
    }

    React.axios(url, {
      dept_id: deptid ? deptid : undefined,
      user_id: userid ? userid : undefined,
      appId: appId || window.FX.STATIC.APPID,
    })
      .then((res) => {
        BsyUtils.showAjaxTip(res.data, () => {
          cb && cb(res.data);
        });
      })
      .catch((res) => {
        console.error(res);
      });
  },

  showUserInfo: (dept, user, t, appId, is_dock_form) => {
    if (window.FX.STATIC.QTOKEN) {
      return;
    }

    BsyUtils.loadData(
      dept && (dept.id || dept._id),
      user && (user.id || user._id),
      appId,
      is_dock_form,
      (info) => {
        BsyMsgBubble({
          anchor: t.target,
          contentHTML: (ref) => {
            return (
              <BsyDeptUserPane
                type={dept ? "dept" : "user"}
                status={info.status === -99 ? "deleted" : ""}
                info={{ ...info }}
              />
            );
          },
          text4Cancel: null,
          text4Ok: null,
          // theme: this.props.theme,
          minWidth: "auto",
          width: 300,
          contentPadding: 0,
          edge: 200,
          hAdjust: 72,
          dockPosition: "left",
          onClose: function () {
            return !1;
          },
        });
      }
    );
  },

  hasHref: function (href) {
    if (!href) return !1;

    href = href || { ...window.FX.STATIC.FORMHREF };

    function checkUrl(url) {
      var re =
        /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
      return re.test(url);
    }
    if (href) {
      if (href.urlmode == "externalUrl") {
        if ("external" in href && !BsyUtils.isObjectEmpty(href.external)) {
          if (!href.external?.webUrl) return !1;
        }
        const url = href?.external?.webUrl || href.externalUrl;
        if (!url) {
          return !1;
        } else {
          if (!checkUrl(url)) {
            return !1;
          }
        }
      } else {
        if (BsyUtils.isObjectEmpty(href.internalFrom)) {
          return !1;
        }
      }
    }
    return !0;
  },
  href: function (b) {
    function getUrl(url) {
      if (href.hasBlank) {
        return url;
      }
      if (url.indexOf("?") == -1) {
        url += "?st=" + new Date().getTime();
      } else {
        url += "&st=" + new Date().getTime();
      }
      return url;
    }

    function getExternalUrl() {
      if (window.FX.STATIC.FTOKEN) {
        let url = BsyUtils.createWebPage({}, href.external, b, -1);
        url = getUrl(url);
        BsyUtils.redirectTo(url, href.hasBlank ? "_blank" : "");
      } else {
        window.FX.Utils.ajax(
          {
            url: "/data/getCurrentUserInfo",
            data: {
              appId: window.FX.STATIC.APPID,
            },
          },
          function (res) {
            let url = BsyUtils.createWebPage(res.data, href.external, b, -1);
            url = getUrl(url);
            BsyUtils.redirectTo(url, href.hasBlank ? "_blank" : "");
          }
        );
      }
    }

    var href = { ...window.FX.STATIC.FORMHREF };
    if (href.hasBlank) {
      if (href.urlmode == "externalUrl") {
        if ("external" in href && !BsyUtils.isObjectEmpty(href.external)) {
          getExternalUrl();
        } else {
          BsyUtils.redirectTo(href.externalUrl, "_blank");
        }
      } else {
        var url = BsyUtils.getUrl(b, href);
        if (url) BsyUtils.redirectTo(url, "_blank");
      }
    } else {
      //url没有变化的情况下页面无法刷新
      if (href.urlmode == "externalUrl") {
        if ("external" in href && !BsyUtils.isObjectEmpty(href.external)) {
          getExternalUrl();
        } else {
          let externalUrl = href.externalUrl;
          externalUrl = getUrl(externalUrl);
          BsyUtils.redirectTo(externalUrl);
        }
      } else {
        let externalUrl = BsyUtils.getUrl(b, href);
        externalUrl = getUrl(externalUrl);
        if (externalUrl) BsyUtils.redirectTo(externalUrl);
      }
    }
  },
  getWebFieldValue: function (res, val, subformvalindex, opt) {
    var lineValue;
    if (!val) {
      return "";
    }
    if (subformvalindex > -1) {
      if (opt.subform === res.name.split(".")[0]) {
        if (val[opt.subform].data.length > 0) {
          lineValue =
            val[opt.subform].data[subformvalindex][res.name.split(".")[1]].data;
        } else {
          lineValue = "";
        }
      }
    } else {
      if (res.name.indexOf(".") > -1) {
        if (val[res.name.split(".")[0]]) {
          lineValue = val[res.name.split(".")[0]].data;
        } else {
          lineValue = "";
        }
      } else {
        if (val[res.name]) {
          lineValue = val[res.name].data;
        } else {
          lineValue = "";
        }
      }
    }

    if (!lineValue && lineValue !== 0) {
      return "";
    }

    switch (res.type) {
      case "checkboxgroup":
      case "combocheck":
      case "array":
      case "radiogroup":
      case "combo":
      case "string":
      case "text":
      case "id":
      case "did":
      case "dept":
      case "user":
      case "usergroup":
      case "deptgroup":
        if (BsyUtils.isArray(lineValue)) {
          lineValue = lineValue.join("、");
        }
        break;
      case "formula":
      case "number":
        lineValue = BsyUtils.num2Str(lineValue, res.format);

        break;
      case "flowState": {
        switch (parseInt(lineValue)) {
          case window.FX.CONST.WORKFLOW.FLOWSTATE.INPROCESS:
            lineValue = React.language("flow.state.inProcess");
            break;
          case window.FX.CONST.WORKFLOW.FLOWSTATE.COMPLETE:
            lineValue = React.language("flow.node.end");
            break;
          case window.FX.CONST.WORKFLOW.FLOWSTATE.CLOSE:
            lineValue = React.language("flow.state.closed");
            break;
          default:
            lineValue = "";
        }
        break;
      }
      case "address":
      case "location":
        var l = [];
        var e = lineValue;
        if (e.province) {
          l.push(e.province);
          e.city && e.province !== e.city && l.push(e.city);
          e.district && l.push(e.district);
        }
        if (e.detail) {
          l.push(e.detail);
        }
        lineValue = BsyUtils.address2Str(e, e.format || "pcda");

        break;
      case "lat":
        var e = val[res.name.split(".")[0]].data;
        lineValue = e.lnglatXY ? e.lnglatXY[1] : "";
        break;
      case "lng":
        var e = val[res.name.split(".")[0]].data;
        lineValue = e.lnglatXY ? e.lnglatXY[0] : "";
        break;
      case "datetime":
        break;
      case "linkdata":
        var e = lineValue;
        var d = e && e.key;
        if (BsyUtils.isNull(d)) {
          lineValue = "";
          break;
        }
        "datetime" === res.linkType
          ? (lineValue = BsyUtils.date2Str(new Date(d), "yyyy-MM-dd"))
          : (lineValue = d);

        break;
      default:
        break;
    }

    return lineValue;
  },
  getFormatDateStart: function (date, format) {
    date.setMilliseconds(0);
    switch (format) {
      case "yyyy": {
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
        break;
      }
      case "yyyy-MM": {
        date.setDate(1);
        date.setHours(0, 0, 0, 0);
        break;
      }
      case "yyyy-MM-dd HH:mm:ss":
      case "yyyy-MM-dd HH:mm":
      case "yyyy-MM-dd":
      default: {
        date.setHours(0, 0, 0, 0);
        break;
      }
    }
    return new Date(date.getTime());
  },
  getFormatDateEnd: function (date, format) {
    date.setMilliseconds(999);
    switch (format) {
      case "yyyy": {
        date.setMonth(11, 31);
        date.setHours(23, 59, 59, 999);
        break;
      }
      case "yyyy-MM": {
        date.setMonth(date.getMonth() + 1);
        date.setMilliseconds(-1);
        break;
      }
      case "yyyy-MM-dd HH:mm:ss":
      case "yyyy-MM-dd HH:mm":
      case "yyyy-MM-dd":
      default: {
        date.setHours(23, 59, 59, 999);
        break;
      }
    }
    return new Date(date.getTime());
  },
  getFormatDate: function (date, format) {
    date.setMilliseconds(0);
    switch (format) {
      case "yyyy": {
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
        break;
      }
      case "yyyy-MM": {
        date.setDate(1);
        date.setHours(0, 0, 0, 0);
        break;
      }
      case "yyyy-MM-dd HH:mm:ss": {
        date.setMilliseconds(0);
        break;
      }
      case "yyyy-MM-dd HH:mm": {
        date.setHours(date.getHours(), date.getMinutes(), 0, 0);
        break;
      }
      case "yyyy-MM-dd":
      default: {
        date.setHours(0, 0, 0, 0);
        break;
      }
    }
    return new Date(date.getTime());
  },
  createWebPage: function (webParameterList, opt, val, subformvalindex, ref) {
    var i = opt,
      e = BsyUtils,
      webUrl = "",
      suffix = "";
    BsyUtils.forEach(i.suffixField, function (key, res) {
      if (
        encodeURIComponent(
          e.getWebFieldValue(res, val, subformvalindex, opt)
        ) === ""
      ) {
        return;
      }
      suffix +=
        "/" +
        encodeURIComponent(e.getWebFieldValue(res, val, subformvalindex, opt));
    });
    BsyUtils.forEach(i.webParameter, function (key, res) {
      var sym = "";
      if (key !== 0) {
        sym = "&";
      }
      switch (res) {
        case "webpage_corp_id":
          if (webParameterList.corp_id) {
            webUrl +=
              sym +
              "webpage_corp_id=" +
              encodeURIComponent(webParameterList.corp_id);
          }

          break;
        case "webpage_user_id":
          if (webParameterList.user_id)
            webUrl +=
              sym +
              "webpage_user_id=" +
              encodeURIComponent(webParameterList.user_id);
          break;
        case "webpage_phone":
          if (webParameterList.mobile)
            webUrl +=
              sym +
              "webpage_phone=" +
              encodeURIComponent(webParameterList.mobile);
          break;
        case "webpage_account":
          if (webParameterList.account)
            webUrl +=
              sym +
              "webpage_account=" +
              encodeURIComponent(webParameterList.account);
          break;
        case "webpage_email":
          if (webParameterList.email)
            webUrl +=
              sym +
              "webpage_email=" +
              encodeURIComponent(webParameterList.email);
          break;
        case "webpage_corp_user_id":
          if (webParameterList.uniqueid)
            webUrl +=
              sym +
              "webpage_corp_user_id=" +
              encodeURIComponent(webParameterList.uniqueid);
          break;
        default:
      }
    });

    BsyUtils.forEach(i.webField, function (key, res) {
      var sym = "";
      if (webUrl) {
        sym = "&";
      } else {
        if (key !== 0) {
          sym = "&";
        }
      }

      if (
        encodeURIComponent(
          e.getWebFieldValue(res, val, subformvalindex, opt)
        ) === ""
      ) {
        return;
      }
      webUrl +=
        sym +
        res.key +
        "=" +
        encodeURIComponent(e.getWebFieldValue(res, val, subformvalindex, opt));
    });

    if (i.webUrl.indexOf("?") > -1) {
      var urlList = i.webUrl.split("?");
      webUrl = urlList[0] + suffix + "?" + webUrl + "&" + urlList[1];
    } else {
      webUrl = i.webUrl + suffix + "?" + webUrl;
    }

    return webUrl;
  },
  getUpperTimeLimit: function (t) {
    var e = BsyUtils.parseDate(t),
      i = BsyUtils.getDateInfo(e);
    if (BsyUtils.isObjectEmpty(i)) return null;
    if (/^\d{4}-\d{1,2}$/.test(t)) {
      e = BsyUtils.getMonthDays(i.year, i.month);
      return new Date(i.year, i.month, e, 23, 59, 59, 999);
    }
    return /^\d{4}-\d{1,2}-\d{1,2}$/.test(t)
      ? new Date(i.year, i.month, i.day, 23, 59, 59, 999)
      : /^\d{4}-\d{1,2}-\d{1,2} \d{1,2}:\d{1,2}$/.test(t)
        ? new Date(i.year, i.month, i.day, i.hour, i.minute, 59, 999)
        : /^\d{4}-\d{1,2}-\d{1,2} \d{1,2}:\d{1,2}:\d{1,2}$/.test(t)
          ? new Date(i.year, i.month, i.day, i.hour, i.minute, i.second, 999)
          : null;
  },
  getDateByOffset: function (t, e, i) {
    if (!BsyUtils.isDate(t)) return null;
    var a = BsyConfig().CONST.DATE_FILTER_FORMULA_UNIT;
    switch (i) {
      case a.DAY:
        return BsyUtils.getDateByDayOffset(t, e);
      case a.WEEK:
        return BsyUtils.getDateByWeekOffset(t, e);
      case a.MONTH:
        return BsyUtils.getDateByMonthOffset(t, e);
      case a.QUARTER:
        return BsyUtils.getDateByQuarterOffset(t, e);
      case a.YEAR:
        return BsyUtils.getDateByYearOffset(t, e);
      default:
        return null;
    }
  },
  getDateByDayOffset: function (t, e) {
    t = BsyUtils.getDateInfo(t);
    return new Date(
      t.year,
      t.month,
      t.day + e,
      t.hour,
      t.minute,
      t.second,
      t.millisecond
    );
  },
  getDateByWeekOffset: function (t, e) {
    t = BsyUtils.getDateInfo(t);
    return new Date(
      t.year,
      t.month,
      t.day + 7 * e,
      t.hour,
      t.minute,
      t.second,
      t.millisecond
    );
  },
  getDateByQuarterOffset: function (t, e) {
    return BsyUtils.getDateByMonthOffset(t, 3 * e);
  },
  getDateByMonthOffset: function (t, e) {
    var i = BsyUtils.getDateInfo(t),
      a = i.year,
      t = i.month;
    a += parseInt(e / 12 + "", 10);
    if ((t += e % 12)) {
      --a;
      t += 12;
    } else {
      if (11 < t) {
        a += 1;
        t -= 12;
      }
      // 11 < t && (a += 1, t -= 12)
    }

    // (t += e % 12) < 0 ? (--a,
    //     t += 12) : 11 < t && (a += 1,
    //         t -= 12);
    e = BsyUtils.getMonthDays(a, t);
    e = Math.min(e, i.day);
    return new Date(a, t, e, i.hour, i.minute, i.second, i.millisecond);
  },
  getDateByYearOffset: function (t, e) {
    var i = BsyUtils.getDateInfo(t),
      t = i.year + e,
      e = BsyUtils.getMonthDays(t, i.month),
      e = Math.min(e, i.day);
    return new Date(t, i.month, e, i.hour, i.minute, i.second, i.millisecond);
  },
  getFormulaTimeRange: function (t) {
    var e,
      i = BsyConfig().CONST.DATE_FILTER_FORMULA_MODE,
      a = BsyConfig().CONST.DATE_FILTER_FORMULA_MAP;
    if (BsyUtils.isString(t)) {
      var dt = t;
      switch (t) {
        case "today": {
          let d = dayjsUtils.timeToTZ(new Date());
          dt = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
          let result = {
            min: BsyUtils.parseDate(dt),
            max: BsyUtils.getUpperTimeLimit(dt),
          };
          return {
            min: result.min.getTime(),
            max: result.max.getTime(),
          };
          break;
        }
        case "yesterday": {
          let d = dayjsUtils.timeToTZ(new Date());
          d.setHours(0, 0, 0, 0);
          d = new Date(d.getTime() - 1);
          dt = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
          const result = {
            min: BsyUtils.parseDate(dt),
            max: BsyUtils.getUpperTimeLimit(dt),
          }
          return {
            min: result.min.getTime(),
            max: result.max.getTime(),
          };
          break;
        }
        case "thisWeek": {
          let nowThisWeek = new Date().getDay(); //获取当前周
          let nowDate = dayjsUtils.timeToTZ(new Date()).getTime();
          let d = new Date(nowDate - (nowThisWeek - 1) * 86400000);
          d.setHours(0, 0, 0, 0);
          dt = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();

          d = new Date(d.getTime() + 6.5 * 86400000);
          let dt1 =
            d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
          const result = {
            min: BsyUtils.parseDate(dt),
            max: BsyUtils.getUpperTimeLimit(dt1),
          }
          return {
            min: result.min.getTime(),
            max: result.max.getTime(),
          };
        }
        case "lastWeek": {
          let nowThisWeek = new Date().getDay(); //获取当前周
          let nowDate = dayjsUtils.timeToTZ(new Date()).getTime();
          let d = new Date(nowDate - (nowThisWeek - 1 + 7) * 86400000);
          d.setHours(0, 0, 0, 0);
          dt = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();

          d = new Date(d.getTime() + 6.5 * 86400000);
          let dt1 =
            d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
          const result = {
            min: BsyUtils.parseDate(dt),
            max: BsyUtils.getUpperTimeLimit(dt1),
          }
          return {
            min: result.min.getTime(),
            max: result.max.getTime(),
          };
        }
        case "thisMonth": {
          let nowDate = dayjsUtils.timeToTZ(new Date());
          nowDate.setMonth(nowDate.getMonth() + 1, 1);
          nowDate.setHours(0, 0, 0, 0);
          let d = new Date(nowDate.getTime() - 1);
          let max =
            d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
          nowDate = dayjsUtils.timeToTZ(new Date());
          nowDate.setDate(1);
          nowDate.setHours(0, 0, 0, 0);
          d = new Date(nowDate.getTime());
          let min =
            d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
          const result = {
            min: BsyUtils.parseDate(min),
            max: BsyUtils.getUpperTimeLimit(max),
          }
          return {
            min: result.min.getTime(),
            max: result.max.getTime(),
          };
        }
        case "lastMonth": {
          let nowDate = dayjsUtils.timeToTZ(new Date());
          nowDate.setDate(1);
          nowDate.setHours(0, 0, 0, 0);
          let d = new Date(nowDate.getTime() - 1);
          let max =
            d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
          nowDate = dayjsUtils.timeToTZ(new Date());
          nowDate.setMonth(nowDate.getMonth() - 1, 1);
          nowDate.setHours(0, 0, 0, 0);
          d = new Date(nowDate.getTime());
          let min =
            d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
          const result = {
            min: BsyUtils.parseDate(min),
            max: BsyUtils.getUpperTimeLimit(max),
          }
          return {
            min: result.min.getTime(),
            max: result.max.getTime(),
          };
        }
        case "tomorrow": {
          let d = dayjsUtils.timeToTZ(new Date());
          d.setHours(23, 59, 59, 999);
          d = new Date(d.getTime() + 1);
          dt = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
          const result = {
            min: BsyUtils.parseDate(dt),
            max: BsyUtils.getUpperTimeLimit(dt),
          }
          return {
            min: result.min.getTime(),
            max: result.max.getTime(),
          };
        }
        case "nextMonth": {
          let nowDate = dayjsUtils.timeToTZ(new Date());
          nowDate.setDate(1);
          nowDate.setHours(0, 0, 0, 0);
          nowDate.setMonth(nowDate.getMonth() + 1, 1);
          let d = new Date(nowDate.getTime());
          let min =
            d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();

          nowDate = dayjsUtils.timeToTZ(new Date());
          nowDate.setMonth(nowDate.getMonth() + 2, 1);
          nowDate.setHours(0, 0, 0, 0);
          d = new Date(nowDate.getTime() - 1);
          let max =
            d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
          const result = {
            min: BsyUtils.parseDate(min),
            max: BsyUtils.getUpperTimeLimit(max),
          }
          return {
            min: result.min.getTime(),
            max: result.max.getTime(),
          };
          break;
        }
        case "nextWeek": {
          let nowThisWeek = dayjsUtils.timeToTZ(new Date()).getDay(); //获取当前周
          let nowDate = dayjsUtils.timeToTZ(new Date()).getTime();
          let d = new Date(nowDate + (7 - nowThisWeek + 1) * 86400000);
          d.setHours(0, 0, 0, 0);
          dt = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();

          d = new Date(nowDate + (7 - nowThisWeek + 7) * 86400000);
          let dt1 =
            d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
          const result = {
            min: BsyUtils.parseDate(dt),
            max: BsyUtils.getUpperTimeLimit(dt1),
          }
          return {
            min: result.min.getTime(),
            max: result.max.getTime(),
          };
        }
        case "thisQuarterly": {
          let dt = {};

          let nowDate = dayjsUtils.timeToTZ(new Date());
          switch (nowDate.getMonth()) {
            case 0:
            case 1:
            case 2:
              dt = {
                min: nowDate.getFullYear() + "-" + "01-01",
                max: nowDate.getFullYear() + "-" + "03-31",
              };
              break;
            case 3:
            case 4:
            case 5:
              dt = {
                min: nowDate.getFullYear() + "-" + "04-01",
                max: nowDate.getFullYear() + "-" + "06-30",
              };
              break;
            case 6:
            case 7:
            case 8:
              dt = {
                min: nowDate.getFullYear() + "-" + "07-01",
                max: nowDate.getFullYear() + "-" + "09-30",
              };
              break;
            case 9:
            case 10:
            case 11:
              dt = {
                min: nowDate.getFullYear() + "-" + "10-01",
                max: nowDate.getFullYear() + "-" + "12-31",
              };
              break;
            default:
          }

          const result = {
            min: BsyUtils.parseDate(dt.min),
            max: BsyUtils.getUpperTimeLimit(dt.max),
          }
          return {
            min: result.min.getTime(),
            max: result.max.getTime(),
          };
        }
        case "lastQuarterly": {
          let dt = {};

          let nowDate = dayjsUtils.timeToTZ(new Date());
          switch (nowDate.getMonth()) {
            case 0:
            case 1:
            case 2:
              nowDate.setFullYear(nowDate.getFullYear() - 1);

              dt = {
                min: nowDate.getFullYear() + "-" + "10-01",
                max: nowDate.getFullYear() + "-" + "12-31",
              };
              break;
            case 3:
            case 4:
            case 5:
              dt = {
                min: nowDate.getFullYear() + "-" + "01-01",
                max: nowDate.getFullYear() + "-" + "03-31",
              };
              break;
            case 6:
            case 7:
            case 8:
              dt = {
                min: nowDate.getFullYear() + "-" + "04-01",
                max: nowDate.getFullYear() + "-" + "06-30",
              };
              break;
            case 9:
            case 10:
            case 11:
              dt = {
                min: nowDate.getFullYear() + "-" + "07-01",
                max: nowDate.getFullYear() + "-" + "09-30",
              };
              break;
            default:
          }

          const result = {
            min: BsyUtils.parseDate(dt.min),
            max: BsyUtils.getUpperTimeLimit(dt.max),
          }
          return {
            min: result.min.getTime(),
            max: result.max.getTime(),
          };
        }
        case "nextQuarterly": {
          let dt = {};

          let nowDate = dayjsUtils.timeToTZ(new Date());
          switch (nowDate.getMonth()) {
            case 0:
            case 1:
            case 2:
              dt = {
                min: nowDate.getFullYear() + "-" + "04-01",
                max: nowDate.getFullYear() + "-" + "06-30",
              };
              break;
            case 3:
            case 4:
            case 5:
              dt = {
                min: nowDate.getFullYear() + "-" + "07-01",
                max: nowDate.getFullYear() + "-" + "09-30",
              };
              break;
            case 6:
            case 7:
            case 8:
              dt = {
                min: nowDate.getFullYear() + "-" + "10-01",
                max: nowDate.getFullYear() + "-" + "12-31",
              };
              break;
            case 9:
            case 10:
            case 11:
              nowDate.setFullYear(nowDate.getFullYear() + 1);
              dt = {
                min: nowDate.getFullYear() + "-" + "01-01",
                max: nowDate.getFullYear() + "-" + "03-31",
              };
              break;
            default:
          }

          const result = {
            min: BsyUtils.parseDate(dt.min),
            max: BsyUtils.getUpperTimeLimit(dt.max),
          }
          return {
            min: result.min.getTime(),
            max: result.max.getTime(),
          };
        }
        case "nextYear": {
          let nowDate = dayjsUtils.timeToTZ(new Date());
          nowDate.setFullYear(nowDate.getFullYear() + 1);
          let dt = {
            min: nowDate.getFullYear() + "-" + "01-01",
            max: nowDate.getFullYear() + "-" + "12-31",
          };
          const result = {
            min: BsyUtils.parseDate(dt.min),
            max: BsyUtils.getUpperTimeLimit(dt.max),
          }
          return {
            min: result.min.getTime(),
            max: result.max.getTime(),
          };
        }
        case "thisYear": {
          let nowDate = dayjsUtils.timeToTZ(new Date());
          let dt = {
            min: nowDate.getFullYear() + "-" + "01-01",
            max: nowDate.getFullYear() + "-" + "12-31",
          };
          const result = {
            min: BsyUtils.parseDate(dt.min),
            max: BsyUtils.getUpperTimeLimit(dt.max),
          }
          return {
            min: result.min.getTime(),
            max: result.max.getTime(),
          };
        }
        case "lastYear": {
          let nowDate = dayjsUtils.timeToTZ(new Date());
          nowDate.setFullYear(nowDate.getFullYear() - 1);
          let dt = {
            min: nowDate.getFullYear() + "-" + "01-01",
            max: nowDate.getFullYear() + "-" + "12-31",
          };
          const result = {
            min: BsyUtils.parseDate(dt.min),
            max: BsyUtils.getUpperTimeLimit(dt.max),
          }
          return {
            min: result.min.getTime(),
            max: result.max.getTime(),
          };
        }
        default: {
          const result = {
            min: BsyUtils.parseDate(dt),
            max: BsyUtils.getUpperTimeLimit(dt),
          }
          return {
            min: result.min.getTime(),
            max: result.max.getTime(),
          };
        }
      }
    }

    switch (get(t, "mode")) {
      case i.PRESET:
        var n = a[get(t, "formula")],
          s = (e = BsyUtils.parseDateFormula(n));
        break;
      case i.CUSTOM:
        s = BsyUtils.parseDateFormula(get(t, "formula[0]"));
        e = BsyUtils.parseDateFormula(get(t, "formula[1]"));
        break;
      default: {
        if (get(t, "method") === "formula") {
          s = BsyUtils.parseDateFormula(get(t, "value[0]"));
          e = BsyUtils.parseDateFormula(get(t, "value[1]"));
        }
      }
    }

    if (BsyUtils.isObjectEmpty(s) && BsyUtils.isObjectEmpty(e)) {
      return {}
    }

    const result = {
      min: s ? s.min : void 0,
      max: e ? e.max : void 0,
    }
    return {
      min: result.min ? dayjsUtils.timeToLocal(result.min).date.getTime() : void 0,
      max: result.max ? dayjsUtils.timeToLocal(result.max).date.getTime() : void 0,
    };
  },
  stringSlice: function (str, len) {
    if (BsyUtils.isObjectEmpty(str)) {
      return "";
    }
    len = len || 15;
    return str.length > len ? str.slice(0, len) + "..." : str;
  },
  getNoEmptyTabs: function (t, e) {
    // console.log('getNoEmptyTabs 1', t, e);
    var i = {};
    BsyUtils.forEach(t, function (t, e) {
      !e.tab || e.hidden || i[e.tab] || (i[e.tab] = !0);
    });
    var a = [];
    BsyUtils.forEach(e, function (t, e) {
      i[e.name] && a.push(e);
    });
    // console.log('getNoEmptyTabs 2', a);
    return a;
  },
  getDateStartOf: function (t, e) {
    if (!BsyUtils.isDate(t)) return null;
    var i = BsyUtils.getDateInfo(t),
      a = BsyConfig().CONST.DATE_FILTER_FORMULA_UNIT;
    switch (e) {
      case a.DAY:
        return new Date(i.year, i.month, i.day, 0, 0, 0, 0);
      case a.WEEK:
        var n = BsyUtils.getWeekStartDate(t);
        return n.setHours(0, 0, 0, 0), n;
      case a.MONTH:
        return new Date(i.year, i.month, 1, 0, 0, 0, 0);
      case a.QUARTER:
        n = 3 * Math.floor(i.month / 3);
        return new Date(i.year, n, 1, 0, 0, 0, 0);
      case a.YEAR:
        return new Date(i.year, 0, 1, 0, 0, 0, 0);
      default:
        return null;
    }
  },
  getDateEndOf: function (t, e) {
    if (!BsyUtils.isDate(t)) return null;
    var i = BsyUtils.getDateInfo(t),
      a = BsyConfig().CONST.DATE_FILTER_FORMULA_UNIT;
    switch (e) {
      case a.DAY:
        return new Date(i.year, i.month, i.day, 23, 59, 59, 999);
      case a.WEEK:
        var n = BsyUtils.getWeekEndDate(t);
        return n.setHours(23, 59, 59, 999), n;
      case a.MONTH:
        var s = BsyUtils.getMonthDays(i.year, i.month);
        return new Date(i.year, i.month, s, 23, 59, 59, 999);
      case a.QUARTER:
        n = 3 * (Math.floor(i.month / 3) + 1) - 1;
        s = BsyUtils.getMonthDays(i.year, n);
        return new Date(i.year, n, s, 23, 59, 59, 999);
      case a.YEAR:
        return new Date(i.year, 11, 31, 23, 59, 59, 999);
      default:
        return null;
    }
  },
  parseDateFormula: function (t) {
    if (!BsyUtils.isString(t)) return {};
    var e = new Date(),
      i = t.match(/^1([dwMQy])$/);
    if (!BsyUtils.isObjectEmpty(i))
      return (
        (a = get(i, "[1]")),
        {
          min: BsyUtils.getDateStartOf(e, a),
          max: BsyUtils.getDateEndOf(e, a),
        }
      );
    if (((i = t.match(/^([+-])(\d+)([dwMQy])$/)), BsyUtils.isObjectEmpty(i)))
      return {};
    var a = get(i, "[3]"),
      t = get(i, "[1]"),
      i = toInteger(get(i, "[2]")),
      i = BsyUtils.getDateByOffset(e, "+" === t ? i : -i, a);
    return i
      ? {
        min: BsyUtils.getDateStartOf(i, a),
        max: BsyUtils.getDateEndOf(i, a),
      }
      : {};
  },
  getDateInfo: function (t) {
    t = BsyUtils.parseDate(t) || new Date();
    return {
      year: t.getFullYear(),
      month: t.getMonth(),
      day: t.getDate(),
      hour: t.getHours(),
      minute: t.getMinutes(),
      second: t.getSeconds(),
      millisecond: t.getMilliseconds(),
    };
  },
  getAddressObject: function (a) {
    if (BsyUtils.isString(a)) {
      try {
        a = JSON.parse(a);
        if (a && a.hasOwnProperty("province")) {
        } else {
          a = null;
        }
        return a;
      } catch (e) {
        a = null;
      }
    } else {
      if (a && a.hasOwnProperty("province")) {
      } else {
        a = null;
      }
    }
    return a;
  },
  forEach: (a, b) => {
    if (Array.isArray(a))
      for (
        let c = 0, d = a.length;
        c < d && b.apply(a[c], [c, a[c]]) !== !1;
        c++
      );
    else if (a && "object" == typeof a)
      for (let e in a)
        if (a.hasOwnProperty(e) && b.apply(a[e], [e, a[e]]) === !1) break;
  },
  parseMm2Pt: function (t) {
    return parseFloat(((t / 25.4) * BsyConfig().CONST.PRINT_DPI).toFixed(2));
  },
  parsePt2Mm: function (t) {
    return parseFloat(((t / BsyConfig().CONST.PRINT_DPI) * 25.4).toFixed(2));
  },
  hasImage: function (file) {
    if (file.mime) {
      return file.mime.indexOf("image") > -1;
    }
    return /(.png|.jpg|.jpeg|.gif)$/i.test(file.name);
  },
  makeArray: function (arr, results) {
    var ret = results || []; // 如果没有提供 results 参数，则初始化为空数组

    if (arr != null) {
      if (BsyUtils.isArrayLike(Object(arr))) {
        // 使用 Array.prototype.push.apply 是为了兼容旧环境，
        // 在 ES6+ 可以使用 ret.push(...arr);
        Array.prototype.push.apply(ret, typeof arr === "string" ? [arr] : arr);
      } else {
        // 对于非类数组对象，直接添加至 ret 数组
        ret.push(arr);
      }
    }

    return ret;
  },
  hasTokenEdit: function (appid) {
    const key = `bby_e_${appid}`;
    // const value = React.cookie.load(key);
    // console.log(`hasTokenEdit: ${key}, ${value}`);
    return React.cookie.load(key) ? true : false;
  },
  // 辅助函数，判断对象是否是类数组
  isArrayLike: function (obj) {
    var length = !!obj && "length" in obj && obj.length;
    var type = typeof obj;
    if (type === "function" || obj === window) {
      return false;
    }
    return (
      type === "array" ||
      length === 0 ||
      (typeof length === "number" && length > 0 && length - 1 in obj)
    );
  },
  //创建24位长度的ID
  Ids24: function () {
    return BsyFormula.MD5(
      (window.FX.STATIC.user
        ? window.FX.STATIC.user.corpId + window.FX.STATIC.user._id
        : "") +
      "subform" +
      window.FX.STATIC.IDBase++
    )
      .substr(0, 24);
  },
  isValueWidget: function (a) {
    return !!BsyConfig().ValueWidgets[a];
  },
  isFilterWidgets: function (a) {
    return !!BsyConfig().FilterWidgets[a];
  },
  issetValueWidgets: function (a) {
    return !!BsyConfig().setValueWidgets[a];
  },
  doPrint: function (b, c) {
    document.querySelectorAll("body > div").forEach((div) => {
      div.classList.add("bsy-ui-notprint");
    });
    document.querySelector("#bsy-printer")?.remove?.();
    const d = document.createElement("div");
    d.id = "bsy-printer";
    document.body.appendChild(d);

    ReactDOM.render(b, d);
    c = BsyUtils.isNull(c) ? 0 : c;
    setTimeout(function () {
      window.print();
    }, c);
  },
  cancelPrint: function () {
    document
      .querySelector(".bsy-ui-notprint")
      ?.classList?.remove?.("bsy-ui-notprint");
    document.querySelector("#bsy-printer")?.remove?.();
  },
  _formatDate: (a) => {
    var b = new Date(a),
      c = new Date(),
      d = (c - b) / 6e4,
      e = d / 60,
      f = parseInt(e / 24);
    return (
      (e = parseInt(e)),
      (d = parseInt(d)),
      f > 3
        ? BsyUtils.date2Str(b, "yyyy-MM-dd HH:mm:ss")
        : f > 0
          ? React.language("date.ago.day", { value: f })
          : e > 0
            ? React.language("date.ago.hours", { value: e })
            : d > 0
              ? d + React.language("minute.ago")
              : React.language("date.just")
    );
  },

  _checkLoadDataConfig: function (loaddataconfig) {
    if (BsyUtils.isObjectEmpty(loaddataconfig)) {
      tipAlert({
        type: "warning",
        msg: React.language("subform.data.load.tip"),
      });
      return !1;
    }

    if (BsyUtils.isObjectEmpty(loaddataconfig.mapFields)) {
      tipAlert({
        type: "warning",
        msg: React.language("subform.data.load.tip3"),
      });
      return !1;
    }
    if (loaddataconfig.mode !== "tree") {
      if (BsyUtils.isObjectEmpty(loaddataconfig.fields)) {
        tipAlert({
          type: "warning",
          msg: React.language("subform.data.load.tip4"),
        });
        return !1;
      }
    } else {
      if (BsyUtils.isObjectEmpty(loaddataconfig.treeFields)) {
        tipAlert({
          type: "warning",
          msg: React.language("subform.data.load.tip38"),
        });
        return !1;
      }
      if (BsyUtils.isObjectEmpty(loaddataconfig.treeFields.treeTitle)) {
        tipAlert({
          type: "warning",
          msg: React.language("subform.data.load.tip39"),
        });
        return !1;
      }
      if (BsyUtils.isObjectEmpty(loaddataconfig.treeFields.treeNode)) {
        tipAlert({
          type: "warning",
          msg: React.language("subform.data.load.tip40"),
        });
        return !1;
      }
      if (BsyUtils.isObjectEmpty(loaddataconfig.treeFields.treeParentNode)) {
        tipAlert({
          type: "warning",
          msg: React.language("subform.data.load.tip41"),
        });
        return !1;
      }
      if (BsyUtils.isObjectEmpty(loaddataconfig.treeFields.treeRootNode)) {
        tipAlert({
          type: "warning",
          msg: React.language("subform.data.load.tip42"),
        });
        return !1;
      }
    }

    return !0;
  },
  globalIdManager: function (appid, entryid, dataid, innerlink) {
    let bakappId = window.FX.STATIC.APPID;
    let bakentryId = window.FX.STATIC.ENTRYID;
    let bakdataId = window.FX.STATIC.DATAID;
    let bakinnerlink = window.FX.STATIC.INNERLINK;
    window.FX.STATIC.appId = window.FX.STATIC.APPID = appid;
    window.FX.STATIC.entryId = window.FX.STATIC.ENTRYID = entryid;
    window.FX.STATIC.DATAID = dataid;
    window.FX.STATIC.INNERLINK = innerlink;

    function restore() {
      window.FX.STATIC.appId = window.FX.STATIC.APPID = bakappId;
      window.FX.STATIC.entryId = window.FX.STATIC.ENTRYID = bakentryId;
      window.FX.STATIC.DATAID = bakdataId;
      window.FX.STATIC.INNERLINK = bakinnerlink;
    }
    return { restore };
  },
  getFieldAttr: function (b, c, mode) {
    if (mode) {
      if (b.widget.type === "button") {
        //处理表单数据管理使用需要使用
        return {
          id: b.formId,
          text: b.label,
          btnText: b.widget.text,
          name: b.widget.widgetName,
          background: b.widget.background,
          eventAlert: b.widget.eventAlert,
          alertinfo: b.widget.alertinfo,
          type: b.widget.type,
          regex: b.widget.regex,
          tab: b.tab,
        };
      }
      if (b.widget.type === "linkquery") {
        //处理表单数据管理使用需要使用
        return {
          id: b.formId,
          text: b.label,
          name: b.widget.widgetName,
          type: b.widget.type,
          regex: b.widget.regex,
          tab: b.tab,
          linkForm: b.widget.linkForm,
          linkFields: b.widget.linkFields,
          linkType: b.widget.linkType,
          linkKey: b.widget.linkKey,
          refAppId: b.widget.refAppId,
          showType: b.widget.showType,
          showMode: b.widget.showMode,
        };
      }
      if (b.widget.type === "separator") {
        //处理表单数据管理使用需要使用
        return {
          id: b.formId,
          text: b.label,
          labelHidden: b.labelHidden,
          name: b.widget.widgetName,
          type: b.widget.type,
          tab: b.tab,
          lineStyle: b.widget.lineStyle,
          labelColor: b.widget.labelColor,
          lineColor: b.widget.lineColor,
        };
      }
    }

    if (!BsyUtils.isValueWidget(b.widget.type)) return null;
    if (c && c.indexOf(b.widget.type) < 0) return null;
    let d = {
      id: b.formId,
      text: b.label,
      name: b.widget.widgetName,
      type: b.widget.type,
      regex: b.widget.regex,
      tab: b.tab,
    };
    switch (b.widget.type) {
      case "subform":
        let e = [];
        BsyUtils.forEach(b.widget.items, function (d, f) {
          f = {
            ...f,
            ...{
              formId: b.formId,
            },
          };
          let g = BsyUtils.getFieldAttr(f, c, mode);
          if (g) {
            g = {
              ...g,
              ...{
                subform: b.widget.widgetName,
              },
            };

            e.push(g);
          }
        });
        d = {
          ...d,
          ...{
            items: e,
          },
        };
        break;
      case "linkquery":
      case "linkdata":
        d = {
          ...d,
          ...{
            linkForm: b.widget.linkForm,
            linkFields: b.widget.linkFields,
            linkType: b.widget.linkType,
            linkKey: b.widget.linkKey,
            refAppId: b.widget.refAppId,
            showType: b.widget.showType,
            showMode: b.widget.showMode,
          },
        };
        break;
      case "combo":
      case "combocheck":
      case "radiogroup":
      case "checkboxgroup":
        d = {
          ...d,
          ...{
            async: b.widget.async,
            colorEnable: b.widget.colorEnable,
            items: b.widget.items,
          },
        };
        break;
      case "address":
        d = {
          ...d,
          ...{
            format: b.widget.format
              ? b.widget.format
              : !b.widget.needDetail
                ? "pcd"
                : "pcda",
          },
        };
        break;
      case "number": {
        d = {
          ...d,
          ...{
            format: b.widget.format,
            displayMode: b.widget.displayMode, //格式模式
            precision: b.widget.precision, //nuu 关闭小数位模式 最多保留4位
            thousandsSeparator: b.widget.thousandsSeparator, //千分符
            notround: b.widget.notround,
            afterSuffix: b.widget.afterSuffix,
          },
        };
        break;
      }
      case "datetime":
        d = {
          ...d,
          ...{
            format: b.widget.format,
          },
        };
        break;
      default:
    }
    return d;
  },
  createEntryAttributeField: function (b, c) {
    let d = {
      id: c.entryId,
    };
    switch (b) {
      case "label":
        d = {
          ...d,
          ...{
            name: "label",
            type: "textarea",
            text: React.language("label"),
          },
        };
        break;
      case "ext":
        d = {
          ...d,
          ...{
            name: "ext",
            type: "text",
            text: React.language("field.ext"),
            items: c.extParams,
          },
        };
        break;
      case "_id":
        d = {
          ...d,
          ...{
            name: "_id",
            type: "text",
            text: React.language("data.id"),
          },
        };
        break;
      case "createTime":
        d = {
          ...d,
          ...{
            name: "createTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            text: React.language("field.createTime"),
          },
        };
        break;
      case "updateTime":
        d = {
          ...d,
          ...{
            name: "updateTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            text: React.language("field.updateTime"),
          },
        };
        break;
      case "creator":
        d = {
          ...d,
          ...{
            name: "creator",
            type: "user",
            text: React.language("field.creator"),
          },
        };
        break;
      case "flowState":
        d = {
          ...d,
          ...{
            name: "flowState",
            type: "flowstate",
            text: React.language("field.flowState"),
          },
        };
        break;
      case "flowdecision":
        d = {
          ...d,
          ...{
            name: "flowDecision",
            type: "flowdecision",
            text: React.language("process.decision"),
          },
        };
        break;
      case "chargers":
        d = {
          ...d,
          ...{
            name: "chargers",
            type: "chargers",
            text: React.language("field.chargers"),
          },
        };
        break;
      case "deleter":
        d = {
          ...d,
          ...{
            name: "deleter",
            type: "user",
            text: React.language("field.deleter"),
          },
        };
        break;
      case "deleteTime":
        d = {
          ...d,
          ...{
            name: "deleteTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            text: React.language("field.deleteTime"),
          },
        };
        break;
      default:
        return null;
    }
    return d;
  },
  getRandomCode: (t, e) => {
    let a = "";
    let i =
      e || "1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    for (t > 0; t--;) {
      a += i[Math.floor(Math.random() * i.length)];
    }
    return a;
  },
  _genFormEventId: () => {
    return (
      new Date().getTime().toString(36) +
      BsyUtils.getRandomCode(8, "1234567890abcdefghijklmnopqrstuvwxyz")
    );
  },
  transformDataSourceRow: (header, data) => {
    if (!header) return data;

    switch (header.type) {
      case "usergroup":
      case "deptgroup":
        let name = "";
        let names = [];
        if (data && data.length > 0) {
          data.map((res) => {
            if (res) {
              names.push(BsyUtils._toDeptUser(res, header.type));
            }
          });
          name = BsyUtils.escapeHtmlSpecialChar(names.join("、"));
        }
        return name;
      case "user":
      case "dept":
        return BsyUtils._toDeptUser(data, header.type);
      case "image":
      case "signature":
      case "upload":
        return JSON.stringify(data);

      case "linkdata": {
        if (header.linkType === "number") {
          let d = data ? data.key : "";
          let res = BsyUtils.numberFormatValue(d, header);
          return res.text;
        }
        return data ? data.key : "";
      }
      case "datetime":
        if (data)
          return BsyUtils.date2Str(dayjsUtils.timeToTZ(data), header.format);
        return "";
      case "number":
        if (data) {
          let res = {
            value: "",
            text: "",
          };
          if (["assist_protime", "assist_outtime"].includes(header.name)) {
            res = BsyUtils.numberFormatTime(data, header);
          } else {
            res = BsyUtils.numberFormatValue(data, header);

            const afterSuffixVal = getAfterSuffix(header.afterSuffix)
            if (afterSuffixVal && res.text && !res.text.includes("%")) {
              res.text = res.text + " " +afterSuffixVal;
            }
          }
          return res.text;
        }
        // return BsyUtils.num2Str(BsyUtils.fixDecimalPrecision(data), header.format)
        return "";
      case "address":
      case "location": {
        return BsyUtils.address2Str(data, header.format || "pcda");
      }
      case "flowState": {
        return BsyUtils._getFlowState(data);
      }
      case "checkboxgroup":
      case "combocheck":
      case "array":
        return data;
      case "chargers":
        let m = {},
          n = {};
        BsyUtils.forEach(data, function (a, b) {
          if (b.flowName) {
            m[b.flowName] || (m[b.flowName] = !0);
            n[b.userNickname] || (n[b.userNickname] = !0);
          }
        });

        let outdata = {
          currentnode: [],
          currentcharger: [],
        };
        BsyUtils.forEach(m, function (a) {
          outdata.currentnode.push(a);
        });
        BsyUtils.forEach(n, function (a) {
          outdata.currentcharger.push(a);
        });
        return outdata;
      default:
        return data;
    }
  },
  _widget_dash_filter: function (b) {
    let map = {
      text: "text_filter",
      sn: "text_filter",
      radiogroup: "text_filter",
      combo: "text_filter",
      number: "number_filter",
      textarea: "textarea_filter",
      checkboxgroup: "combocheck_filter",
      combocheck: "combocheck_filter",
      address: "address_filter",
      location: "address_filter",
      image: "filelist_filter",
      upload: "filelist_filter",
      signature: "filelist_filter",
      user: "user_filter",
      usergroup: "usergroup_filter",
      dept: "dept_filter",
      deptgroup: "deptgroup_filter",
      datetime: "date_filter",
      flownode: "flownode_filter",
      backflowid: "backflowid_filter",
      flowcreator: "flowcreator_filter",
      flowState: "flowstate_filter",
      flowstate: "flowstate_filter",
      filter_flowstate: "flowstate_filter",
      flowdecision: "flowdecision_filter",
      flowDecision: "flowdecision_filter",
      flow_chargers: "flow_chargers_filter",
      assist_flowid: "assist_flowid_filter",
      assist_prostatus: "assist_prostatus_filter",
      ticknumber: "ticknumber_filter",
    };
    return map[b] || b;
  },
  injectStylesIntoIframe: function (iframe, styles) {
    if (iframe.contentDocument) {
      const styleElement = iframe.contentDocument.createElement("style");
      styleElement.type = "text/css";
      styleElement.appendChild(iframe.contentDocument.createTextNode(styles));
      iframe.contentDocument.head.appendChild(styleElement);
    }
  },
  _filter_dash_widget: function (b) {
    let map = {
      text_filter: ["text", "sn", "radiogroup", "combo"],
      number_filter: ["number"],
      textarea_filter: ["textarea"],
      combocheck_filter: ["checkboxgroup", "combocheck"],
      address_filter: ["address", "location"],
      filelist_filter: ["image", "upload", "signature"],
      user_filter: ["user"],
      dept_filter: ["dept"],
      usergroup_filter: ["usergroup"],
      deptgroup_filter: ["deptgroup"],
      date_filter: ["datetime"],
      datetime_filter: ["datetime"],
      datemonth_filter: ["datetime"],
      dateyear_filter: ["datetime"],
    };
    return map[b] || b;
  },
  _filter_widget: function (b) {
    let map = {
      text: "text",
      sn: "text",
      radiogroup: "text",
      combo: "text",
      number: "number",
      textarea: "textarea",
      checkboxgroup: "combocheck",
      combocheck: "combocheck",
      address: "address",
      location: "address",
      user: "user",
      dept: "dept",
      usergroup: "usergroup",
      deptgroup: "deptgroup",
      datetime: "datetime",
      image: "file_list",
      upload: "file_list",
      signature: "signature",
      flowstate: "flowstate",
      flowState: "flowstate",
    };
    return map[b] || b;
  },
  pick: function (a, b) {
    let c = {};
    BsyUtils.forEach(b, function (b, d) {
      d in a && (c[d] = a[d]);
    });
    return c;
  },
  isString: (a) => {
    return "string" == typeof a;
  },
  toType: (obj) => {
    if (obj == null) {
      return obj + "";
    }
    if (!window.class2type) {
      window.class2type = {};
      let d =
        "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
          " "
        );
      for (let i = 0; i < d.length; i++) {
        window.class2type["[object " + d[i] + "]"] = d[i].toLowerCase();
      }
    }

    // Support: Android <=2.3 only (functionish RegExp)
    return typeof obj === "object" || typeof obj === "function"
      ? window.class2type[toString.call(obj)] || "object"
      : typeof obj;
  },
  isNumber: (obj) => {
    let type = BsyUtils.toType(obj);
    return (
      (type === "number" || type === "string") &&
      // parseFloat NaNs numeric-cast false positives ("")
      // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
      // subtraction forces infinities to NaN
      !isNaN(obj - parseFloat(obj))
    );
  },
  compareOp: function (t, e) {
    if (_.isNil(t) || "" === t) return !1;
    var r = /^(>=|<=|<|>|==|!=)(.*)/.exec(_.trim(e));
    if (r) {
      var n = BsyUtils._slicedToArray(r, 3),
        o = n[1],
        i = n[2],
        a = _.trim(i);
      return BsyFormulaCalcParser.evalExpression(
        o,
        t,
        BsyUtils.isNumber(a) ? BsyUtils.parseNumber(a) : a
      );
    }
    return t == e;
  },
  getDaysWithForward: function (t) {
    var e = t.startDay,
      r = t.startWeekNo,
      n = t.workdays,
      o = t.holidays,
      i = t.timezone,
      a = BsyUtils.getDaysByWorkdays(r, n),
      s = e + a,
      c = ((r - 1 + ((s - e) % 7)) % 7) + 1,
      u = 0,
      l = BsyUtils.getFormatHolidays(o, !0, i);
    _.map(l, function (t) {
      var r = BsyUtils.getDays(t);
      if (r > e && r <= s) {
        var n = dayjsUtils.getDay(t);
        if (6 !== n && 0 !== n)
          do {
            u++;
            s++;
            c = (c + 1) % 7;
          } while (6 === c || 0 === c);
      }
    });
    return a + u;
  },
  getDaysWithBackwards: function (t) {
    var e = t.endDay,
      r = t.endWeekNo,
      n = t.workdays,
      o = t.holidays,
      i = t.timezone,
      a = BsyUtils.getDaysByWorkdays(6 - r, -n),
      s = e - a,
      c = ((r - 1 - (a % 7) + 7) % 7) + 1,
      u = 0,
      l = BsyUtils.getFormatHolidays(o, !1, i);
    _.map(l, function (t) {
      var r = BsyUtils.getDays(t);
      if (r >= s && r < e) {
        var n = dayjsUtils.getDay(t);
        if (6 !== n && 0 !== n)
          do {
            u++;
            s--;
            c = (c - 1 + 7) % 7;
          } while (6 === c || 0 === c);
      }
    });
    return -a - u;
  },
  getSysTimeZone: function (t) {
    if (window.localDevInfo.user_corps.timezone &&
      window.localDevInfo.user_corps.timezone.value !== "default") {
      return window.localDevInfo.user_corps.timezone.utc[0];
    }
    return "";
  },
  getSysTimeZoneOffset: function (t) {
    if (window.localDevInfo.user_corps.timezone &&
      window.localDevInfo.user_corps.timezone.value !== "default") {
      return window.localDevInfo.user_corps.timezone.offset;
    }
    return "";
  },
  filterDate: function (t) {
    //Intl.DateTimeFormat().resolvedOptions().timeZone
    const tz = BsyUtils.getSysTimeZone();
    return tz ? dayjs(t).tz(tz) : dayjs(t);
  },
  getDays: function (t) {
    return Math.floor(dayjsUtils.valueOf(dayjsUtils.startOf(t, "day")) / 864e5);
  },
  getFormatHolidays: function (t) {
    var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
      r = arguments.length > 2 ? arguments[2] : void 0,
      n = [];
    _.map(t, function (t) {
      var e = BsyUtils.filterDate(t, r)
      _.isNil(e) || n.push(e);
    });

    n = _.sortBy(n, function (t, r) {
      return dayjsUtils.isBefore(t, r) ? (e ? -1 : 1) : e ? 1 : -1;
    });

    // n.sort((t,r)=>{
    //     return dayjsUtils.isBefore(t, r) ? e ? -1 : 1 : e ? 1 : -1
    // })

    // _sortInstanceProperty(n).call(n, (function(t, r) {
    //     return dayjsUtils.isBefore(t, r) ? e ? -1 : 1 : e ? 1 : -1
    // }
    // ));
    return n;
  },
  getDaysByWorkdays: function (t, e) {
    var r = 0;
    if (6 === t) {
      t = 5;
      r = -1;
    }
    // 6 === t && (t = 5, r = -1);
    var n = Math.floor((t - 1 + e) / 5);
    return (
      0 === n ? (r += e) : ((r += 7 * n - t + 1), (r += (t - 1 + e) % 5)), r
    );
  },
  _slicedToArray: function (arr, i) {
    var _arr = [];
    for (
      var _iterator = arr[Symbol.iterator](), _step;
      !(_step = _iterator.next()).done;

    ) {
      _arr.push(_step.value);
      if (_arr.length === i) break;
    }
    return _arr;
  },
  isFunction: (b) => {
    return typeof b === "function";
  },
  hexToRGBAStr: (t, e) => {
    if (t.toUpperCase(t).indexOf("RGBA") > -1) return t;
    if (1 === e || BsyUtils.isEmpty(e)) return t;
    t = BsyUtils.hexToRgbJson(t);
    return "rgba(" + t.r + "," + t.g + "," + t.b + "," + e + ")";
  },
  hexToRGBStr: (t, e) => {
    if (t.toUpperCase(t).indexOf("RGBA") > -1) return t;
    if (1 === e || BsyUtils.isEmpty(e)) return t;
    t = BsyUtils.hexToRgbJson(t);
    return BsyUtils.rgbaToRGB(t.r, t.g, t.b, e);
  },
  hsbToRgb: (a) => {
    let b, d, e;
    b = a.h;
    let c = (255 * a.s) / 100;
    a = (255 * a.b) / 100;
    if (0 === c) b = d = e = a;
    else {
      c = ((255 - c) * a) / 255;
      let f = ((b % 60) * (a - c)) / 60;
      360 === b && (b = 0);

      if (60 > b) {
        b = a;
        e = c;
        d = c + f;
      } else {
        if (120 > b) {
          d = a;
          e = c;
          b = a - f;
        } else {
          if (180 > b) {
            d = a;
            b = c;
            e = c + f;
          } else {
            if (240 > b) {
              e = a;
              b = c;
              d = a - f;
            } else {
              if (300 > b) {
                e = a;
                d = c;
                b = c + f;
              } else {
                if (360 > b) {
                  b = a;
                  d = c;
                  e = a - f;
                } else {
                  e = d = b = 0;
                }
              }
            }
          }
        }
      }

      // 60 > b ? (b = a,
      //     e = c,
      //     d = c + f) : 120 > b ? (d = a,
      //     e = c,
      //     b = a - f) : 180 > b ? (d = a,
      //     b = c,
      //     e = c + f) : 240 > b ? (e = a,
      //     b = c,
      //     d = a - f) : 300 > b ? (e = a,
      //     d = c,
      //     b = c + f) : 360 > b ? (b = a,
      //     d = c,
      //     e = a - f) : e = d = b = 0
    }
    return (
      "RGB(" + Math.round(b) + "," + Math.round(d) + "," + Math.round(e) + ")"
    );

    // {
    //     r: Math.round(b),
    //     g: Math.round(d),
    //     b: Math.round(e)
    // }
  },
  rgbToHsb: function (a, h1, s1, b1) {
    console.log("---rgbToHsb---");
    h1 = h1 || 1;
    s1 = s1 || 1;
    b1 = b1 || 1;
    a = BsyUtils.hexToRgbJson(a);
    let b = {
      h: 0,
      s: 0,
      b: 0,
    },
      d = Math.min(a.r, a.g, a.b),
      e = Math.max(a.r, a.g, a.b),
      c = e - d;
    b.b = e;
    b.s = 0 != e ? (255 * c) / e : 0;
    b.h =
      0 != b.s
        ? a.r == e
          ? (a.g - a.b) / c
          : a.g == e
            ? 2 + (a.b - a.r) / c
            : 4 + (a.r - a.g) / c
        : -1;
    if (e == d) b.h = 0;
    // e == d && (b.h = 0);
    b.h *= 60;
    0 > b.h && (b.h += 360);
    b.s *= 100 / 255;
    b.b *= 100 / 255;
    return (b = {
      h: Math.round(b.h * h1),
      s: Math.round(b.s * s1),
      b: Math.round(b.b * b1),
    });
  },
  hexTohslaStr: (t, e) => {
    if (t.toUpperCase(t).indexOf("RGBA") > -1) return t;
    if (1 === e || BsyUtils.isEmpty(e)) return t;
    t = BsyUtils.hexToRgbJson(t);
    return "rgb(" + t.r + "," + t.g + "," + t.b * e + ")";
  },

  //添加 style 元素节点
  appendStyle: (stylestr) => {
    // let style="<style id='dddd'>.cc{color:red;}</style>";
    let ele = document.createElement("div");
    ele.innerHTML = stylestr;
    document.getElementsByTagName("head")[0].appendChild(ele.firstElementChild);
  },
  getDashQuotaSortFields: (t) => {
    let e = [];
    BsyUtils.forEach(t, function (t, i) {
      BsyUtils.isEmpty(i.growth) && e.push(i);
    });
    return e;
  },
  getFieldInfoByFormula: function (t) {
    let e = {},
      i = (t + "").match(/(\$[0-9a-zA-Z\._]+)(#[0-9a-f]+)?(@[0-9a-f]+)?/),
      a = ["", "field", "entryId", "appId"];
    BsyUtils.forEach(i, function (t, i) {
      0 !== t && i && (e[a[t]] = i.substr(1));
    });
    return e;
  },
  getFieldInfoById: function (t) {
    let e = {},
      i = (t = "#" + t).match(/(#[0-9a-f]+)(@[0-9a-f]+)?/),
      a = ["", "entryId", "appId"];
    BsyUtils.forEach(i, function (t, i) {
      0 !== t && i && (e[a[t]] = i.substr(1));
    });
    return e;
  },
  dealFilterInfoByField: function (e) {
    let i = BsyUtils.getFieldInfoById(e.id),
      a = BsyUtils.dealFilterFieldName(e);
    return {
      ...i,
      ...a,
    };
  },
  getFlowStateText: (t) => {
    if (!Array.isArray(t)) {
      t = [t];
    }
    let e = {};
    e[BsyConfig().CONST.WORKFLOW.FLOWSTATE.INPROCESS] = React.language(
      "flow.state.inProcess"
    );
    e[BsyConfig().CONST.WORKFLOW.FLOWSTATE.COMPLETE] =
      React.language("flow.node.end");
    e[BsyConfig().CONST.WORKFLOW.FLOWSTATE.CLOSE] =
      React.language("flow.state.closed");
    let i = [];
    BsyUtils.forEach(t, function (t, a) {
      a = parseInt(a, 10);
      e[a] && i.push(e[a]);
    });
    return i.join("、");
  },
  getFlowDecisionText: (t) => {
    if (!Array.isArray(t)) {
      if (t && t.text) {
        return t.text;
      }
      if (t && t.state_id) {
        return t.state;
      }
      t = [t];
    }
    let e = {};
    e[0] = React.language("filter.method.ep");
    e[1] = React.language("approved");
    e[2] = React.language("approval.rejected");
    let i = [];
    BsyUtils.forEach(t, function (t, a) {
      a = parseInt(a, 10);
      e[a] && i.push(e[a]);
    });
    return i.join("、");
  },
  getAnglePos: (angle) => {
    let type = "top";
    if (angle == 0) {
      type = "top";
    } else if (angle > 0 && angle < 90) {
      type = "righttop";
    } else if (angle == 90) {
      type = "right";
    } else if (angle > 90 && angle < 180) {
      type = "rightbottom";
    } else if (angle == 180) {
      type = "bottom";
    } else if (angle > 180 && angle < 270) {
      type = "leftbottom";
    } else if (angle == 270) {
      type = "left";
    } else if (angle > 270 && angle < 360) {
      type = "lefttop";
    }
    return type;
  },
  _trim: function (str) {
    return str.replace(/^\s+|\s+$/g, "");
  },
  dealFilterFieldName: function (t) {
    let e = {};
    if (/\./.test(t.name)) {
      let i = t.name.split(".");
      e.subform = i[0];
      e.subField = i[1];
    } else e.field = t.name;
    return e;
  },

  getLinkFilter: (e, i) => {
    let a = {
      type: e.type,
    };
    a = { ...a, ...BsyUtils.dealFilterFieldName(e) };
    switch (e.type) {
      case "datetime":
        a.method = BsyConfig().CONST.FILTER_METHOD.RG;
        a.value = i;
        break;
      case "address":
      case "location":
        a.type = "address";
        a.method = BsyConfig().CONST.FILTER_METHOD.ALL;
        a.value = i;
        break;
      case "deptgroup":
      case "usergroup": {
        a.type = e.type;
        a.method = BsyConfig().CONST.FILTER_METHOD.IN;
        a.value = BsyUtils.makeArray(i);
        break;
      }
      case "user":
      case "id":
        a.type = "user";
        a.method = BsyConfig().CONST.FILTER_METHOD.IN;
        a.value = [i];
        break;
      case "dept":
      case "did":
        a.type = "dept";
        a.method = BsyConfig().CONST.FILTER_METHOD.IN;
        a.value = BsyUtils.makeArray(i);
        break;
      case "number":
        a.method = BsyConfig().CONST.FILTER_METHOD.EQ;
        a.value = BsyUtils.makeArray(i);
        break;
      case "linkdata":
        if ("number" === e.linkType) {
          a.keyType = "number";
          a.method = BsyConfig().CONST.FILTER_METHOD.EQ;
        } else {
          a.keyType = "text";
          a.method = BsyConfig().CONST.FILTER_METHOD.IN;
        }
        a.value = BsyUtils.makeArray(i);

        // "number" === e.linkType ? (a.keyType = "number",
        //     a.method = BsyConfig().CONST.FILTER_METHOD.EQ) : (a.keyType = "text",
        //     a.method = BsyConfig().CONST.FILTER_METHOD.IN),
        //     a.value = $.makeArray(i);
        break;
      case "flowState":
        a.type = "flowstate";
        a.method = BsyConfig().CONST.FILTER_METHOD.IN;
        a.value = BsyUtils.makeArray(i);
        break;
      case "combocheck":
      case "checkboxgroup":
        a.type = "combocheck";
        a.method = BsyConfig().CONST.FILTER_METHOD.IN;
        a.value = BsyUtils.makeArray(i);
        break;
      case "assist_flowid": {
        a.type = "assist_flowid";
        a.method = BsyConfig().CONST.FILTER_METHOD.IN;
        a.value = BsyUtils.makeArray(i);
        break;
      }
      default:
        if ("creator" === e.name) {
          a.type = "user";
          a.method = BsyConfig().CONST.FILTER_METHOD.IN;
          a.value = BsyUtils.makeArray(i);
        } else {
          a.type = "text";
          a.method = BsyConfig().CONST.FILTER_METHOD.IN;
          a.value = BsyUtils.makeArray(i);
        }

      // "creator" === e.name ? (a.type = "user",
      //     a.method = BsyConfig().CONST.FILTER_METHOD.IN,
      //     a.value = $.makeArray(i)) : (a.type = "text",
      //     a.method = BsyConfig().CONST.FILTER_METHOD.IN,
      //     a.value = $.makeArray(i))
    }
    return a;
  },
  getArrayFromRange: (t, e) => {
    let i = [];
    switch (e) {
      case "number":
        i.push(BsyUtils.isNull(t.min) ? null : t.min);
        i.push(BsyUtils.isNull(t.max) ? null : t.max);
        break;
      case "address":
        i.push(t.province || null);
        i.push(t.city || null);
        i.push(t.district || null);
        break;
      case "datetime":
        i.push(t.min ? BsyUtils.date2Str(new Date(t.min), "yyyy-MM-dd") : null);
        i.push(t.max ? BsyUtils.date2Str(new Date(t.max), "yyyy-MM-dd") : null);
        break;
      default:
    }
    return i;
  },
  getDateRange: (t) => {
    let e = "yyyy-MM-dd";
    let i = new Date();
    let a = [];
    if (BsyUtils.isNull(t.day))
      if (BsyUtils.isNull(t.week)) {
        if (BsyUtils.isNull(t.month)) {
          if (BsyUtils.isNull(t.quarter)) {
            i.setFullYear(t.year, 0, 1);
            a.push(BsyUtils.date2Str(i, e));
            i.setFullYear(t.year + 1, 0, 1);
            i.setHours(0, 0, 0, 0);
            a.push(BsyUtils.date2Str(new Date(i.getTime() - 1), e));
          } else {
            i.setFullYear(t.year, 3 * (t.quarter - 1), 1);
            a.push(BsyUtils.date2Str(i, e));
            i.setFullYear(t.year, 3 * t.quarter, 1);
            i.setHours(0, 0, 0, 0);
            a.push(BsyUtils.date2Str(new Date(i.getTime() - 1), e));
          }
        } else {
          i.setFullYear(t.year, t.month - 1, 1);
          a.push(BsyUtils.date2Str(i, e));
          i.setFullYear(t.year, t.month, 1);
          i.setHours(0, 0, 0, 0);
          a.push(BsyUtils.date2Str(new Date(i.getTime() - 1), e));
        }
      } else {
        i.setFullYear(t.year, 0, 1);
        let n = i.getDay() || 7,
          s = n <= 4 ? 1 - n : 7 - n + 1;
        i.setTime(i.getTime() + 864e5 * (s + 7 * (t.week - 1)));
        a.push(BsyUtils.date2Str(i, e));
        i.setTime(i.getTime() + 6048e5);
        i.setHours(0, 0, 0, 0);
        a.push(BsyUtils.date2Str(new Date(i.getTime() - 1), e));
      }
    else {
      i.setFullYear(t.year, t.month - 1, t.day);
      let o = BsyUtils.date2Str(i, e);
      a = [o, o];
    }
    return a;
  },
  parsePercent2: (percent, all) => {
    switch (percent) {
      case "center":
      case "middle":
        percent = "50%";
        break;
      case "left":
      case "top":
        percent = "0%";
        break;
      case "right":
      case "bottom":
        percent = "100%";
        break;
      default: {
        break;
      }
    }
    if (typeof percent === "string") {
      if (BsyUtils._trim(percent).match(/%$/)) {
        return (parseFloat(percent) / 100) * all;
      }
      return parseFloat(percent);
    }
    return percent == null ? NaN : +percent;
  },
  getDashSortFields: function (t) {
    let e = [],
      i = ["checkboxgroup", "combocheck"].concat(
        BsyConfig().LimitFields.dashSort
      );
    BsyUtils.forEach(t, function (t, a) {
      i.indexOf(a.type) > -1 && e.push(a);
    });
    return e;
  },
  isDate: (a) => {
    return a instanceof Date;
  },
  isArray: (b) => {
    return Array.isArray(b);
  },
  isEmpty: (a) => {
    return "" === a || BsyUtils.isNull(a);
  },
  isBlank: (a) => {
    return BsyUtils.isNull(a) || "" === a.trim();
  },
  isNull: (a) => {
    return null == a;
  },
  ISNULL: function (a) {
    if (a === null) return true;
    // eslint-disable-next-line no-self-compare
    if (a !== a) return true; //替换isNan 为什么，因为isNan 判断字符串的时候会异常
    if (typeof a == "number" && !isFinite(a)) return true; //正无穷
    if (a === undefined) return true; //未定义
    return false;
  },
  leftPad: (a, b, c) => {
    let d = String(a);
    for (c || (c = " "); d.length < b;) d = c + d;
    return d.toString();
  },
  add: (a, b) => {
    //解决 科学计算法问题
    return Big(a).plus(Big(b));
  },
  sub: (a, b) => {
    //减法
    return Big(a).minus(Big(b));
  },
  mul: (a, b) => {
    //乘法
    return Big(a).times(Big(b));
  },
  div: (a, b) => {
    //除法
    return Big(a).div(Big(b));
  },
  getSelectionText: () => {
    return window.getSelection
      ? window.getSelection().toString()
      : document.selection && document.selection.createRange
        ? document.selection.createRange().text
        : "";
  },
  getShowFieldsByNames: (e, i) => {
    let a = [];
    if (i) {
      BsyUtils.forEach(e, function (e, s) {
        if ("subform" === s.type) {
          let n = [];
          BsyUtils.forEach(s.items, function (t, e1) {
            if (e1.widget) {
              e1 = BsyUtils.getFieldAttr(e1);
            }

            i.indexOf([s.name, e1.name].join(".")) > -1 && n.push(e1);
          });
          if (n.length > 0) {
            a.push({
              ...s,
              items: n,
            });
          }
        } else i.indexOf(s.name) > -1 && a.push(s);
      });
    } else {
      a = e;
    }

    // i ? BsyUtils.forEach(e, function (e, s) {
    //     if ("subform" === s.type) {
    //         let n = [];
    //         BsyUtils.forEach(s.items, function (t, e) {
    //             i.indexOf([s.name, e.name].join(".")) > -1 && n.push(e)
    //         })
    //         if(n.length <= 0){
    //             a.push({
    //                 ...s,
    //                 items: n
    //             })
    //         }
    //     } else
    //         i.indexOf(s.name) > -1 && a.push(s)
    // }) : a = e;
    return a;
  },
  // num2Str: (a, b) => {
  //     if (BsyUtils.isEmpty(a))
  //         return "";
  //     let c = a + "";
  //     if (BsyUtils.isEmpty(b))
  //         return c;
  //     let d = /\[Num0\]/;
  //     if (d.test(b))
  //         return b.replace(d, c);
  //     if (d = /\[Num1\]/,
  //         d.test(b))
  //         return b.replace(d, BsyUtils._num2CN(c, !1));
  //     if (d = /\[Num2\]/,
  //         d.test(b))
  //         return b.replace(d, BsyUtils._num2CN(c, !0));

  //     d = /\[Num3\]/;
  //     if (d.test(b))
  //         return BsyUtils.numbertoChinayuan(a);

  //     d = /[#0]+,?[#0]*\.?[#0]*%?/;
  //     let e = b.match(d);
  //     if (e && e.length > 0) {
  //         let f = e[0];
  //         return c = BsyUtils._numberFormat(a, f),
  //             b.replace(d, c)
  //     }
  //     return b
  // },
  numbertoChinayuan: function (a) {
    // console.log(a);
    let b = 9.999999999999e10,
      c = "\u58f9",
      e = "\u8d30",
      d = "\u53c1",
      g = "\u62fe",
      f = "\u4f70",
      k = "\u4edf",
      m = "\u4e07",
      l = "\u4ebf",
      h = "\u89d2",
      n = "\u5206";
    a = a.toString();
    if ("" == a) return "";
    if (null != a.match(/[^,.\d]/)) return "";
    if (
      null ==
      a.match(/^((\d{1,3}(,\d{3})*(.((\d{3},)*\d{1,3}))?)|(\d+(.\d+)?))$/)
    ) {
      // console.log("非法的数值格式");
      return "";
    }

    a = a.replace(/,/g, "");
    a = a.replace(/^0+/, "");
    if (Number(a) > b) {
      // console.log("最大数值不能超过 99999999999.99!");
      return "";
    }
    b = a.split(".");
    if (1 < b.length) {
      a = b[0];
      b = b[1];
      b = b.substr(0, 2);
    } else {
      a = b[0];
      b = "";
    }
    c = [
      "\u96f6",
      c,
      e,
      d,
      "\u8086",
      "\u4f0d",
      "\u9646",
      "\u67d2",
      "\u634c",
      "\u7396",
    ];
    g = ["", g, f, k];
    m = ["", m, l];
    n = [h, n];
    h = "";
    if (0 < Number(a)) {
      for (f = l = 0; f < a.length; f++) {
        d = a.length - f - 1;
        k = a.substr(f, 1);
        e = d / 4;
        d %= 4;
        if ("0" == k) {
          l++;
        } else {
          if (0 < l) {
            h += c[0];
          }
          l = 0;
          h += c[Number(k)] + g[d];
        }
        0 == d && 4 > l && (h += m[e]);
      }
      h += "\u5143";
    }
    if ("" != b) {
      for (f = 0; f < b.length; f++) {
        k = b.substr(f, 1);
        "0" != k && (h += c[Number(k)] + n[f]);
      }
    }
    "" == h && (h = "\u96f6\u5143");
    2 > b.length && (h += "\u6574");
    return h;
  },
  _num2CN: function (a, b) {
    let c = "〇一二三四五六七八九",
      d = "个十百千万亿";
    if (b) {
      c = "零壹贰叁肆伍陆柒捌玖";
      d = "个拾佰仟万亿";
    }
    let e = Math.floor(Math.abs(a)),
      f = Math.abs(a).toString(),
      g = f.replace(/\..*$/, ""),
      h = f.split("."),
      i = c,
      j = d,
      k = "-.",
      l = i[0],
      m = new RegExp(i[0] + "*$"),
      n = new RegExp(i[0] + "+", "g"),
      o = "",
      p = "";
    if (((o = a < 0 ? k[0] : ""), h.length >= 2)) {
      let q = h[1];
      if (q) {
        p = k[1];
        for (let r = 0; r < q.length; r++) p += i[+q[r]];
      }
    }
    if (1 == g.length) return o + i[e] + p;
    if (g.length <= 5) {
      let s = "";
      for (let t = 0, e = g.length; e--;) {
        let u = +g[t];
        s += this._num2CN(g[t], b) + (u && e ? j[e] : "");
        t++;
      }
      s = s.replace(n, l);
      s = s.replace(m, "");
      return o + s + p;
    }
    let s = "";
    let v = (g.length / 4) >> 0,
      w = g.length % 4;
    for (; 0 == w || !j[3 + v];) {
      w += 4;
      v--;
    }
    if (+g.substr(0, w)) {
      s = this._num2CN(g.substr(0, w), b) + j[3 + v];
      let x = g.substr(w);
      "0" === x[0] && (s += i[0]);
      s += this._num2CN(x, b);
    } else s = this._num2CN(g.substr(0, w), b) + this._num2CN(g.substr(w), b);
    s = s.replace(n, l);
    s = s.replace(m, "");
    return o + s + p;
  },
  _numberFormat: function (t, e) {
    var i = "",
      a = t + "",
      n =
        (/%$/.test(e) &&
          ((t *= 100),
            (e = e.replace((i = "%"), "")),
            -1 < (n = a.indexOf(".")) &&
            ((n = (n = a.length - 3 - n) < 0 ? 0 : 8 < n ? 8 : n),
              (t = parseFloat(t.toFixed(n)))),
            (a = t + "")),
          e.split(".")),
      e = n[0],
      s = n[1];
    if ("" !== s) {
      for (
        var n = s ? s.length : 0,
        o = (a = BsyUtils.toFixed(parseFloat(t), n)).split(""),
        r = n;
        0 < r && "#" === s.charAt(r - 1);
        r--
      ) {
        var l = o.pop();
        if ("0" !== l) {
          o.push(l);
          break;
        }
      }
      t = o.pop();
      "." === t && (t = "");
      a = o.join("") + t;
    }
    n = a.split(".");
    t = n[0];
    return (
      /,/.test(e)
        ? (n[0] = t.replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, "$1,"))
        : (a = e.match(/[0]+[0#]*$/)) &&
        0 < a.length &&
        (n[0] = BsyUtils.leftPad(t, a[0].length, "0")),
      n.join(".") + i
    );
  },
  fixDecimalPrecision: function (t, e) {
    var i,
      a = null;
    return (
      (e = e || 8),
      this.isEmpty(t) ||
      ((t = parseFloat(t)),
        isNaN(t) ||
        (a =
          (i = BsyUtils.toFixed(t).split(".")[1]) && i.length > e
            ? parseFloat(BsyUtils.toFixed(t, e))
            : t)),
      a
    );
  },
  formatUserThumb: (t) => {
    if (!BsyUtils.isObjectEmpty(t)) {
      let t1 = String(t);
      if (t1.match(/^[\u4e00-\u9fa5]+$/)) {
        t1 = t1.substr(t1.length - 1 > 0 ? t1.length - 1 : 0, 1);
      } else {
        t1 = t1.substr(0, 1);
      }
      return {
        color: t1.charCodeAt(0) % 6,
        name: t1.toUpperCase(),
      };
    } else {
      let t1 = React.language("widget.user.anonymous");
      t1 = t1.substr(0, 1);
      return {
        color: t1.charCodeAt(0) % 6,
        name: t1.toUpperCase(),
      };
    }
  },
  getDecimalPlaces: (t) => {
    let decimalPlacesRegExp = /(?:\d+)(?:\.(\d+))?(?:[eE]-(\d+))?/;

    t = (t + "").match(decimalPlacesRegExp);
    return t ? (t[1] ? t[1].length : 0) + (+t[2] || 0) : 0;
  },
  accDiv: (t, e) => {
    let decimalRegExp = /\.|[eE]-\d+/g;
    if (t % 1 == 0 && e % 1 == 0) return t / e;
    let i = t + "",
      n = e + "",
      r = -BsyUtils.getDecimalPlaces(t);
    r += BsyUtils.getDecimalPlaces(e);
    let a = i.replace(decimalRegExp, ""),
      o = n.replace(decimalRegExp, "");
    return r > 0 ? (a / o) * Math.pow(10, r) : a / o / Math.pow(10, -r);
  },
  accMul: (t, e) => {
    let decimalRegExp = /\.|[eE]-\d+/g;

    if (t % 1 == 0 && e % 1 == 0) return t * e;
    let i = t + "",
      n = e + "",
      r = BsyUtils.getDecimalPlaces(t);
    return (
      (r += BsyUtils.getDecimalPlaces(e)),
      (i.replace(decimalRegExp, "") * n.replace(decimalRegExp, "")) /
      Math.pow(10, r)
    );
  },
  _calTriggerViewPos: (e, scss) => {
    const { top, left } = BsyUtils.elemoffset(e.target);
    // console.log(top, left)

    let css = {
      width: scss.width + "px",
    };

    if (
      scss.height > top ||
      document.documentElement.clientHeight - top - 10 > scss.height
    ) {
      //底部有足够的空间
      css.top = top + "px";
    } else {
      css.bottom = document.documentElement.clientHeight - top + 2 + "px";
    }

    if (
      scss.width > left ||
      document.documentElement.clientWidth - left - 10 > scss.width
    ) {
      //右边有足够的空间
      css.left = left + e.target.offsetWidth + 10 + "px";
    } else {
      css.left = left - scss.width - 10 + "px";
    }
    return css;
  },
  //处理，删除编辑数据的时候data中的跨应用的formId信息
  checkRefApp: (b) => {
    let b1 = {
      ...b,
    };
    if (b1.formId && b1.formId.indexOf("@") > -1) {
      let formids = b1.formId.split("@");
      b1.refAppId = formids[1];
      // b1.appId = formids[1];
      b1.formId = formids[0];
      // b1.entryId = formids[0];
    } else {
      if (!b1.entryId) b1.entryId = b1.formId;
      if (!b1.formId) b1.formId = b1.entryId;
    }
    return b1;
  },
  _getFieldTypeIcon: function (type) {
    let iCon = "";
    if (type === "text" || type === "linkdata") {
      iCon = "icon-widget-text";
    } else if (type === "address") {
      iCon = "icon-widget-address";
    } else if (type === "image") {
      iCon = "icon-image";
    } else if (type === "number") {
      iCon = "icon-widget-number";
    } else if (type === "textarea") {
      iCon = "icon-widget-textarea";
    } else if (type === "radiogroup") {
      iCon = "icon-widget-radiogroup";
    } else if (type === "checkboxgroup") {
      iCon = "icon-widget-checkboxgroup";
    } else if (type === "combo") {
      iCon = "icon-widget-combo";
    } else if (type === "combocheck") {
      iCon = "icon-widget-combocheck";
    } else if (type === "location") {
      iCon = "icon-widget-location";
    } else if (type === "upload") {
      iCon = "icon-widget-upload";
    } else if (type === "subform") {
      iCon = "icon-widget-subform";
    } else if (type === "linkquery") {
      iCon = "icon-widget-linkquery";
    } else if (type === "signature") {
      iCon = "icon-widget-signature";
    } else if (type === "user") {
      iCon = "icon-widget-user";
    } else if (type === "usergroup") {
      iCon = "icon-widget-usergroup";
    } else if (type === "dept") {
      iCon = "icon-widget-dept";
    } else if (type === "deptgroup") {
      iCon = "icon-widget-deptgroup";
    } else if (type === "datetime") {
      iCon = "icon-widget-time";
    } else if (type === "flowState") {
      iCon = "icon-widget-flowState";
    } else if (type === "flowdecision") {
      iCon = "icon-widget-flowdecision";
    } else if (type === "sn") {
      iCon = "icon-widget-sn";
    } else if (type === "formula") {
      iCon = "icon-widget-number";
    } else if (type === "chargers") {
      iCon = "icon-widget-chargers";
    }
    return iCon;
  },
  _getWidgetTypeIcon: function (t) {
    switch (t) {
      case "metric_table":
        return "icon-widget-metrictable";
      case "gauge_chart":
        return "icon-report-gauge";
      case "column_chart":
        return "icon-widget-columnchart";
      case "funnel_chart":
        return "icon-bby-help-2";
      case "line_chart":
        return "icon-widget-linechart";
      case "pie_chart":
        return "icon-widget-piechart";
      case "area_chart":
        return "icon-widget-areachart";
      case "radar_chart":
        return "icon-widget-radarchart";
      case "bar_chart":
        return "icon-widget-barchart";
      case "gantt":
        return "icon-report-gantt";
      case "multi_axes_chart":
        return "icon-widget-multiaxeschart";
      case "data_table":
      case "background_table":
        return "icon-widget-datatable";
      case "pivot_table":
        return "icon-widget-pivottable";
      case "map_chart":
        return "icon-bby-iconditu";
      case "newMap":
        return "icon-widget-map";
      case "card":
        return "icon-widget-paiban";
      case "rili":
        return "icon-widget-rili";
      case "description":
        return "icon-report-description";
      case "image":
      case "gauge_imageMore":
        return "icon-dash-image";
      default:
        return "";
    }
  },
  _getLabelMap: function (items) {
    var labelMap = {};
    BsyUtils.forEach([...items], function (a1, b1) {
      if (b1.widget) {
        if (b1.widget.type === "subform") {
          labelMap[b1.widget.widgetName] = b1.label;
          BsyUtils.forEach(b1.widget.items, function (a2, b2) {
            labelMap[[b1.widget.widgetName, b2.widget.widgetName].join(".")] = [
              b1.label,
              b2.label,
            ].join(".");
          });
        } else {
          labelMap[b1.widget.widgetName] = b1.label;
        }
      } else {
        if (b1.type === "subform") {
          labelMap[b1.name] = b1.text;
          BsyUtils.forEach(b1.items, function (a2, b2) {
            labelMap[[b1.name, b2.name].join(".")] = [b1.text, b2.text].join(
              "."
            );
          });
        } else {
          labelMap[b1.name] = b1.text;
        }
      }
    });
    return labelMap;
  },
  _getWidgetTypeName: function (t) {
    switch (t) {
      case "metric_table":
        return React.language("dash.metric");
      case "gauge_chart":
        return React.language("dash.gauge");
      case "column_chart":
        return React.language("dash.columnChart");
      case "funnel_chart":
        return React.language("funnel.chart");
      case "line_chart":
        return React.language("dash.lineChart");
      case "pie_chart":
        return React.language("dash.pieChart");
      case "area_chart":
        return React.language("dash.areaChart");
      case "radar_chart":
        return React.language("dash.radarChart");
      case "bar_chart":
        return React.language("dash.barChart");
      case "multi_axes_chart":
        return React.language("dash.multiAxesChart");
      case "data_table":
        return React.language("report.dataTable");
      case "background_table":
        return React.language("backend.table");
      case "pivot_table":
        return React.language("pivot.table");
      case "map_chart":
        return React.language("widget.map");
      case "newMap":
        return React.language("widget.map");
      case "card":
        return React.language("widget.card");
      case "gantt":
        return React.language("dash.gantt");
      case "rili":
        return React.language("widget.datetime.calendar");
      default:
        return "";
    }
  },
  //检测组件是否进入可见范围
  checkInPage: (el) => {
    const pageHeight = document.documentElement.clientHeight;
    const contentTop = el.getBoundingClientRect().top;
    const contentHeight = el.offsetHeight;
    return (
      (contentTop < pageHeight && contentTop >= 0) ||
      (contentTop < 0 && contentTop + contentHeight > 0)
    );
  },

  //设置工作台最后一次访问的页面
  getEntryCache: (appid) => {
    // const { appid, entryid, type } = this.state;
    let key = "_appID_" + window.FX.STATIC.user._id + window.FX.STATIC.corpId;
    let contText = BsyUtils.Store.get(key) || {};
    if (contText[window.FX.STATIC.corpId]) {
      if (contText[window.FX.STATIC.corpId][appid])
        return contText[window.FX.STATIC.corpId][appid];
    }
    return {};
  },

  //重新计算 customDash的布局
  getSurplusDash: (components, customDash, ext) => {
    //方便计算，先进行一次排序
    let tmpComponents = components.sort((a, b) => {
      return a.y - b.y;
    });
    if (navigator.userAgent.indexOf("Firefox") > -1) {
      tmpComponents = tmpComponents.reverse();
    }

    const constDash = [...customDash];
    let newComponents = [];
    let newCustomDash = [];
    //1、过滤出 布局与报表结构有对应关系的数据
    for (let i = 0; i < tmpComponents.length; i++) {
      if (
        tmpComponents[i].id === "flowManagement" ||
        tmpComponents[i].id === "flowManagementV2" ||
        tmpComponents[i].id === "speedyEntry" ||
        tmpComponents[i].id.includes("speedyEntryV2") ||
        tmpComponents[i].id === "customApp" ||
        tmpComponents[i].id === "dockApp" ||
        tmpComponents[i].id === "myApp" ||
        tmpComponents[i].id === "recentUse" ||
        tmpComponents[i].id === "carouselMap" ||
        tmpComponents[i].id === "richText" ||
        tmpComponents[i].id === "noticeBoard" ||
        tmpComponents[i].id === "myDash" ||
        tmpComponents[i].id === "favorites"
      ) {
        newComponents.push(tmpComponents[i]);
      } else {
        let blockDash = customDash.filter((data) => {
          if (
            [data.appId, data.entryId, data.widgetId].join("@") ===
            [
              tmpComponents[i].appId,
              tmpComponents[i].entryId,
              tmpComponents[i].widgetId,
            ].join("@")
          ) {
            return true;
          } else {
            return false;
          }
        });
        if (blockDash.length > 0) {
          // if(blockDash[0].widgetParams.type == 'background_table') {
          //     tmpComponents[i].id = 'invalidBlock'
          //     let msgInfo = React.language('Block.invalid');
          //     newComponents.push({
          //         ...tmpComponents[i],
          //         msg: msgInfo
          //     });
          // } else

          newCustomDash.push(blockDash[0]);
          newComponents.push(tmpComponents[i]);
        } else {
          //无效的块
          tmpComponents[i].id = "invalidBlock";
          tmpComponents[i].widget = "widget_" + new Date().getTime();
          let msgInfo = React.language("Block.invalid");
          if (ext) {
            if (ext[tmpComponents[i].appId]) {
              if (
                ext[tmpComponents[i].appId].indexOf(tmpComponents[i].entryId) >
                -1
              ) {
                msgInfo = React.language("Block.invalid.1");
              }
            }
          }
          newComponents.push({
            ...tmpComponents[i],
            msg: msgInfo,
          });
        }
      }
    }
    //2、查找出没有对应关系的，并进行布局部分的结构补充
    for (let i = 0; i < constDash.length; i++) {
      let blockDash = newCustomDash.filter((data) => {
        if (
          [data.appId, data.entryId, data.widgetId].join("@") ===
          [
            constDash[i].appId,
            constDash[i].entryId,
            constDash[i].widgetId,
          ].join("@")
        ) {
          return true;
        } else {
          return false;
        }
      });
      if (blockDash.length === 0) {
        newCustomDash.push(customDash[i]);

        newComponents.push({
          appId: customDash[i].appId,
          disable: false,
          entryId: customDash[i].entryId,
          h: 10,
          id: "customDash",
          minH: 10,
          minW: 10,
          name: customDash[i].widgetParams.title,
          w: 60,
          widget: customDash[i].widgetId,
          widgetId: customDash[i].widgetId,
          x: 0,
          y:
            newComponents[newComponents.length - 1].y +
            newComponents[newComponents.length - 1].h,
        });
      }
    }

    return {
      components: [...newComponents],
      customDash: [...newCustomDash],
    };
  },
  getSurplusMobileDash: (components, customDash, ext) => {
    //方便计算，先进行一次排序
    let tmpComponents = components;
    if (navigator.userAgent.indexOf("Firefox") > -1) {
      tmpComponents = tmpComponents.reverse();
    }

    const constDash = [...customDash];
    let newComponents = [];
    let newCustomDash = [];
    //1、过滤出 布局与报表结构有对应关系的数据
    for (let i = 0; i < tmpComponents.length; i++) {
      if (
        tmpComponents[i].id === "flowManagement" ||
        tmpComponents[i].id === "flowManagementV2" ||
        tmpComponents[i].id === "speedyEntry" ||
        tmpComponents[i].id.includes("speedyEntryV2") ||
        tmpComponents[i].id === "customApp" ||
        tmpComponents[i].id === "dockApp" ||
        tmpComponents[i].id === "myDash" ||
        tmpComponents[i].id === "favorites" ||
        tmpComponents[i].id === "recentUse" ||
        tmpComponents[i].id === "noticeBoard" ||
        tmpComponents[i].id === "richText" ||
        tmpComponents[i].id === "carouselMap"
      ) {
        tmpComponents[i].x = 0;
        tmpComponents[i].y =
          i === 0 ? 0 : tmpComponents[i - 1].y + tmpComponents[i - 1].h;
        newComponents.push(tmpComponents[i]);
      } else {
        let blockDash = customDash.filter((data) => {
          if (
            data.widgetId === tmpComponents[i].widgetId ||
            data.widget === tmpComponents[i].widget
          ) {
            return true;
          } else {
            return false;
          }
        });
        if (blockDash.length > 0) {
          // if(blockDash[0].widgetParams.type == 'background_table') {
          //     tmpComponents[i].id = 'invalidBlock'
          //     let msgInfo = React.language('Block.invalid');
          //     newComponents.push({
          //         ...tmpComponents[i],
          //         msg: msgInfo
          //     });
          // } else

          newCustomDash.push(blockDash[0]);
          tmpComponents[i].x = 0;
          tmpComponents[i].y =
            i === 0 ? 0 : tmpComponents[i - 1].y + tmpComponents[i - 1].h;
          newComponents.push(tmpComponents[i]);
        } else {
          //无效的块
          tmpComponents[i].id = "invalidBlock";
          tmpComponents[i].widget = "widget_" + new Date().getTime();
          let msgInfo = React.language("Block.invalid");
          if (ext) {
            if (ext[tmpComponents[i].appId]) {
              if (
                ext[tmpComponents[i].appId].indexOf(tmpComponents[i].entryId) >
                -1
              ) {
                msgInfo = React.language("Block.invalid.1");
              }
            }
          }
          newComponents.push({
            ...tmpComponents[i],
            msg: msgInfo,
          });
        }
      }
    }
    //2、查找出没有对应关系的，并进行布局部分的结构补充
    for (let i = 0; i < constDash.length; i++) {
      let blockDash = newCustomDash.filter((data) => {
        if (
          [data.appId, data.entryId, data.widgetId].join("@") ===
          [
            constDash[i].appId,
            constDash[i].entryId,
            constDash[i].widgetId,
          ].join("@")
        ) {
          return true;
        } else {
          return false;
        }
      });
      if (blockDash.length === 0) {
        newCustomDash.push(customDash[i]);

        newComponents.push({
          appId: customDash[i].appId,
          disable: false,
          entryId: customDash[i].entryId,
          h: 10,
          id: "customDash",
          minH: 10,
          minW: 10,
          name: customDash[i].widgetParams.title,
          w: 60,
          widget: customDash[i].widgetId,
          widgetId: customDash[i].widgetId,
          x: 0,
          y:
            newComponents[newComponents.length - 1].y +
            newComponents[newComponents.length - 1].h,
        });
      }
    }

    return {
      mobileComponents: [...newComponents],
      customDash: [...newCustomDash],
    };
  },
  _dataMerge: function (header, orgData, newData) {
    header.map((data, index) => {
      let a1 = data.tag || data.name;
      if (a1) {
        if (newData[data.name]) orgData[a1] = newData[data.name];
      }
    });
    return orgData;
  },
  applyFunc: function (a, b, c, d) {
    return BsyUtils.isFunction(b) ? b.apply(a, c ? c : []) : d;
  },
  base64UrlToFile: function (base64Url, filename) {
    for (
      var e = base64Url.split(","),
      i = e[0].match(/:(.*?);/)[1],
      a = atob(e[1]),
      n = a.length,
      s = new Uint8Array(n);
      n--;

    )
      s[n] = a.charCodeAt(n);
    return new File([s], filename, { type: i });
  },
  blobToFile: function (blob, fileName) {
    // 创建一个新的File对象
    blob.lastModifiedDate = new Date();
    blob.name = fileName;
    return new File([blob], fileName, {
      type: blob.type,
      lastModified: Date.now(),
    });
  },
  // 根据id匹配，不存在写入，存在则更新
  writeStyle: (id, stylestr) => {
    const style = document.getElementById(id);
    if (style) {
      // 覆盖
      style.innerHTML = stylestr;
    } else {
      const style22 = document.createElement("style");
      style22.innerHTML = stylestr;
      style22.setAttribute("id", id);
      document.body.appendChild(style22);
    }
  },
  removeStyle: (id) => {
    const style = document.getElementById(id);
    if (style) {
      document.body.removeChild(style);
    }
  },
  imageCompressed: function (file, quality, cb) {
    // console.log("imageCompressed 1",file, quality)
    if (quality == 1) {
      cb && cb(file);
      return;
    }
    // 图片小于200KB，不压缩，可能会失真
    if (file.size <= 200 * 1024) {
      cb && cb(file);
      return;
    }
    if (quality >= 1 || quality < 0) {
      quality = 0.6;
    }

    new window.Compressor(file, {
      quality: quality || 0.6,
      retainExif: true,
      mimeType: "image/jpeg",
      success(result) {
        cb && cb(result);
      },
      error(err) {
        console.log(err.message);
      },
    });
    return;

    const img = new Image();
    const c = new window.pica();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth / 2; // 缩放到原始尺寸的一半
      canvas.height = img.naturalHeight / 2;
      // 图像质量
      if (quality >= 1 || quality < 0) {
        quality = 0.6;
      }
      c.resize(img, canvas)
        .then((result) => c.toBlob(result, "image/jpeg", 0.9))
        .then((blob) => {
          URL.revokeObjectURL(img.src);
          cb && cb(BsyUtils.blobToFile(blob, file.name));
        });
    };
    img.src = URL.createObjectURL(file);
    return;

    photoCompress(
      file,
      {
        quality: quality,
      },
      (base64Codes) => {
        var res = BsyUtils.base64UrlToFile(base64Codes, file.name);
        quality != 1 && cb && cb(res);
      }
    );

    function photoCompress(file, w, objDiv) {
      var ready = new FileReader();
      /*开始读取指定的Blob对象或File对象中的内容. 当读取操作完成时,readyState属性的值会成为DONE,如果设置了onloadend事件处理程序,则调用之.同时,result属性中将包含一个data: URL格式的字符串以表示所读取文件的内容.*/
      ready.readAsDataURL(file);
      ready.onload = function () {
        var re = this.result;
        canvasDataURL(re, w, objDiv);
      };
    }

    function canvasDataURL(path, obj, callback) {
      var img = new Image();
      img.src = path;
      img.onload = function () {
        var that = this;
        // 默认按比例压缩
        var w = that.width,
          h = that.height,
          scale = w / h;
        w = obj.width || w;
        h = obj.height || w / scale;
        var quality = 0.6; // 默认图片质量为0.7
        //生成canvas
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        // 创建属性节点
        var anw = document.createAttribute("width");
        anw.nodeValue = w;
        var anh = document.createAttribute("height");
        anh.nodeValue = h;
        canvas.setAttributeNode(anw);
        canvas.setAttributeNode(anh);
        ctx.drawImage(that, 0, 0, w, h);
        // 图像质量
        if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
          quality = obj.quality;
        }
        // quality值越小，所绘制出的图像越模糊
        var base64 = canvas.toDataURL("image/jpeg", quality);
        // 回调函数返回base64的值
        callback(base64);
      };
    }
  },
  dataURLtoFile: function (dataurl, filename) {
    var arr = dataurl.split(',');
    var mime = arr[0].match(/:(.*?);/)[1];
    var bstr = atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);

    for (var i = 0; i < n; i++) {
      u8arr[i] = bstr.charCodeAt(i);
    }
    return new File([u8arr], filename, { type: mime });
  },
  data2Base64: function (files, cb) {
    if (files) {
      var len = files.length;
      var convertIndex = 0;
      var dd = [];
      for (var i = 0; i < len; i++) {
        var reader = new FileReader();
        //通过文件流将文件转换成Base64字符串
        reader.readAsDataURL(files[i]);
        var bb = {
          name: files[i].name,
          mime: files[i].type,
          size: files[i].size,
          mode: "base64",
        };
        //转换成功后
        reader.onload = function () {
          bb.base64 = reader.result;

          var image = new Image();
          image.src = reader.result;
          image.onload = function () {
            bb.width = this.naturalWidth;
            bb.height = this.naturalHeight;
            dd.push(bb);
            // console.log(bb)
            if (dd.length == len) {
              cb && cb(dd);
            }
          };
        };
      }
    } else cb && cb([]);
  },
  // 是否支持弹出打印窗口
  popupPrint: function () {
    switch (getBrowser()) {
      case "Firefox":
        return getFirefoxVersion() >= 120;
      case "Chrome":
      case "Edge": {
        return getChromeVersion() >= 100;
      }
      case "Safari": {
        return getSafariVersion() >= 137;
      }
      default:
        return false;
    }
  },
  errorReport: function (dr, type) {
    var data = {
      type: type,
      name: document.title,
      url: window.location.href,
      ua: window.navigator.userAgent,
      nickname: window.FX.STATIC
        ? window.FX.STATIC.user
          ? window.FX.STATIC.user.nickname
          : ""
        : "",
      username: window.FX.STATIC
        ? window.FX.STATIC.user
          ? window.FX.STATIC.user.username
          : ""
        : "",
      userId: window.FX.STATIC
        ? window.FX.STATIC.user
          ? window.FX.STATIC.user._id
          : ""
        : "",
    };
    type = type || "js-logs";
    switch (type) {
      case "js-logs": {
        // var version = "wxsdk 未加载";
        // if ($("script[src$='jweixin-1.6.0.js']").length > 0) {
        //   version = "sdk jweixin-1.6.0.js";
        // } else if ($("script[src$='jweixin-1.2.0.js']").length > 0) {
        //   version = "sdk jweixin-1.2.0.js";
        // }
        // data = $.extend(data, dr ? dr : { wxsdk: version }, { wxsdk: version });
        break;
      }
      default: {
        data = Object.assign({}, data, dr ? dr : {});
      }
    }
    React.axios("/api/getparam.php", data)
      .then((res) => { })
      .catch((err) => { })
      .finally(() => { });
    // FX.Utils.dataAjax(
    //   {
    //     url: "/api/getparam.php",
    //     data: data,
    //   },
    //   function (c) {}
    // );
  },
  toNumberString: (t) => {
    t = BsyUtils.parseNumber(t);
    return BsyUtils.isEmpty(t) ? "" : new Big(t).toFixed().toString();
  },
  getShowFieldItems: (t, e, i) => {
    let a = [],
      s = {};
    BsyUtils.forEach(t, function (t, e) {
      "subform" === e.type
        ? BsyUtils.forEach(e.items, function (t, i1) {
          if (i1.widget) {
            i1 = BsyUtils.getFieldAttr(i1);
          }
          if (i1.type === "dataload") {
            return;
          }
          s[[e.name || e.title, i1.name || e.title].join(".")] = !0;
        })
        : (s[e.name || e.title] = !0);
    });
    BsyUtils.forEach(e, function (t, e) {
      if (!(i && i.indexOf(e.type) < 0)) {
        let n = {
          text:
            "chargers" === e.type
              ? React.language("field.chargers")
              : e.text || e.title,
          value: e.name,
        };
        n.selected = s[n.value];
        "subform" === e.type
          ? BsyUtils.forEach(e.items, function (t, n) {
            if (n.widget) {
              n = BsyUtils.getFieldAttr(n);
            }
            if (n.type === "dataload") {
              return;
            }
            if (!(i && i.indexOf(n.type) < 0)) {
              let o = {
                value: [e.name, n.name].join("."),
                text: [e.text || e.title, n.text || n.title].join("."),
              };
              o.selected = s[o.value];
              a.push(o);
            }
          })
          : a.push(n);
      }
    });
    return a;
  },
  calculateFileMd5: function (file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      // 当文件被成功读取时调用onload事件
      reader.onload = function (event) {
        const arrayBufferView = event.target.result;

        // 将ArrayBuffer转换为WordArray对象
        const wordArray = CryptoJS.lib.WordArray.create(arrayBufferView);

        // 计算MD5哈希值
        const md5Hash = CryptoJS.MD5(wordArray).toString();

        resolve(md5Hash);
      };

      // 当发生错误时调用onerror事件
      reader.onerror = function () {
        reject("Failed to read file");
      };

      // 开始读取文件内容
      reader.readAsArrayBuffer(file);
    });
  },
  //打包下载所有功能
  _package: (filename, val, _opt) => {
    // var _this = this;
    // var _opt = this.options;
    // var val = this.getValue();
    var files = [];
    var namemap = {};

    if (BsyUtils.isObjectEmpty(val)) {
      return;
    }

    function getfiledownload(file) {
      if (window.FX.CONST.QN_BUCKET.UPLOAD_SITE == "ctyun") {
        b =
          window.FX.CONFIG.HOST.IMAGE_HOST +
          "/" +
          file.qnKey +
          "?response-content-disposition=attachment;filename=" +
          encodeURIComponent(encodeURIComponent(c));
      } else if (
        ["aliyun", "localftp", "huawei"].includes(
          window.FX.CONST.QN_BUCKET.UPLOAD_SITE
        )
      ) {
        var routUrl = window.root_directroy ? window.root_directroy + "/" : "";
        b =
          window._bby_config.site +
          routUrl +
          "file/get/" +
          file.qnKey +
          "?filename=" +
          encodeURIComponent(file.name);
      } else {
        b = file.downloadUrl
          ? file.downloadUrl
          : window.FX.CONFIG.HOST.IMAGE_HOST + "/" + file.qnKey;
      }
      return b;
    }

    if (val.length == 1) {
      var c = val[0].name;
      var b = getfiledownload(val[0]);

      BsyUtils.fileDownload(b, c, _opt.dataId, _opt.formId, _opt.appId);
      return;
    }

    BsyUtils.forEach(val, function (a2, b2) {
      if (b2.qnKey) {
        if (!namemap.hasOwnProperty(b2.name)) {
          namemap[b2.name] = 0;
        } else {
          //处理同名文件
          namemap[b2.name]++;
          var index = b2.name.lastIndexOf(".");
          var suffix = b2.name.substring(index + 1);
          var name = b2.name.substring(0, index);
          b2.name = name + "(" + namemap[b2.name] + ")." + suffix;
        }
        files.push({
          name: b2.name,
          url: getfiledownload(b2),
          // window.FX.CONST.QN_BUCKET.UPLOAD_SITE === "qn" ||
          // window.FX.CONST.QN_BUCKET.UPLOAD_SITE === "minio" ||
          // window.FX.CONST.QN_BUCKET.UPLOAD_SITE === "qcloud"
          //   ? b2.downloadUrl
          //   : window.FX.CONFIG.HOST.IMAGE_HOST + "/" + b2.qnKey,
        });
      }
    });

    setTimeout(function () {
      var tag = _opt.label;
      BsyUtils.downloadPackage(
        {
          tag: filename || tag,
          filelist: files,
          updatePercent: function (percent) {
            //进度
            // t1.find(".x-loader-text").text(percent + "%");
          },
          done: function (percent) {
            //下载完成，关闭加载
            // t1 && t1.remove();
          },
          error: function (error) {
            //下载出错 关闭加载
            // t1 && t1.remove();
          },
        },
        _opt.dataId,
        _opt.formId || _opt.entryId,
        _opt.appId
      );
    }, 1);
  },
  closestClass: (node, cls) => {
    if (!node) return null;

    let x = node;
    if (x.classList.contains(cls)) {
      return x;
    }

    while (x.tagName !== "BODY") {
      x = x.parentNode;
      if (!x) return null;
      if (x.classList.contains(cls)) {
        return x;
      }
    }
    return null;
  },
  dataURLtoBlob: (t) => {
    for (
      var e = t.split(","),
      i = e[0].match(/:(.*?);/)[1],
      a = atob(e[1]),
      n = a.length,
      s = new Uint8Array(n);
      n--;

    )
      s[n] = a.charCodeAt(n);
    return new Blob([s], {
      type: i,
    });
  },
  downloadFile: (fileName, content) => {
    var aLink = document.createElement("a");
    var blob = BsyUtils.dataURLtoBlob(content); //new Blob([content]);

    var evt = document.createEvent("HTMLEvents");
    evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
    aLink.download = fileName;
    aLink.href = URL.createObjectURL(blob);
    if (BsyUtils.isFugouAppBrowser()) {
      var obj = {
        action: "downLoadFile", //
        params: URL.createObjectURL(blob), // 下载地址
      };
      try {
        window.$downLoadFile.sendMessageToHost(obj);
      } catch (error) {
        console.log(error);
      }
    } else {
      aLink.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      ); //兼容火狐
    }
  },
  downloadFile2: function (fileName, content) {
    var aLink = document.createElement("a");
    var blob = content; //new Blob([content]);

    var evt = document.createEvent("HTMLEvents");
    evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
    aLink.download = fileName;
    aLink.href = blob;
    if (BsyUtils.isFugouAppBrowser()) {
      var obj = {
        action: "downLoadFile", //
        params: blob, // 下载地址
      };
      try {
        window.$downLoadFile.sendMessageToHost(obj);
      } catch (error) {
        console.log(error);
      }
    } else {
      aLink.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      ); //兼容火狐
    }
  },
  closest: (node, cls) => {
    if (!node) return null;

    let x = node;
    if (x.tagName.toLowerCase() === cls.toLowerCase()) {
      return x;
    }

    while (x.tagName !== "BODY") {
      x = x.parentNode;
      if (!x) return null;
      if (x.tagName.toLowerCase() === cls.toLowerCase()) {
        return x;
      }
    }
    return null;
  },
  startWith: (a, b) => {
    let c = a.length;
    return (
      !(null == b || "" === b || 0 === c || b.length > c) &&
      a.substr(0, b.length) === b
    );
  },

  address2Str: (a, c, split) => {
    let b = "";
    split = split || "";
    if (c && a) {
      let d = !0;

      let ads = [];

      if (/p/.test(c) && a.province) {
        ads.push(a.province);
        // b += a.province
        // a.province === a.city && (d = !1)
      }
      if (/c/.test(c) && a.city) {
        if (a.province === a.city) {
          if (split) {
            ads.push(a.city);
          }
        } else {
          ads.push(a.city);
        }
      }
      if (/d/.test(c) && a.district) {
        ads.push(a.district);
      }
      if (/a/.test(c) && a.detail) {
        ads.push(a.detail);
      }
      if (ads.length) {
        b = ads.join(split);
      }
    }
    return b;
  },
  t_requestFullScreen: () => { //兼容钉钉方法
    try {
      let elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullScreen) {
        elem.webkitRequestFullScreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    } catch (e) { }
  },
  //进入全屏
  requestFullScreen: (callback) => {
    try {
      let elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullScreen) {
        elem.webkitRequestFullScreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }

      document.addEventListener("fullscreenchange", handleFullscreenChange);
      document.addEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.addEventListener("mozfullscreenchange", handleFullscreenChange);
      document.addEventListener("MSFullscreenChange", handleFullscreenChange);

      function handleFullscreenChange() {
        // 检查是否退出全屏
        if (
          !document.fullscreenElement &&
          !document.webkitFullscreenElement &&
          !document.mozFullScreenElement &&
          !document.msFullscreenElement
        ) {
          callback();
          document.removeEventListener(
            "fullscreenchange",
            handleFullscreenChange
          );
          document.removeEventListener(
            "webkitfullscreenchange",
            handleFullscreenChange
          );
          document.removeEventListener(
            "mozfullscreenchange",
            handleFullscreenChange
          );
          document.removeEventListener(
            "MSFullscreenChange",
            handleFullscreenChange
          );
        }
      }
    } catch (e) { }
  },
  //退出全屏
  exitFullscreen: () => {
    try {
      let de = document;
      if (de.exitFullscreen) {
        de.exitFullscreen();
      } else if (de.mozCancelFullScreen) {
        de.mozCancelFullScreen();
      } else if (de.webkitCancelFullScreen) {
        de.webkitCancelFullScreen();
      } else if (de.msExitFullscreen) {
        de.msExitFullscreen();
      }
    } catch (e) { }

  },
  prefixInteger: (num, length) => {
    return ("0000000000000000" + num).substr(-length);
  },
  //是否是纯数字
  isRealNum: (val) => {
    if (val == null || val.toString().replace(/\s/g, "") === "") {
      return false;
    }

    if (typeof val == "boolean") {
      return false;
    }

    if (!isNaN(val)) {
      return true;
    } else {
      return false;
    }
  },
  isTrue: (val) => {
    if (BsyUtils.isRealNum(val)) return true;
    return val ? true : false;
  },
  fileDownload: function (a, b, c, e, d) {
    if (!b) {
      return;
    }
    window.FX.Utils.dataAjax(
      {
        url: "/data/add_file_log",
        data: {
          appId: d ? d : "",
          formId: e ? e : "",
          dataId: c ? c : "",
          fileName: b,
        },
      },
      function () {
        BsyUtils.redirectTo(a);
      }
    );
  },
  downloadPackage: function (opt, dataId, formId, appId) {
    //filelist,done,error
    if (BsyUtils.isObjectEmpty(opt.filelist)) {
      opt.error && opt.error("打包下载列表为空");
      return;
    }
    var Promise = window.Promise;
    if (!Promise) {
      Promise = window.JSZip.external.Promise;
    }

    var zip = new window.JSZip();
    for (var i = 0; i < opt.filelist.length; i++) {
      zip.file(opt.filelist[i].name, urlToPromise(opt.filelist[i].url), {
        binary: true,
      });
    }

    zip
      .generateAsync(
        {
          type: "blob",
        },
        function updateCallback(metadata) {
          opt.updatePercent && opt.updatePercent(metadata.percent.toFixed(2));
          var msg = "progression : " + metadata.percent.toFixed(2) + " %";
          if (metadata.currentFile) {
            msg += ", current file = " + metadata.currentFile;
          }
          console.log(msg);
          // updatePercent(metadata.percent | 0);

          // opt.updatePercent && opt.updatePercent(metadata.percent | 0);
        }
      )
      .then(
        function callback(blob) {
          // see FileSaver.js
          var dd = new Date();
          var name = (opt.tag || React.language("Form.download")) + "_";
          name += dd.getFullYear().toString();
          name +=
            dd.getMonth() + 1 < 10
              ? "0" + (dd.getMonth() + 1).toString()
              : (dd.getMonth() + 1).toString();
          name +=
            dd.getDate() < 10
              ? "0" + dd.getDate().toString()
              : dd.getDate().toString();
          name +=
            dd.getHours() < 10
              ? "0" + dd.getHours().toString()
              : dd.getHours().toString();
          name +=
            dd.getMinutes() < 10
              ? "0" + dd.getMinutes().toString()
              : dd.getMinutes().toString();
          name +=
            dd.getSeconds() < 10
              ? "0" + dd.getSeconds().toString()
              : dd.getSeconds().toString();
          name += ".zip";
          window.FX.Utils.dataAjax(
            {
              url: "/data/add_file_log",
              data: {
                appId: appId ? appId : undefined,
                formId: formId ? formId : undefined,
                dataId: dataId ? dataId : undefined,
                fileName: name,
              },
            },
            function () {
              window.saveAs(blob, name);
              opt.done && opt.done();
              console.log("done !");
            }
          );
        },
        function (e) {
          BsyUtils.forEach(opt.filelist, function (a1, b1) {
            if (e.indexOf(b1.url) > -1) {
              e = b1.name + "不存在，请检查后重试";
              return !1;
            }
          });
          opt.error && opt.error(e);

          // opt.error && opt.error(e);
          // console.log(e);
        }
      );

    /**
     * Fetch the content and return the associated promise.
     * @param {String} url the url of the content to fetch.
     * @return {Promise} the promise containing the data.
     */
    function urlToPromise(url) {
      return new Promise(function (resolve, reject) {
        window.JSZipUtils.getBinaryContent(url, function (err, data) {
          if (err) {
            reject(err);
          } else {
            resolve(data);
          }
        });
      });
    }
  },
  isObjectEmpty: (a) => {
    if (null == a) return !0;
    if (a.length > 0) return !1;
    if (0 === a.length) return !0;
    for (let b in a) if (hasOwnProperty.call(a, b)) return !1;
    return isNaN(a);
  },
  checkValidateTitle: function (value, title, result, len, customize) {
    //验证标题类名称规则，26位长度， 可以使用中文, 和特殊字符 ( ) - _ 以及空格, 数据, 统一使用26位长度
    len = len || 23;
    result = result || {};
    value = BsyUtils.trim(value);
    customize = customize || "";

    if (!value) {
      tipAlert({
        type: "warning",
        msg: title + React.language("not.empty"),
      });
      return false;
    }

    if (value.length > len) {
      tipAlert({
        type: "warning",
        msg: React.language("title.len", {
          title: title,
          len: len,
        }),
      });
      if (result) result.data = value.substr(0, len);
      return false;
    }
    var c = !0;
    try {
      c = new RegExp(
        "^[" + customize + "-.a-zA-Z0-9_\u4e00-\u9fa5()（） ]{0," + len + "}$"
      ).test(value);
    } catch (a) {
      c = !1;
    }

    if (!c) {
      if (result)
        result.data = value.replace(
          "/[^-.a-zA-Z0-9_\u4e00-\u9fa5()（） " + customize + "]+/g",
          ""
        );
      tipAlert({
        type: "warning",
        msg: title + React.language("only.be"),
      });
      return false;
    }
    return true;
  },
  findDuplicates: (arr) => {
    return arr
      .filter(
        (item, index) =>
          arr.indexOf(item) !== index && arr.lastIndexOf(item) === index
      )
      .filter((it) => it);
  },
  _initDeptMap: function (data) {
    BsyUtils.forEach(data, function (a1, b1) {
      const id = b1._id || b1.id;
      if (
        ["110000000000000000000001", "110000000000000000000002"].includes(id)
      ) {
        return;
      }
      window.deptSelectMap[b1._id || b1.id] = b1;
    });
  },
  _initUserMap: function (data) {
    BsyUtils.forEach(data, function (a1, b1) {
      const id = b1._id || b1.id;
      if ("100000000000000000000001" === id) {
        return;
      }

      window.userSelectMap[id] = b1;
    });
  },
  isStringEmpty: function (e) {
    return "" === e || BsyUtils.isEmpty(e);
  },
  getLnglatText: (t) => {
    return BsyUtils.isObjectEmpty(t) || BsyUtils.isObjectEmpty(t.lnglatXY)
      ? ""
      : React.language("lat") +
      BsyUtils.fixDecimalPrecision(t.lnglatXY[1], 6) +
      "，" +
      React.language("lon") +
      BsyUtils.fixDecimalPrecision(t.lnglatXY[0], 6);
  },
  isDarkColor: (t, e, i) => {
    return 0.299 * t + 0.578 * e + 0.114 * i < 192;
  },
  jsonCopy: (json) => {
    return JSON.parse(JSON.stringify(json));
  },
  flatten: (a, b, c) => {
    c || (c = []);
    if (a)
      for (let d = 0, e = a.length; d < e; d++) {
        let f = a[d];
        if (Array.isArray(f)) {
          BsyUtils.flatten(f, b, c);
        } else {
          if (!(b && !b(f))) {
            c.push(f);
          }
          // b && !b(f) || c.push(f)
        }

        // Array.isArray(f) ? BsyUtils.flatten(f, b, c) : b && !b(f) || c.push(f)
      }
    return c;
  },
  getServerDate: (a) => {
    if (a && a.headers) {
      let b = a.headers.date;
      if (b) {
        window.FX.STATIC._st = new Date(b).getTime();
        window.FX.STATIC._ct = new Date().getTime();
      }
    }
  },
  Base64Encode: function (str) {
    var encode = encodeURIComponent(str);
    // 对编码的字符串转化base64
    var base64 = btoa(encode);
    return base64;
  },
  Base64Decode: function (str) {
    var base64 = atob(str);
    var encode = decodeURIComponent(base64);
    // 对编码的字符串转化base64

    return encode;
  },
  isSubformWidget: (t) => {
    return /\./.test(t);
  },

  isSupportHint: function (t) {
    return [
      "text",
      "textarea",
      "number",
      "datetime",
      "combo",
      "combocheck",
      "phone",
    ].includes(t);
  },
  isSupportHorizontalLayout: function (t) {
    return ![
      "subform",
      "separator",
      "linkfield",
      "linkquery",
      "linkdata",
      "dataload",
    ].includes(t);
  },

  dataAjax: (a, b, c, d) => {
    a.data = a.data || {};
    let e = a.data;
    e.appId ||
      BsyUtils.isEmpty(window.FX.STATIC.APPID) ||
      (e.appId = window.FX.STATIC.APPID);
    e.entryId ||
      BsyUtils.isEmpty(window.FX.STATIC.ENTRYID) ||
      (e.entryId = window.FX.STATIC.ENTRYID);
    e.dataId ||
      BsyUtils.isEmpty(window.FX.STATIC.DATAID) ||
      (e.dataId = window.FX.STATIC.DATAID);
    window.FX.STATIC.BACKUP && (e.isBackup = !0);
    if (BsyUtils.isEmpty(window.FX.STATIC.DTOKEN)) {
      if (BsyUtils.isEmpty(window.FX.STATIC.FTOKEN)) {
        if (BsyUtils.isEmpty(window.FX.STATIC.QTOKEN)) {
          if (BsyUtils.isEmpty(window.FX.STATIC.RTOKEN)) {
            if (!BsyUtils.isEmpty(window.FX.STATIC.ATOKEN)) {
              e.fx_access_token = window.FX.STATIC.ATOKEN;
              e.fx_access_type = "app_public";
            }
          } else {
            e.fx_access_token = window.FX.STATIC.RTOKEN;
            e.fx_access_type = "report_public";
          }
        } else {
          e.fx_access_token = window.FX.STATIC.QTOKEN;
          e.fx_access_type = "form_query";
        }
      } else {
        e.fx_access_token = window.FX.STATIC.FTOKEN;
        e.fx_access_type = "form_public";
      }
    } else {
      e.fx_access_token = window.FX.STATIC.DTOKEN;
      e.fx_access_type = "form_public";
    }

    return BsyUtils.ajax(
      a,
      function (a, c) {
        b(a, c);
      },
      c,
      d
    );
  },

  compare: (originOrg, targetOrg) => {
    return isEqual(originOrg, targetOrg);
  },
  getDateInfoFromNow: (t, t1) => {
    if (BsyUtils.isNull(t)) return null;
    if (BsyUtils.isObjectEmpty(t1)) {
      t1 = new Date();
    } else t1 = new Date(t1);

    let e = {
      isLater: !0,
    },
      i = new Date(t),
      n = t1.getTime() - i.getTime();
    n > 0 && (e.isLater = !1);
    return (
      (n = Math.abs(n)) >= 864e5
        ? ((e.day = parseInt(n / 864e5, 10)),
          (e.hour = parseInt((n % 864e5) / 36e5, 10)),
          (e.minute = parseInt(((n % 864e5) % 36e5) / 6e4, 10)))
        : n >= 36e5
          ? ((e.hour = parseInt(n / 36e5, 10)),
            (e.minute = parseInt((n % 36e5) / 6e4, 10)))
          : n >= 6e4
            ? (e.minute = parseInt(n / 6e4, 10))
            : ((e.second = parseInt(n / 1000, 10)), (e.isJustNow = !0)),
      e
    );
  },
  _getSeachUserDeptList: (user, mode, opt) => {
    //显示最后三级部门
    if (window.FX.STATIC.FTOKEN) {
      return "";
    }
    opt = opt || {};
    let b = BsyUtils;
    mode = mode || "data";
    let url = "/corp/department/list";
    if (mode == "data") {
      url = "/data/member/departments";
    }
    if (BsyUtils.isObjectEmpty(b.departmentMap)) {
      b.departmentMap = {};
      b.labelCorpMap = {};
      window.FX.Utils.dataAjax(
        {
          url: url,
          async: false,
          data: { ...opt },
        },
        function (c) {
          for (let i = 0; i < c.departments.length; i++) {
            let element = c.departments[i];
            b.departmentMap["dept_" + element.departmentId] = element;
          }
          for (let i = 0; i < c.label_corp_list.length; i++) {
            let element = c.label_corp_list[i];
            b.labelCorpMap["corp_" + element.departmentId] = element;
          }
        }
      );
    }

    function getTopDockCorp(id) {
      let drot = "";
      //当前这层
      let element = b.labelCorpMap["corp_" + id];
      if (element) {
        drot = element.name;
        //第二层
        element = b.labelCorpMap["corp_" + element.parentId];
        if (element) {
          if (element.parentId === 0) {
            drot = drot;
          } else {
            drot = element.name + "/" + drot;
          }
          //第三层
          element = b.labelCorpMap["corp_" + element.parentId];
          if (element) {
            drot = element.name + "/" + drot;
          }
        }
      }

      return drot;
    }

    function getTopDetp(id) {
      let drot = "";
      //当前这层
      let element = b.departmentMap["dept_" + id];
      if (element) {
        drot = element.name;
        //第二层
        element = b.departmentMap["dept_" + element.parentId];
        if (element) {
          drot = element.name + "/" + drot;
          //第三层
          element = b.departmentMap["dept_" + element.parentId];
          if (element) {
            drot = element.name + "/" + drot;
          }
        }
      }

      return drot;
    }
    let ds = [];
    if (user.mode === "outsider") {
      let df = user.groupname;
      if (df) {
        ds = [React.language("outsider") + ":" + df];
      } else {
        ds = [React.language("outsider")];
      }
    } else {
      if (user.mode === "dockuser") {
        BsyUtils.forEach(user.deptids, function (a1, a2) {
          let df = getTopDockCorp(a2);
          if (df) {
            ds.push(df);
          }
        });
        if (ds.length > 0) {
          ds = [React.language("organization.external") + ":" + ds];
        } else {
          ds = [React.language("organization.external")];
        }
      } else {
        BsyUtils.forEach(user.deptids, function (a1, a2) {
          let df = getTopDetp(a2);
          if (df) {
            if (user.job_title && user.job_title[a2]) {
              df += " - " + user.job_title[a2];
            }
            ds.push(df);
          }
        });
      }
    }

    if (ds.length > 0) return "(" + ds.join("、") + ")";
    return "";
  },
  _getSeachUserDeptListArray: (user, mode) => {
    //显示最后三级部门
    if (window.FX.STATIC.FTOKEN) {
      return [];
    }
    let b = BsyUtils;
    mode = mode || "data";
    let url = "/corp/department/list";
    if (mode == "data") {
      url = "/data/member/departments";
    }
    if (BsyUtils.isObjectEmpty(b.departmentMap)) {
      b.departmentMap = {};
      window.FX.Utils.dataAjax(
        {
          url: url,
          async: false,
        },
        function (c) {
          for (let i = 0; i < c.departments.length; i++) {
            let element = c.departments[i];
            b.departmentMap["dept_" + element.departmentId] = element;
          }
        }
      );
    }

    function getTopDetp(id) {
      let drot = "";
      //当前这层
      let element = b.departmentMap["dept_" + id];
      if (element) {
        drot = element.name;
        //第二层
        element = b.departmentMap["dept_" + element.parentId];
        if (element) {
          drot = element.name + " / " + drot;
          //第三层
          element = b.departmentMap["dept_" + element.parentId];
          if (element) {
            drot = element.name + " / " + drot;
          }
        }
      }

      return drot;
    }
    let ds = [];
    BsyUtils.forEach(user, function (a1, a2) {
      let obj = b.departmentMap["dept_" + a2.id];
      if (obj) {
        let df = getTopDetp(a2.id);
        obj.moreTitle = df;
        obj.title = obj.name;
        ds.push(obj);
      }
    });
    return ds;
  },
  getDateInfoFromNowString: (t, t1) => {
    let g = BsyUtils.getDateInfoFromNow(t, t1);

    let f = "";
    f += g.day
      ? '<span class="days">' + g.day + "</span>" + React.language("days")
      : "";
    f += g.hour
      ? '<span class="hours">' + g.hour + "</span>" + React.language("to.hour")
      : "";
    f += g.minute
      ? '<span class="minute">' +
      g.minute +
      "</span>" +
      React.language("to.minute")
      : "";
    f += g.second
      ? '<span class="second">' +
      g.second +
      "</span>" +
      React.language("second")
      : "";
    if (!f) {
      f = '<span class="second">0</span>' + React.language("second");
    }
    return f;
  },
  escapeHtmlSpecialChar: (t) => {
    return BsyUtils.isEmpty(t)
      ? ""
      : BsyUtils.isString(t)
        ? t.replace(/[<>"&]/g, function (t, e, i) {
          switch (t) {
            case "<":
              return "&lt;";
            case ">":
              return "&gt;";
            case "&":
              return "&amp;";
            case '"':
              return "&quot;";
            default: {
              return t;
            }
          }
        })
        : "";
  },
  replaceURL: (t) => {
    if (BsyUtils.isNull(t)) return "";
    t += "";
    let e = "";
    let i = BsyConfig().CONST.TEXT_TYPE_REGEXP.URL;
    let a = t.split(new RegExp("(" + i + ")"));
    BsyUtils.forEach(a, function (t, i) {
      if (t % 2 != 0) {
        let a = i;
        BsyUtils.startWith(i, "www") && (a = "http://" + i);
        e +=
          '<a class="nest-link" target="_blank" href="' +
          a +
          '">' +
          BsyUtils.escapeHtmlSpecialChar(i) +
          "</a>";
      } else e += BsyUtils.escapeHtmlSpecialChar(i);
    });
    return e;
  },
  escapeHtmlScriptSpecialChar: (t) => {
    return BsyUtils.isEmpty(t)
      ? ""
      : t.replace(/<script.*>.*<\/script>/gi, function (t, e, i) {
        return t.replace(/[<>"&]/g, function (t, e, i) {
          switch (t) {
            case "<":
              return "&lt;";
            case ">":
              return "&gt;";
            case "&":
              return "&amp;";
            case '"':
              return "&quot;";
          }
        });
      });
  },
  _getBsargs: function (base) {
    var agrs = decodeURIComponent(atob(base));
    var theRequest = {};

    if (agrs) {
      var strs = agrs.split("&");
      for (var i = 0; i < strs.length; i++) {
        var tmp = strs[i].split("=");
        if (tmp[0] == "") continue;
        theRequest[decodeURIComponent(tmp[0])] = decodeURIComponent(tmp[1]);
      }
    }

    return theRequest;
  },
  _getRequest: function () {
    var url = window.location.href; //获取url中"?"符后的字串
    var theRequest = {};
    var pos = url.lastIndexOf("?");
    if (pos != -1) {
      var str = url.substr(pos + 1);
      var strs = str.split("&");
      for (var i = 0; i < strs.length; i++) {
        var tmp = strs[i].split("=");
        if (tmp[0] === "") continue;
        if (tmp[0] === "bsargs") {
          var da = BsyUtils._getBsargs(tmp[1]);
          theRequest = { ...theRequest, ...da };
        } else
          theRequest[decodeURIComponent(tmp[0])] = decodeURIComponent(tmp[1]);
      }
    }
    return theRequest;
  },
  _getDashRequest: function (h) {
    var s = BsyUtils._getRequest();
    BsyUtils.forEach(s, function (a1, b1) {

      try {
        //.replace(/\n/g,"\\n").replace(/\r/g,"\\r")

        if (h.components[a1].type === "user_filter") {
          b1 = b1.replace('100000000000000000000001', window.FX.STATIC.user.dock_userid || window.FX.STATIC.user._id)
        }
        var data = JSON.parse(b1.replace(/\n/g, "\\n").replace(/\r/g, "\\r"));
        if (data && data.hasOwnProperty("m")) {
          //带多种条件的模式
          h.components[a1].method = data.m;
          if (h.components[a1].type === "flowdecision_filter") {
            h.components[a1].defaultConfig.value = data.v.items;
            h.components[a1].defaultConfig.hasEmpty = data.v.hasEmpty;
          } else {
            h.components[a1].defaultConfig = _.cloneDeep(data.v);
          }

        } else {
          //不能转为json 用普通方式重置一次
          otertFormat();
        }

      } catch (e) {
        // console.log(e)
        //不能转为json 用普通方式重置一次
        otertFormat();
      }

      function otertFormat() {
        if (h.components.hasOwnProperty(a1) && h.components[a1].hasOwnProperty('method')) {
          switch (h.components[a1].type) {
            case "textarea_filter": {
              h.components[a1].method = "like";
              h.components[a1].defaultConfig = {
                value: b1
              }
              break;
            }

            case 'text_filter': {
              h.components[a1].method = "eq";
              h.components[a1].defaultConfig = {
                value: b1
              }
              break;
            }

            case "number_filter": {
              h.components[a1].method = "eq";
              h.components[a1].defaultConfig = {
                value: parseFloat(b1)
              }
              break;
            }

            case "date_filter":
            case "datetime_filter": {
              h.components[a1].method = "eq";
              b1 = b1.replace(/-/g, "/");

              var ss = new Date(b1)
              if (ss == 'Invalid Date') {
                if (typeof b1 == 'string') {
                  b1 = parseInt(b1);
                }
                ss = new Date(b1)
              }

              if (ss == 'Invalid Date') {
                return;
              }
              h.components[a1].defaultConfig = {
                value: ss.getTime()
              }
              break;
            }

            case "address_filter": {
              try {
                if (b1) {
                  h.components[a1].method = "all";
                  var address = JSON.parse(b1);
                  if (address && (address.hasOwnProperty("city") || address.hasOwnProperty("district") || address.hasOwnProperty("province"))) {
                    h.components[a1].defaultConfig = address
                  }
                }

              } catch (e) {
                // console.log(e)
              }
              break;
            }


            case "dept_filter":
            case "user_filter": {
              h.components[a1].method = "in";
              h.components[a1].defaultConfig = {
                items: [b1]
              }
              break;
            }

            case "combocheck_filter":
            case "deptgroup_filter":
            case "usergroup_filter": {
              try {
                if (b1) {
                  h.components[a1].method = "all";
                  var dd = JSON.parse(b1);
                  if (BsyUtils.isArray(dd)) {
                    h.components[a1].defaultConfig = {
                      items: dd
                    }
                  }
                }
              } catch (e) {
                console.log(e)
              }
              break;
            }

            default:
          }
        }
      }

    })
  },
  isVideoExt: (e) => {
    return /^(mp4|webm|ogg|mov)$/i.test(e);
  },
  isPdfExt: (e) => {
    return /^pdf$/i.test(e);
  },
  isOfficeExt: (e) => {
    return /^(doc|docx|ppt|pptx|xls|xlsx)$/i.test(e);
  },
  isImageExt: (e) => {
    return /^(png|jpg|jpeg|gif)$/i.test(e);
  },
  isFormDataSupported: () => {
    return void 0 !== window.FormData;
  },
  getFlowOption: function (a, b) {
    var c = {};

    a.hasPrint &&
      (c.print = {
        text: a.custom_text
          ? a.custom_text.print_text
          : React.language("print"),
      });

    switch (b) {
      case "todo":
        if (a.isEditable && a.currentFlowId !== -1) {
          if (a.hasOwnProperty("allowSubmit")) {
            if (a.allowSubmit) {
              c = {
                forward: {
                  text: a.custom_text.submit_text,
                },
              };
            }
          } else {
            c = {
              forward: {
                text: a.custom_text.submit_text,
              },
            };
          }

          a.allowSave &&
            (c.save = {
              text: a.custom_text.save_text,
            });
          a.allowSign &&
            (c.sign = {
              text: a.custom_text.sign_text,
            });
          a.allowBack &&
            (c.back = {
              text: a.custom_text.back_text,
            });
          a.allowClose &&
            (c.close = {
              text: a.custom_text.close_text,
            });
          a.allowTransfer &&
            (c.transfer = {
              text: a.custom_text.transfer_text,
            });
          a.hasPrint &&
            (c.print = {
              text: a.custom_text.print_text,
            });
          c.comment = a.comment;
          c.isEditable = !0;
        }
        break;
      case "create":
        a.allowRevoke &&
          (c.revoke = {
            text: React.language("flow.action.revoke"),
          });
        a.allowUrge &&
          (c.urge = {
            text: React.language("flow.Urge"),
          });
        break;
      case "transactors":
        a.allowRevoke &&
          (c.revoke = {
            text: React.language("flow.action.revoke"),
          });
        break;
      case "part":
      default: {
      }
    }
    BsyUtils.isObjectEmpty(c) ? (c.hasBtn = !1) : (c.hasBtn = !0);
    c.flowState = a.data.flowState;
    c.version = a.data.flowVer;
    c.hasLogView = a.hasLogView;
    if (a.hasComment === undefined) c.hasComment = !0;
    else c.hasComment = a.hasComment;
    c.chargers = a.data.chargers;
    c.transactors = a.data.transactors;
    c.dataId = a.data._id;

    c.ccUsers = a.data.ccUsers;
    c.flowStack = a.data.flowStack;
    var d = [];
    BsyUtils.isArray(a.flowNodes) &&
      a.flowNodes.length > 0 &&
      (d = a.flowNodes.filter(function (a) {
        return "todo" === b
          ? "charger" === a.type
          : "part" === b
            ? "transactor" === a.type
            : void 0;
      }));
    c.flowId = a.currentFlowId;
    c.candidates = a.candidates;
    c.signature = a.signature;
    c.urgeNodes = a.urgeNodes;
    // c.flowNodes = a.flowNodes,
    c.printId = a.printId;
    c.flowNodes = d;
    c.flowtype = b;
    return c;
  },
  getfiledownloadURL: (a, b) => {
    if (BsyUtils.isObjectEmpty(a)) return "";

    let d = "?attname=" + a.name;

    switch (window.FX.CONST.QN_BUCKET.UPLOAD_SITE) {
      case "minio":
      case "qcloud":
      case "qn": {
        // b && (d = "?imageView2/" + b.mode + "/w/" + b.width + "/h/" + b.height)
        // if (b) {
        //     if (a.size < 20 * 1024 * 1024) //七牛文件预览大于 20M imageView2 imageMogr2 函数无法处理
        //         d += "&imageView2/" + b.mode + "/w/" + b.width + "/h/" + b.height
        // }

        if (a && a.thumbUrl) {
          if (b) {
            switch (b.width) {
              case 32:
                return a.thumbUrl;
              case 65:
                return a.thumbUrlMedium;
              case 450:
                return a.previewUrlMedium;
              case 1200:
                return a.previewUrl;
              default:
                return BsyUtils.hasImage(a) ? a.compressUrl : a.originalUrl;
            }
          } else {
            return a.originalUrl;
          }
        }

        return window.FX.CONFIG.HOST.IMAGE_HOST + "/" + a.qnKey + d;
      }
      case "ctyun": {
        d =
          "?response-content-disposition=attachment;filename=" +
          encodeURIComponent(encodeURIComponent(a.name));
        return window.FX.CONFIG.HOST.IMAGE_HOST + "/" + a.qnKey + d;
      }

      case "localftp":
      case "aliyun":
      case "huawei": {
        let routUrl = window.root_directroy ? window.root_directroy + "/" : "";
        return (
          window._bby_config.site +
          routUrl +
          "file/get/" +
          a.qnKey +
          "?filename=" +
          encodeURIComponent(a.name)
        );
      }
      default: {
        return window.FX.CONFIG.HOST.IMAGE_HOST + "/" + a.qnKey;
      }
    }
    return "";

    // switch (a.bucket) {
    //     case BsyConfig().CONST.QN_BUCKET.PRIVATE_FILE:
    //     case BsyConfig().CONST.QN_BUCKET.PUBLIC_IMAGE: {
    //         e && (d = "?imageView2/" + e.mode + "/w/" + e.width + "/h/" + e.height)
    //         return window.FX.CONFIG.HOST.IMAGE_HOST + "/" + a.qnKey + d
    //     }
    //     default: {
    //         e && (d = "?imageView2/" + e.mode + "/w/" + e.width + "/h/" + e.height)
    //         return window.FX.CONFIG.HOST.IMAGE_HOST + "/" + a.qnKey + d;
    //     }
    // }
  },
  redirectTo: (a, target) => {
    var url = a;
    if (url.indexOf("http") !== 0) {
      if (url.indexOf("/") !== 0) {
        url = window.rootDirectroy + "/" + a;
      } else {
        url = window.rootDirectroy + a;
      }
      if (url.indexOf("/") !== 0) {
        url = "/" + url;
      }
    }
    if (!window.rootDirectroy) {
      url = a;
    }
    if (!target) {
      if (
        window.self.frameElement &&
        window.self.frameElement.tagName == "IFRAME"
      ) {
        window.self.location.href = url;
      } else {
        if (window.top.location !== window.self.location)
          window.top.location.href = url;
        else window.location.href = url;
      }
    } else {
      window.open(url, target);
    }
    // if (window.top.location !== window.self.location)
    //     window.top.location.href = a;
    // else
    //     window.location.href = a;
  },
  getFormIcon: (forminfo) => {
    //hasCoop
    // " icon-bsy-form-" + forminfo.icon;
    let s =
      forminfo.icon <= 24
        ? " icon-bsy-form-" + (forminfo.icon || (forminfo.value && forminfo.value.icon) || "0")
        : " icon-new-bsy-form-" + (forminfo.icon || (forminfo.value && forminfo.value.icon) || "0");
    switch (forminfo.type) {
      case "dash":
      case "scenes": {
        s += " icon-bsy-dash";
        break;
      }
      default: {
        if (!forminfo.hasCoop) {
          s += " icon-bsy-form-flow";
        } else {
          s += " icon-bsy-form";
        }
      }
    }
    return s;
  },

  getDashFilterTypeByFieldType: (t, e) => {
    switch (t) {
      case "text_filter":
        switch (e) {
          case "text":
          case "radiogroup":
          case "combo":
          case "sn":
            return "text_filter";
          case "textarea":
            return "textarea_filter";
          case "checkboxgroup":
          case "combocheck":
            return "combocheck_filter";
          case "user":
            return "user_filter";
          case "usergroup":
            return "usergroup_filter";
          default:
            return "text_filter";
        }
      case "dept_filter":
        switch (e) {
          case "dept":
            return "dept_filter";
          case "deptgroup":
            return "deptgroup_filter";
          default:
            return "dept_filter";
        }
      default:
        return t;
    }
  },
  _toDeptUser: (data, type) => {
    if (!data) {
      return "";
    }
    if (data._id === "anonymous" && data.nickname === "anonymous") {
      return React.language("widget.user.anonymous");
    }
    let name =
      data.inputName || data.nickname || data.name || data.id || data._id;
    //window.FX.STATIC.user_corps.mode === "common"

    if (data.status === -2) {
      switch (data.mode) {
        case "member":
          if (
            window.FX.STATIC.user_corps &&
            window.FX.STATIC.user_corps.mode &&
            window.FX.STATIC.user_corps.mode === "common"
          )
            name += " (" + React.language("resigned") + ")";
          break;
        case "outsider":
          name += " (" + React.language("deleted") + ")";
          break;
        default:
          if (type === "outsiderMember") {
            name += " (" + React.language("deleted") + ")";
          } else if (type === "user") {
            if (
              window.FX.STATIC.user_corps &&
              window.FX.STATIC.user_corps.mode &&
              window.FX.STATIC.user_corps.mode === "common"
            )
              name += " (" + React.language("resigned") + ")";
          }
      }
    }

    if (data.status === -99) {
      name += " (" + React.language("deleted") + ")";
    }

    return name;
  },
  showAjaxTip: (res, sucess, error) => {
    if (res.hasOwnProperty("error_code")) {
      var title = React.language("form.submit.fail.charger");
      var msg = React.language("form.submit.fail.charger.desc");
      if (res.error_code === BsyConfig().CONST.FLOW_FAIL_CODE.FORWARD_COND) {
        title = React.language("form.submit.fail.cond");
        msg = res.error_info; //;
      } else if (res.error_code === BsyConfig().CONST.FLOW_FAIL_CODE.BACK) {
        title = React.language("form.submit.fail.back");
        msg = React.language("form.submit.fail.charger.desc");
      } else if (
        res.error_code === BsyConfig().CONST.FLOW_FAIL_CODE.FORWARD_SUBFLOW
      ) {
        title = React.language("form.submit.fail.subflow");
        msg = React.language("form.submit.fail.subflow.desc");
      } else if (
        res.error_code === BsyConfig().CONST.FLOW_FAIL_CODE.FORWARD_approval
      ) {
        title = React.language("form.submit.fail.approval");
        msg = React.language("form.submit.fail.approval.desc");
      }
      BsyAlert({
        title: title,
        type: "warning",
        msg: msg,
        text4Ok: React.language("iSee"),
        text4Cancel: null,
        OkType: "blue",
        ok: () => {
          error && error();
        },
        cancel: () => {
          error && error();
        },
      });
      return;
    }
    if (res.hasOwnProperty("code")) {
      if (res.code === 200 || res.code === 0) {
        if (sucess) {
          sucess(res);
        }
        return true;
      }

      let c,
        d,
        e,
        f = null;
      if (/^71[0-9]{2}/.test(res.code)) {
        c = React.language("vip.upgrade.yes");
        d = React.language("vip.upgrade.no");
        f = function () {
          BsyUtils.redirectTo(
            window._bsy_config.site + "/dashboard/profile#/member",
            "_blank"
          );
        };

        e = React.language(res.message || res.msg);
        switch (res.code) {
          case 7117: {
            e = React.language(res.msg, {
              managers: res.managers,
              sysManagers: res.sysManagers,
            });
            break;
          }
          case 7104: {
            BsyAlert({
              title: e,
              type: "warning",
              text4Ok: React.language("ok"),
              OkType: "blue",
              text4Cancel: React.language("cancel"),
              ok: () => {
                error && error();
              },
              cancel: () => {
                error && error();
              },
            });

            return false;
          }
          default: {
            BsyAlert({
              title: res.msg,
              // msg: React.language("dismission.alert.tip1"),
              type: "query",
              text4Ok: c,
              OkType: "blue",
              text4Cancel: d,
              ok: () => {
                window.open(
                  `${window.rootDirectroy}/dashboard/profile#/member`,
                  "_blank"
                );
                error && error();
              },
              cancel: () => {
                error && error();
              },
            });

            return false;
          }
        }

        if (window.FX.STATIC.RTOKEN) {
          BsyAlert({
            title: e,
            text4Cancel: "",
            type: "query",
            OkType: "blue",
            text4Ok: React.language("ok"),
            ok: () => {
              error && error();
            },
            cancel: () => {
              error && error();
            },
          });
        } else {
          BsyAlert({
            title: e,
            text4Ok: c,
            type: "query",
            OkType: "blue",
            text4Cancel: d,
            ok: () => {
              f && f();
            },
          });
        }
        error && error(res);
        return false;
      } else if (res.code === 400) {
        tipAlert({
          type: "error",
          msg: res.msg,
        });
        error && error(res);
        return false;
      } else if (res.code === 4002) {
        error && error(res);
        return false;
      } else {
        tipAlert({
          type: "error",
          msg: !langCN[res.msg] ? res.msg : React.language(res.msg),
        });
        error && error(res);
      }
      return false;
    } else {
      if (sucess) {
        sucess(res);
      }
    }
    return true;
  },
  deBounce: (func, wait) => {
    let timeOut = null;
    return function (...args) {
      clearTimeout(timeOut); //一定要清除定时器
      timeOut = setTimeout(() => {
        func(...args);
      }, wait);
    };
  },
  elemoffset: (elem) => {
    let rect, win;

    if (!elem) {
      return;
    }

    // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
    // Support: IE <=11 only
    // Running getBoundingClientRect on a
    // disconnected node in IE throws an error
    if (!elem.getClientRects().length) {
      return {
        top: 0,
        left: 0,
      };
    }

    // Get document-relative position by adding viewport scroll to viewport-relative gBCR
    rect = elem.getBoundingClientRect();
    win = elem.ownerDocument.defaultView;
    return {
      top: rect.top + win.pageYOffset,
      left: rect.left + win.pageXOffset,
    };
  },
  ajax: (b, c, d, e) => {
    post(b.url, b.data)
      .then((res) => {
        c && c(res);
        e && e(res);
      })
      .catch((res) => {
        d && d(res);
        e && e(res);
      });
  },
  excelDate2Date: (excelSerialNumber) => {
    // excel中的时间 转换成js时间,当前所在时区的
    const excelDayOffset = 25569;
    const millisecondsInDay = 86400000;
    const timezoneOffsetMs = (new Date().getTimezoneOffset() / 60) * 3600000;

    const unixTimestamp = Math.round(
      (excelSerialNumber - excelDayOffset) * millisecondsInDay + timezoneOffsetMs
    );
    return new Date(unixTimestamp)
  },
  isExcelDateNumber: (value) => {

    return typeof value === 'number' &&
      value > 0 &&
      value < 2958466;
  },
  date2Str: (a, b) => {
    if (!a) return "";

    let c = (b = b || "yyyy-MM-dd").length,
      d = "";
    if (c > 0) {
      let e = b.charAt(0);
      let f = 0,
        g = e,
        h = 1;
      for (h = 1; h < c; h++) {
        let i = b.charAt(h);

        if (e !== i) {
          d += BsyUtils._compileDateFormat(
            {
              char: e,
              str: g,
              len: h - f,
            },
            a
          );
          e = i;
          f = h;
          g = e;
        } else {
          g += i;
        }

        // e !== i ? (d += BsyUtils._compileDateFormat({
        //         char: e,
        //         str: g,
        //         len: h - f
        //     }, a),
        //     e = i,
        //     f = h,
        //     g = e) : g += i
      }
      d += BsyUtils._compileDateFormat(
        {
          char: e,
          str: g,
          len: c - f,
        },
        a
      );
    }
    return d;
  },
  _getFlowState: (type) => {
    switch (parseInt(type)) {
      case 0: {
        return React.language("flow.state.inProcess");
      }
      case 1: {
        return React.language("flow.node.end");
      }
      case 2: {
        return React.language("flow.state.closed");
      }
      default: {
        return "";
      }
    }
  },
  detectOS: function () {
    let ua = navigator.userAgent;
    if (ua.indexOf("iPad") > -1) {
      return "iPad";
    }

    let isWin =
      navigator.platform === "Win32" || navigator.platform === "Windows";
    let isMac =
      navigator.platform === "Mac68K" ||
      navigator.platform === "MacPPC" ||
      navigator.platform === "Macintosh" ||
      navigator.platform === "MacIntel";

    if (isMac) return "Mac";
    let isUnix = navigator.platform === "X11" && !isWin && !isMac;
    if (isUnix) return "Unix";
    let isLinux = String(navigator.platform).indexOf("Linux") > -1;
    if (isLinux) return "Linux";
    if (isWin) {
      // let iswin2K = userAgent.indexOf("windows NT 5.0") > -1 || userAgent.indexOf("windows 2000") > -1;
      // if (iswin2K) return "win2000";
      // let iswinXP = userAgent.indexOf("windows NT 5.1") > -1 || userAgent.indexOf("windows XP") > -1;
      // if (iswinXP) return "winXP";
      // let iswin2003 = userAgent.indexOf("windows NT 5.2") > -1 || userAgent.indexOf("windows 2003") > -1;
      // if (iswin2003) return "win2003";
      // let iswinVista = userAgent.indexOf("windows NT 6.0") > -1 || userAgent.indexOf("windows Vista") > -1;
      // if (iswinVista) return "winVista";
      // let iswin7 = userAgent.indexOf("windows NT 6.1") > -1 || userAgent.indexOf("windows 7") > -1;
      // if (iswin7) return "win7";
      // let iswin10 = userAgent.indexOf("windows NT 10.0") > -1 || userAgent.indexOf("windows 10") > -1;
      // if (iswin10) return "win10";
      return "Win";
    }
    return "other";
  },
  completeDate: (value) => {
    return value < 10 ? "0" + value : value;
  },
  getNowDateDay: (nowDate) => {
    let char = "-";
    if (nowDate == null) {
      nowDate = new Date();
    }
    let day = nowDate.getDate();
    let month = nowDate.getMonth() + 1; //注意月份需要+1
    let year = nowDate.getFullYear();
    //补全0，并拼接
    return (
      year +
      char +
      BsyUtils.completeDate(month) +
      char +
      BsyUtils.completeDate(day)
    );
  },
  getNowDateTime: (nowDate) => {
    if (nowDate == null) {
      nowDate = new Date();
    }
    let colon = ":";
    let h = nowDate.getHours();
    let m = nowDate.getMinutes();
    let s = nowDate.getSeconds();
    //补全0，并拼接
    return (
      BsyUtils.getNowDateDay(nowDate) +
      " " +
      BsyUtils.completeDate(h) +
      colon +
      BsyUtils.completeDate(m) +
      colon +
      BsyUtils.completeDate(s)
    );
  },
  UUID: function (a) {
    return a
      ? (a ^ ((16 * Math.random()) >> (a / 4))).toString(16)
      : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, this.UUID);
  },
  _compileDateFormat: (a, b) => {
    let c = a.str,
      d = a.len,
      e = a.char;
    switch (e) {
      case "E":
        c =
          d > 2
            ? Date._DN[b.getDay()]
            : d > 1
              ? Date._SDN[b.getDay()]
              : b.getDay() + "";
        break;
      case "y":
        c = d <= 3 ? (b.getFullYear() + "").slice(2, 4) : b.getFullYear();
        break;
      case "M":
        c =
          d > 2
            ? Date._MN[b.getMonth()]
            : d < 2
              ? b.getMonth() + 1
              : BsyUtils.leftPad(b.getMonth() + 1 + "", 2, "0");
        break;
      case "d":
        c = d > 1 ? BsyUtils.leftPad(b.getDate() + "", 2, "0") : b.getDate();
        break;
      case "h":
        let f = b.getHours() % 12;
        0 === f && (f = 12);
        c = d > 1 ? BsyUtils.leftPad(f + "", 2, "0") : f;
        break;
      case "H":
        c = d > 1 ? BsyUtils.leftPad(b.getHours() + "", 2, "0") : b.getHours();
        break;
      case "m":
        c =
          d > 1
            ? BsyUtils.leftPad(b.getMinutes() + "", 2, "0")
            : b.getMinutes();
        break;
      case "s":
        c =
          d > 1
            ? BsyUtils.leftPad(b.getSeconds() + "", 2, "0")
            : b.getSeconds();
        break;
      case "a":
        c = b.getHours() < 12 ? "am" : "pm";
        break;
      default:
        c = a.str;
    }
    return c;
  },
  createFileThumb: function (t, i, name) {
    i = i || "normal";
    //
    let b =
      [
        "ppt",
        "pptx",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "zip",
        "rar",
        "csv",
        "txt",
        "pdf",
        "mp4",
        "webm",
        "ogg",
        "mov",
        "png",
        "jpg",
        "jpeg",
        "gif",
      ].indexOf(t) > -1
        ? t
        : "other";
    return React.createElement("i", {
      className: "icon-bsy-" + b,
      title: name,
    });
  },
  find: function (t, i) {
    let a = null;
    BsyUtils.isFunction(i) &&
      BsyUtils.forEach(t, function (t, e) {
        if (i(e)) return (a = e), !1;
      });
    return a;
  },
  rgbaToRGB: (rgba_color_red, rgba_color_green, rgba_color_blue, alpha) => {
    let red = (1 - alpha) * 255 + alpha * rgba_color_red;
    let green = (1 - alpha) * 255 + alpha * rgba_color_green;
    let blue = (1 - alpha) * 255 + alpha * rgba_color_blue;
    return "rgb(" + red + "," + green + "," + blue + ")";
  },
  hexToRgbJson: function (t) {
    if (!/^#[0-9a-fA-F]{6}$/.test(t)) {
      if (t.indexOf("rgb") !== -1) {
        let y = t.split("(")[1];
        y = y.split(")")[0];
        y = y.split(",");
        return {
          r: y[0],
          g: y[1],
          b: y[2],
        };
      } else {
        return {};
      }
    } else {
      let e = [];
      for (let i = 1; i < 7; i += 2) e.push(parseInt("0x" + t.slice(i, i + 2)));
      return {
        r: e[0],
        g: e[1],
        b: e[2],
      };
    }
  },
  TextTag: (opt) => {
    let element = document.createElement("div");
    let defaultProps = {
      ...{
        baseCls: "fui-text-tag",
        size: "middle",
        bgColor: "",
        fontColor: "",
        fontSize: "",
        maxWidth: "",
        borderColor: "",
        multiLine: !1,
        text: "",
        html: null,
        borderRadius: "",
      },
      ...opt,
    };

    let t,
      e = defaultProps,
      i = e.fontColor;
    if (!i && e.bgColor) {
      t = BsyUtils.hexToRgbJson(e.bgColor);
      i = BsyUtils.isDarkColor(t.r, t.g, t.b) ? "#fff" : "#333";
    }

    // !i && e.bgColor && (t = BsyUtils.hexToRgbJson(e.bgColor),
    //     i = BsyUtils.isDarkColor(t.r, t.g, t.b) ? "#fff" : "#333");

    let a = e.borderColor || e.bgColor || "#D9D9D9";
    // let n = {
    //     "background-color": e.bgColor,
    //     color: i,
    //     "max-width": e.maxWidth,
    //     border: "1px solid " + a,
    //     "border-radius": e.borderRadius,
    //     "font-size": e.fontSize
    // };

    element.classList.add(defaultProps.baseCls);
    element.classList.add(defaultProps.size);
    element.classList.add(
      defaultProps.multiLine ? "multi-line" : "single-line"
    );
    if (defaultProps.html) element.innerHTML = defaultProps.text;
    else {
      element.innerText = defaultProps.text;
    }

    element.style.background = e.bgColor;
    element.style.color = i;
    element.style.maxWidth = e.maxWidth + "px";
    element.style.border = "1px solid " + e.bgColor;
    element.style.borderRadius = e.borderRadius;
    element.style.fontSize = e.fontSize + "px";

    return element;
  },
  _dynamicTime: (time) => {
    let r = {
      t1: "", // 空当前 -过去 +未来
      count: 1, // 数量 默认为1 当前最大值也为1 过去与未来最大值99
      type: "d", // d天 w周 m月
    };
    if (!time) {
      return r;
    }

    //处理 +1s +1m +1h  -1s -1m -1h
    let val = Math.abs(parseInt(time));
    r.count = val;
    if (time.indexOf("M") > -1) {
      r.type = "M";
    } else if (time.indexOf("w") > -1) {
      r.type = "w";
    } else if (time.indexOf("d") > -1) {
      r.type = "d";
    } else {
      r.type = "d";
    }

    let type = time.charCodeAt(0);
    if (type === 43) {
      r.t1 = "+";
    } else if (type === 45) {
      r.t1 = "-";
    }
    return r;
  },

  _dynamicStr: (d) => {
    if (!d) {
      return "";
    }
    let obj = BsyUtils._dynamicTime(d);
    let str = "";
    switch (obj.t1) {
      case "+": {
        str = React.language("future");
        break;
      }
      case "-": {
        str = React.language("past");
        break;
      }
      default:
        str = React.language("current");
        break;
    }
    str += Math.abs(obj.count);
    switch (obj.type) {
      case "M": {
        str += React.language("month");
        break;
      }
      case "w": {
        str += React.language("week");
        break;
      }
      default:
        str += React.language("day");
        break;
    }
    return str;
  },
  getColorTagList: (a) => {
    if (!a || !a.field || BsyUtils.isEmpty(a.values)) return "";
    let n = a.field.items,
      s = document.createElement("div"); // $("<div />");
    s.classList.add(a.className || "");

    BsyUtils.forEach(a.values, (t, e) => {
      if (!e) return !0;
      let i = BsyUtils.find(n, (t) => {
        return t.text === e;
      });
      i = i ? i.color : "";
      i = BsyUtils.TextTag({
        text: BsyUtils.escapeHtmlSpecialChar(e),
        bgColor: i,
        multiLine: a.multiLine,
      });
      if (a.tagCss) {
        BsyUtils.forEach(a.tagCss, (index, data) => {
          i.style[index] = data;
        });
      }
      s.appendChild(i);
    });
    return s;
  },
  hasExtension: function (b) {
    let extendSet = null;
    let mode = "event";
    //b.options.funMode
    if (b.hasOwnProperty("extendSet")) {
      mode = b.extendSet.funMode;
      extendSet = b.extendSet;
    } else {
      mode = b.funMode;
    }

    //模块
    if (mode == "module") {
      let validatormode = true;
      let module = null;
      let libs = null;
      if (b.hasOwnProperty("extendSet")) {
        module = extendSet.module;
        libs = extendSet.libs;
      } else {
        module = b.module;
        libs = b.libs;
      }

      BsyUtils.forEach(module, function (a1, b1) {
        if (BsyUtils.isObjectEmpty(b1)) {
          validatormode = false;
          return !1;
        }
      });

      if (
        libs &&
        libs.length > 0 &&
        module &&
        (module || (BsyUtils.isArray(module) && validatormode))
      ) {
      } else {
        //功能模块 设置参数，不触发后端事件

        return false;
      }
    } else if (mode == "datahelp") {
      if (!BsyUtils.isObjectEmpty(extendSet.datahelpids)) {
      } else {
        //功能模块 设置参数，不触发后端事件
        return false;
      }
    } else if (mode == "formEvent") {
      if (!BsyUtils.isObjectEmpty(extendSet.events)) {
      } else {
        //功能模块 设置参数，不触发后端事件
        return false;
      }
    } else if (mode == "all") {
      var validatormode = true;
      var module = [];
      var libs = [];
      var events = [];
      var backEvents = false;
      var datahelpids = null;
      var status = false;

      if (b.hasOwnProperty("extendSet")) {
        datahelpids = extendSet.datahelpids || [];
        module = extendSet.module || [];
        libs = extendSet.libs || [];
        backEvents = extendSet.backEvents || false;
        status = extendSet.status || false;
        events = extendSet.events || [];
      }

      BsyUtils.forEach(module, function (a1, b1) {
        if (BsyUtils.isObjectEmpty(b1)) {
          validatormode = false;
          return !1;
        }
      });
      if (
        status == true &&
        (datahelpids.length > 0 ||
          events.length > 0 ||
          libs.length > 0 ||
          backEvents == true)
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
    return true;
  },
  _dingCreate: function (opt) {
    try {
      React.axios("/team/thirdGetSignPackage", {
        url: window.location.href,
      }).then((res) => {
        console.log(res.data)
        window.dd.config(res.data);
        window.dd.ready(() => {
          window.dd && window.dd.biz.ding.create(opt)
        });
        window.dd.error((res) => {
          console.log(res)
        });
      })


    } catch (e) {
      alert(JSON.stringify(e))
    }

  },
  copyToClipboard: (t, e) => {
    if (t && t.length) {
      let i = document.createElement("textarea");
      i.style.background = "transparent";
      i.style.color = "transparent";
      i.value = t;
      document.body.appendChild(i);
      i.select();
      let a;
      try {
        a = document.execCommand("copy");
      } catch (t) {
        a = !1;
      }
      document.body.removeChild(i);
      e && e();
    }
  },
  getDateDN: () => {
    return [
      React.language("date.sunday"),
      React.language("date.monday"),
      React.language("date.tuesday"),
      React.language("date.wednesday"),
      React.language("date.thursday"),
      React.language("date.friday"),
      React.language("date.saturday"),
    ];
  },
  getDateSDN: () => {
    return [
      React.language("date.sunday.short"),
      React.language("date.monday.short"),
      React.language("date.tuesday.short"),
      React.language("date.wednesday.short"),
      React.language("date.thursday.short"),
      React.language("date.friday.short"),
      React.language("date.saturday.short"),
    ];
  },
  getCustomDateSDN: () => {
    return [
      React.language("date.monday.custom"),
      React.language("date.tuesday.custom"),
      React.language("date.wednesday.custom"),
      React.language("date.thursday.custom"),
      React.language("date.friday.custom"),
      React.language("date.saturday.custom"),
      React.language("date.sunday.custom"),
    ];
  },
  getDateMN: () => {
    return [
      React.language("date.january"),
      React.language("date.february"),
      React.language("date.march"),
      React.language("date.april"),
      React.language("date.may"),
      React.language("date.june"),
      React.language("date.july"),
      React.language("date.august"),
      React.language("date.september"),
      React.language("date.october"),
      React.language("date.november"),
      React.language("date.december"),
    ];
  },
  isWeiXin: () => {
    if (
      window.FX.STATIC.user_corps.mode &&
      window.FX.STATIC.user_corps.mode === "weixin"
    ) {
      return !0;
    }
    return !1;
  },
  isQyWinxin: () => {
    if (
      window.FX.STATIC.user_corps.mode &&
      window.FX.STATIC.user_corps.mode === "qyweixin"
    ) {
      return !0;
    }
    return !1;
  },
  isDingding: () => {
    if (
      window.FX.STATIC.user_corps.mode &&
      window.FX.STATIC.user_corps.mode === "dingding"
    ) {
      return !0;
    }
    return !1;
  },
  isFeishu: () => {
    if (
      window.FX.STATIC.user_corps.mode &&
      window.FX.STATIC.user_corps.mode === "feishu"
    ) {
      return !0;
    }
    return !1;
  },
  isTripartite: () => {
    if (
      BsyUtils.isWeiXin() ||
      BsyUtils.isQyWinxin() ||
      BsyUtils.isDingding() ||
      BsyUtils.isFeishu()
    ) {
      return !0;
    }
    return !1;
  },
  isDingdingBrowser: () => {
    if (navigator.userAgent.indexOf("DingTalk") > -1) {
      return !0;
    }
    return !1;
  },
  //获取钉钉自动登陆的url
  getDingdingLoginUrl: function (cb) {
    React.axios("/sso/getJumpUrl", {
      url: window.location.href,
    }).then((res) => {
      cb && cb(res.data);
    });

    // FX.Utils.dataAjax({
    //     url: "/sso/getJumpUrl",
    //     data:
    // }, function (data) {
    //     cb && cb(data)
    // }, null);
  },
  isWechatBrowser: function () {
    if (navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1) {
      return !0;
    }
    return !1;
  },
  isWechatWorkBrowser: function () {
    if (navigator.userAgent.toLowerCase().indexOf("wxwork") > -1) {
      return !0;
    }
    return !1;
  },
  // mac 系统下的企业微信客户端要单独处理
  isMacWechatWorkBrowser: function () {
    if (
      navigator.userAgent.toLowerCase().indexOf("wxwork") > -1 &&
      navigator.userAgent.toLowerCase().indexOf("mac") > -1
    ) {
      return !0;
    }
    return !1;
  },
  isFugouAppBrowser: () => {
    if (
      navigator.userAgent
        .toLowerCase()
        .indexOf("com.cispirit.wisdomeducation") > -1
    ) {
      return !0;
    }
    return !1;
  },
  //普通账号
  isCommon: () => {
    if (
      window.FX.STATIC.user_corps.mode &&
      window.FX.STATIC.user_corps.mode === "common"
    ) {
      return !0;
    }
    return !1;
  },
  isNormalUser: () => {
    if (
      window.FX.STATIC.user_corps.isCorpOwn ||
      window.FX.STATIC.user_corps.isSysManager ||
      window.FX.STATIC.user_corps.isSubAdmin
    ) {
      return !1;
    }
    return !0;
  },
  //是否是外部联系人
  isOutdiser: () => {
    if (
      window.FX.STATIC.user_corps.member_corp_type &&
      window.FX.STATIC.user_corps.member_corp_type === "outsider"
    ) {
      return !0;
    }
    return !1;
  },
  AmapError: () => {
    return (
      <div
        className="bsy_form_item_disable"
        data-watermark={React.language("content.empty")}
      >
        {React.language("amap.sdk.load.fail")}
      </div>
    );
  },
  isCorpOwn: () => {
    return !!window.FX.STATIC.user_corps.isCorpOwn;
  },
  insertArrayIntoArray: (originalArray, insertIndex, arrayToInsert) => {
    originalArray.splice(insertIndex, 0, ...arrayToInsert);
  },
  isSysManager: () => {
    return !!window.FX.STATIC.user_corps.isSysManager;
  },
  isSubAdmin: () => {
    return !!window.FX.STATIC.user_corps.isSubAdmin;
  },
  isMemberManage: () => {
    return !!window.FX.STATIC.user_corps.memberManage;
  },
  trim: (str) => {
    return str.replace(/^(\s|\xA0)+|(\s|\xA0)+$/g, "");
  },
  transformToTreeFormat: (b) => {
    let simpleData = {
      enable: true,
      idKey: "departmentId",
      pIdKey: "parentId",
    };
    var c,
      d,
      e = simpleData.idKey,
      f = simpleData.pIdKey,
      g = "children";
    if (!e || "" == e || !b) return [];
    if (Array.isArray(b)) {
      var h = [],
        i = [];
      for (c = 0, d = b.length; c < d; c++) {
        i[b[c][e]] = b[c];
      }

      for (c = 0, d = b.length; c < d; c++) {
        if (i[b[c][f]] && b[c][e] != b[c][f]) {
          i[b[c][f]][g] || (i[b[c][f]][g] = []);

          b[c].title = b[c].name;
          b[c].key = b[c].departmentId;
          i[b[c][f]][g].push(b[c]);
        } else {
          b[c].title = b[c].name;
          b[c].key = b[c].departmentId;
          h.push(b[c]);
        }
      }
      return h;
    }
    b.title = b.name;
    b.key = b.departmentId;
    return [b];
  },
  getSpanTextWidth: (text, font, fontWeight) => {
    let span = document.createElement("span");
    span.style.fontSize = font;
    span.style.fontWeight = fontWeight || "normal";
    span.style.visibility = "hidden";
    span.textContent = text;
    document.body.appendChild(span);
    let width = span.offsetWidth;
    span.remove();
    return width;
  },
  makeFont: (style) => {
    let font = "";
    if (style.fontSize || style.fontFamily || style.fontWeight) {
      let fontSize = "";
      if (
        typeof style.fontSize === "string" &&
        (style.fontSize.indexOf("px") !== -1 ||
          style.fontSize.indexOf("rem") !== -1 ||
          style.fontSize.indexOf("em") !== -1)
      ) {
        fontSize = style.fontSize;
      } else if (!isNaN(+style.fontSize)) {
        fontSize = style.fontSize + "px";
      } else {
        fontSize = "12px";
      }
      font = [
        style.fontStyle,
        style.fontWeight,
        fontSize,
        style.fontFamily || "sans-serif",
      ].join(" ");
    }
    return (font && font.trim()) || style.textFont || style.font;
  },
  getTextPixelWith: (text, fontStyle) => {
    fontStyle.fontSize = parseInt(fontStyle.fontSize);
    fontStyle.fontFamily = fontStyle.fontFamily || "verdana";
    let font = BsyUtils.makeFont(fontStyle);
    let canvas = document.createElement("canvas"); // 创建 canvas 画布
    let context = canvas.getContext("2d"); // 获取 canvas 绘图上下文环境

    context.font = font; // 设置字体样式，使用前设置好对应的 font 样式才能准确获取文字的像素长度
    let dimension = context.measureText(text); // 测量文字
    return dimension.width;
  },
  getTextWidth: function (text, font) {
    font = font || " normal 12px verdana  ";
    let canvas =
      this.canvas || (this.canvas = document.createElement("canvas"));
    let context = canvas.getContext("2d");
    context.font = font;
    let metrics = context.measureText(text);
    return metrics.width;
  },
  getElTextWidth: function (text, font) {
    let span = document.createElement("span");
    span.style.fontSize = font;
    span.style.visibility = "hidden";
    span.textContent = text;
    document.body.appendChild(span);
    let width = span.offsetWidth;
    // console.log(span.offsetWidth);
    span.remove();
    return width;
  },
  getGanttZoomlevel: function (level) {
    return BsyConfig().CONST.GanttMode[parseInt(level)];
  },
  getGanttZoomlevelName: function (level) {
    return BsyConfig().CONST.GanttModeName[parseInt(level)];
  },
  isSupportPdf: function () {
    return "undefined" != typeof navigator.mimeTypes["application/pdf"];
  },
  Store: {
    has: (a) => {
      return void 0 !== BsyUtils.Store.get(a);
    },

    transact: (a, b, c) => {
      if (null == c) {
        c = b;
        b = null;
      }
      if (null == b) {
        b = {};
      }
      let d = BsyUtils.Store.get(a, b);
      c(d);
      BsyUtils.Store.set(a, d);

      // null == c && (c = b,
      //     b = null ),
      // null == b && (b = {});
      // let d = this.get(a, b);
      // c(d),
      // this.set(a, d)
    },
    getAll: () => {
      let a = {};
      return (
        BsyUtils.Store.for(function (b, c) {
          a[b] = c;
        }),
        a
      );
    },
    storage: window.localStorage,
    set: (a, b) => {
      if (void 0 === b) return BsyUtils.Store.remove(a);
      try {
        BsyUtils.Store.storage.setItem(a, BsyUtils.Store.serialize(b));
      } catch (a) {
        return;
      }
      return b;
    },
    get: (a, b) => {
      let c = BsyUtils.Store.deserialize(BsyUtils.Store.storage.getItem(a));
      return void 0 === c ? b : c;
    },
    remove: (a) => {
      BsyUtils.Store.storage.removeItem(a);
    },
    clear: () => {
      BsyUtils.Store.storage.clear();
    },
    for: (a) => {
      for (let b = 0; b < BsyUtils.Store.storage.length; b++) {
        let c = BsyUtils.Store.storage.key(b);
        a(c, BsyUtils.Store.get(c));
      }
    },
    serialize: (a) => {
      return JSON.stringify(a);
    },
    deserialize: (a) => {
      if ("string" == typeof a)
        try {
          return JSON.parse(a);
        } catch (b) {
          return a || void 0;
        }
    },
    getKey: (e, t) => {
      let i = "";
      switch (e) {
        case "paramFields":
        case "showFields":
        case "metaFields":
        case "formDataShowFields":
          i = [e, t.appId, t.entryId, t.groupId].join("");
          break;
        case "authGroup":
          i = [e, t.appId, t.entryId].join("");
          break;
        case "flowCenterFilter":
          i = [
            e,
            t.appId,
            window.FX.STATIC?.corpId,
            window.FX.STATIC.user._id,
          ].join("");
          break;
        case "formData":
          i =
            window.FX.STATIC.user && !window.FX.STATIC.FTOKEN
              ? [e, t.appId, t.entryId, window.FX.STATIC.user._id].join("")
              : [e, t.appId, t.entryId].join("");
          break;
        case "filterSticky":
        case "filterTopSticky":
        case "filterValue":
        case "RecyclefilterSticky":
        case "RecyclefilterValue":
        case "searchValue":
        case "itemsPerPage":
          i = [e, t.appId, t.entryId, t.groupId, t.authGroupId, t.ext].join("");
          break;
        case "modulesloglimit":
        case "usercontlimit":
        case "dashColors":
          i = [e, t.userId].join("");
          break;
        case "dashShowFields":
          i = [e, t.appId, t.entryId, t.widgetId, t.formId].join("");
          break;
        case "colSizeMap":
          i = [e, t.appId, t.entryId, t.widgetId].join("");
          break;
        case "DataManagercolSizeMap":
        case "DataManagerShowFields":
          i = [e, t.appId, t.entryId].join("");
          break;
        case "qrStyle":
          i = [e, t.appId, t.entryId].join("");
          break;
        case "datafullscreen":
          i = [e, t.appId, t.entryId].join("");
          break;
        case "flowAccessFilter":
          i = [e, t.appId, t.flowtype].join("");
          break;
        case "importStartFlow":
          i = [e, t.appId, t.entryId].join("");
          break;
        case "ganttInfoSizeMap":
          i = [e, t.appId, t.entryId, t.widgetId].join("");
          break;
        case "dashboard":
          i = [e, t.appId, t.entryId, t.widgetId].join("");
          break;
        case "dashboardShowFields":
          i = [e, t.appId, t.entryId, t.widgetId, t.authGroupId].join("");
          break;
        case "dashboardColSizeMap":
          i = [e, t.appId, t.entryId, t.widgetId, t.authGroupId].join("");
          break;
        default:
          if (t) {
            if (t.widgetId && t.authGroupId)
              i = [e, t.appId, t.entryId, t.widgetId, t.authGroupId].join("");
            else if (t.widgetId)
              i = [e, t.appId, t.entryId, t.widgetId].join("");
            else if (t.authGroupId)
              i = [e, t.appId, t.entryId, t.authGroupId].join("");
            else i = [e, t.appId, t.entryId].join("");
          } else {
            i = t;
          }
      }
      return i;
    },
  },
  Vip: {
    _getPack: function () {
      if (!window.FX.STATIC.VIP_PACK) {
        if (!window.FX.STATIC.APPID) return {};
        window.FX.Utils.ajax(
          {
            url: "/team/get_vip_pack",
            data: {
              appId: window.FX.STATIC.APPID,
              entryId: window.FX.STATIC.ENTRYID,
              fx_access_token: window.FX.STATIC.QTOKEN
                ? window.FX.STATIC.QTOKEN
                : undefined,
              fx_access_type: window.FX.STATIC.QTOKEN
                ? "form_public"
                : undefined,
            },
            async: !1,
          },
          function (b) {
            window.FX.STATIC.VIP_PACK = { ...b.VIP_PACK };
            if (b.user_corps) {
              window.localDevInfo = {
                user_corps: b.user_corps,
              }
            }
          },
          function () {
            window.FX.STATIC.VIP_PACK = {};
          }
        );
      }
      return window.FX.STATIC.VIP_PACK;
    },
    clear: function () {
      window.FX.STATIC.VIP_PACK = null;
    },
    hasCustomTheme: function () {
      return this._getPack()[window.FX.CONST.VIP_MODULE.CUSTOM_THEME] == 1;
    },
    hasSubmitPrompt: function () {
      return (
        this._getPack()[window.FX.CONST.VIP_MODULE.SUBMIT_PROMPT] === "vip"
      );
    },
    hasMultipleModule: function () {
      let vippack = this._getPack();
      return vippack[window.FX.CONST.VIP_MODULE.MODULE_NUM];
    },
    hasMultipleSchedule: function () {
      let vippack = this._getPack();
      return vippack[window.FX.CONST.VIP_MODULE.SCHEDULE_NUM];
    },
    hasMultipleDataHelper: function () {
      let vippack = this._getPack();
      return vippack[window.FX.CONST.VIP_MODULE.DATAHELPER_NUM];
    },
    showUpgradeTip: function (a, b) {
      if (!BsyUtils.isObjectEmpty(a)) {
        // if (BsyUtils.isWpsWebView())
        //     return void this._showWpsTip(a.code, a.message || b);

        let c,
          d,
          e,
          f = null;
        if (/^71[0-9]{2}/.test(a.code)) {
          c = React.language("vip.upgrade.yes");
          d = React.language("vip.upgrade.no");
          f = function () {
            let routUrl = window.root_directroy
              ? window.root_directroy + "/"
              : "";
            BsyUtils.redirectTo(
              window._bby_config.site + routUrl + "dashboard/buy_order",
              "_blank"
            );
            return !1;
          };

          // if(a.expireDays && a.expireDays)
          // {
          //     e = React.language((a.message || a.msg)) + a.expireDays + "天后系统将会受限。";
          // }
          // else
          e = React.language(a.message || a.msg);
          switch (a.code) {
            case 7117: {
              e = React.language(a.msg, {
                managers: a.managers,
                sysManagers: a.sysManagers,
              });
              break;
            }

            case 7104: {
              window.FX.Msg.alert({
                title: e,
                text4Cancel: "",
                text4Ok: React.language("ok"),
              });
              return;
            }
            default:
          }

          if (window.FX.STATIC.RTOKEN) {
            window.FX.Msg.alert({
              title: e,
              text4Cancel: "",
              text4Ok: React.language("ok"),
            });
          } else {
            window.FX.Msg.alert({
              title: e,
              text4Ok: c,
              text4Cancel: d,
              onOk: f,
            });
          }
        } else {
          e = React.language(a.message || a.msg);
          let type = "warning";
          if (a.code === 400) {
            type = "error";
          }
          tipAlert({
            msg: e,
            type: type,
          });
        }

        // /^71[0-9]{2}/.test(a.code) ? (c = React.language("vip.upgrade.yes"),
        // d = React.language("vip.upgrade.no"),
        // f = function() {
        //     return BsyUtils.redirectTo(_bby_config.site + "/index.php?bbymember/user_purchase_management"),
        //     !1
        // }
        // ) : /^72[0-9]{2}/.test(a.code) && (c = React.language("iSee"),
        // d = ""),
        // e = a.expireDays && a.expireDays < 8 ? (a.message || a.msg) + a.expireDays + "天后系统将会受限。" : a.message || a.msg,
        // FX.Msg.alert({
        //     msg: e,
        //     text4Ok: c,
        //     text4Cancel: d,
        //     onOk: f
        // })
      }
    },

    getExcelMFS: function () {
      let vippack = this._getPack();
      return vippack[window.FX.CONST.VIP_MODULE.EXCEL_IMPORT] || 2097152;
    },
    getUploadMFS: function () {
      let vippack = this._getPack();
      return vippack[window.FX.CONST.VIP_MODULE.SINGLE_FILE] || 20971520;
    },
    hasAppBridge: function () {
      let vippack = this._getPack();
      return vippack[window.FX.CONST.VIP_MODULE.APP_BRIDGE] > 0;
    },
    hasSignature: function () {
      return this._getPack()[window.FX.CONST.VIP_MODULE.SIGNATURE] > 0;
    },
    hasDataBackup: function () {
      let vippack = this._getPack();
      return vippack[window.FX.CONST.VIP_MODULE.DATA_BACKUP] > 0;
    },
    hasFileExport: function () {
      let vippack = this._getPack();
      return vippack[window.FX.CONST.VIP_MODULE.FILE_ZIP] > 0;
    },
    getPTSize: function () {
      let vippack = this._getPack();
      return vippack[window.FX.CONST.VIP_MODULE.PRINT];
    },
  },
  date2GroupStr: function (t, e) {
    let i = "",
      a = e.split("_"),
      n = {};
    if (!t) {
      return null;
    }
    BsyUtils.forEach(a, function (e, i) {
      let a = 0 !== e;
      n[i] = BsyUtils._compileDateGroupRule(t[i], i, a);
    });
    switch (e) {
      case "year":
        i = React.language("date.year", {
          year: n.year,
        });
        break;
      case "year_quarter":
        i = React.language("date.year_quarter", {
          year: n.year,
          quarter: n.quarter,
        });
        break;
      case "year_month":
        i = React.language("date.year_month", {
          year: n.year,
          month: n.month,
        });
        break;
      case "year_week":
        i = React.language("date.year_week", {
          year: n.year,
          week: n.week,
        });
        break;
      case "year_month_day":
        i = React.language("date.year_month_day", {
          year: n.year,
          month: n.month,
          day: n.day,
        });
        break;
      default: {
        break;
      }
    }
    return i;
  },
  _compileDateGroupRule: function (t, e, i) {
    let a;
    switch (e) {
      case "year":
      case "quarter":
        a = t;
        break;
      case "month":
      case "week":
      case "day":
        a = i ? BsyUtils.leftPad(t, 2, "0") : t;
        break;
      default:
        a = "";
    }
    return a;
  },
  getFunctionName: (func) => {
    let name = null;
    if (typeof func == "function" || typeof func == "object") {
      name = ("" + func).match(/function\s*([\w\$]*)\s*\(/);
    }
    return name && name[1];
  },
  trace: function () {
    // if (!('console' in window)) {
    //     window.console = {};
    // }
    // if (!console.trace) {
    //     let stack = [],
    //         caller = arguments.callee.caller;
    //     while (caller) {
    //         stack.unshift(BsyUtils.getFunctionName(caller));
    //         caller = caller && caller.caller;
    //     }
    //     return 'functions on stack:' + '\n' + stack.join('\n');
    // } else {
    //     return console.trace()
    // }
    // window.dd = Error().stack
    console.error(Error().stack);
    return Error().stack;
  },
  verifyAppid: (id) => {
    id = id + "";
    if (id.length != 24) {
      return !1;
    }

    return true;
  },
  getDashDefaultFilterMethod: (t) => {
    let e = BsyConfig().CONST.FILTER_METHOD;
    switch (t) {
      case "text":
      case "radiogroup":
      case "combo":
      case "sn":
      case "user":
      case "dept":
      case "text_filter":
      case "radiogroup_filter":
      case "combo_filter":
      case "sn_filter":
      case "user_filter":
      case "dept_filter":
        return e.IN;
      case "textarea":
      case "phone":
      case "textarea_filter":
      case "phone_filter":
        return e.LK;
      case "checkboxgroup":
      case "combocheck":
      case "usergroup":
      case "deptgroup":
      case "address":
      case "location":
      case "checkboxgroup_filter":
      case "combocheck_filter":
      case "usergroup_filter":
      case "deptgroup_filter":
      case "address_filter":
      case "location_filter":
        return e.ALL;
      case "datetime":
      case "number":
      case "datetime_filter":
      case "number_filter":
        return e.RG;
      case "flowstate":
      case "flowstate_filter":
        return e.EQ;
      case "upload":
      case "image":
      case "signature":
      case "upload_filter":
      case "image_filter":
      case "signature_filter":
        return e.NEP;
      case "assist_prostatus":
      case "assist_prostatus_filter": {
        return e.EQ;
      }
      default:
        return e.IN;
    }
  },
  formatValue: function (val, option) {
    var a = option;
    // 这里需要考虑老格式的兼容性，在没有displayMode，以及存在format 才直接返回走格式化的效果
    if (a.tag && a.format) {
      return val;
    }
    var value = null;
    if (val) {
      if (val.hasOwnProperty("replace")) val = val.replace(/,/g, "");
    }
    value = val;

    var tmp = parseFloat(value);
    value = BsyUtils.parseNumber(value);
    if (isNaN(tmp)) {
      value = null;
    } else {
      // if (a.displayMode == 'percent') {
      //     value = new Big(value).div(100).toFixed();
      // }
    }

    if (BsyUtils.isNumber(a.precision) && value) {
      if (a.displayMode === "number") {
        if (a.notround) {
          // value = ((value * (10 ** a.precision)) << 0) / (10 ** a.precision);
          Big.RM = 0; //取消四舍五入
          let y = new Big(value);
          value = y.toFixed(a.precision);
          Big.RM = 1; //恢复默认值
        } else {
          // value = value.toFixed(a.precision);
          let y = new Big(value);
          value = y.toFixed(a.precision);
        }
      } else {
        if (a.notround) {
          // value = ((value * (10 ** (a.precision + 2))) << 0) / (10 ** (a.precision + 2));
          Big.RM = 0; //取消四舍五入
          let y = new Big(value);
          value = y.toFixed(a.precision + 2);
          Big.RM = 1; //恢复默认值
        } else {
          // value = value.toFixed(a.precision + 2);
          let y = new Big(value);
          value = y.toFixed(a.precision + 2);
        }
      }
    } else {
    }
    value = BsyUtils.fixDecimalPrecision(value);
    return value;
  },
  parseNumber: function (t) {
    t = parseFloat(t);
    return !isNaN(t) && isFinite(t) ? t : null;
  },
  toFixed: function (t, e) {
    t = BsyUtils.parseNumber(t);
    return BsyUtils.isEmpty(t) ? "" : new Big(t).toFixed(e).toString();
  },
  isValidNumber: function (t) {
    // if(num === null) {
    //     return false;
    // }
    // const t = Number(num);
    return "number" === typeof t && !isNaN(t) && isFinite(t);
  },
  num2Str: function (t, e) {
    if (BsyUtils.isEmpty(t)) return "";
    let a = null;
    if (["minute", "hour", "days", "dynamic"].includes(e)) {
      return t;
    }

    var i = t + "";
    if (
      (BsyUtils.isValidNumber(t) && (i = BsyUtils.toFixed(t)),
        BsyUtils.isEmpty(e))
    )
      return i;
    if ((a = /\[Num0\]/).test(e)) return e.replace(a, i);
    if ((a = /\[Num1\]/).test(e)) return e.replace(a, BsyUtils._num2CN(i, !1));
    if ((a = /\[Num2\]/).test(e)) return e.replace(a, BsyUtils._num2CN(i, !0));
    a = /[#0]+,?[#0]*\.?[#0]*%?/;
    let n = e.match(a);
    return n && 0 < n.length
      ? ((n = n[0]), (i = BsyUtils._numberFormat(i, n)), e.replace(a, i))
      : e;
  },
  numberFormatTime: function (value, opt) {
    var valobj = {
      value: BsyUtils.fixDecimalPrecision(value),
      text: null,
    };
    switch (opt.format) {
      case "dynamic": {
        var ct = valobj.value;
        var ceftd = Math.floor(ct / (60 * 60 * 24)); //计算天数
        var cefth = Math.floor((ct / (60 * 60)) % 24); //计算小时数
        var ceftm = Math.floor((ct / 60) % 60); //计算分钟数
        ct = "";
        if (ceftd > 0) {
          ct = ceftd + React.language("days");
        }
        if (cefth > 0) {
          ct += cefth + React.language("to.hour");
        }
        if (ceftm > 0) {
          ct += ceftm + React.language("to.minute");
        }
        if (!ct) {
          ct = 0 + React.language("to.minute");
        }
        valobj.text = ct;
        break;
      }
      case "days": {
        if (!valobj.value) {
          valobj.text = 0 + React.language("days");
        } else {
          valobj.text =
            (valobj.value / (60 * 60 * 24)).toFixed(2) + React.language("days");
          if (valobj.text == "0.00" + React.language("days")) {
            valobj.text = 0 + React.language("days");
          }
        }
        break;
      }
      case "hour": {
        if (!valobj.value) {
          valobj.text = 0 + React.language("to.hour");
        } else {
          valobj.text =
            (valobj.value / (60 * 60)).toFixed(2) + React.language("to.hour");
          if (valobj.text == "0.00" + React.language("to.hour")) {
            valobj.text = 0 + React.language("to.hour");
          }
        }
        break;
      }
      case "minute":
      default: {
        if (!valobj.value) {
          valobj.text = 0 + React.language("to.minute");
        } else {
          valobj.text =
            (valobj.value / 60).toFixed(2) + React.language("to.minute");
          if (valobj.text == "0.00" + React.language("to.minute")) {
            valobj.text = 0 + React.language("to.minute");
          }
        }
      }
    }

    return valobj;
  },
  numberFormatStr: function (t) {
    var e,
      i = "",
      a =
        ((t = t || {
          displayMode: BsyConfig().CONST.NUM_DISPLAY.NUMBER,
          precision: null,
          thousandsSeparator: !1,
        }).thousandsSeparator
          ? (i += "#,#")
          : (i += "#"),
          t.precision),
      t = t.displayMode === BsyConfig().CONST.NUM_DISPLAY.PERCENT,
      n = "0";
    if (
      (BsyUtils.isValidNumber(a) ||
        ((n = "#"),
          (e = BsyConfig().CONST.NUM_DEFAULT_PRECISION),
          (a = t ? e.PERCENT : e.NUMBER)),
        0 < a)
    ) {
      i += ".";
      for (var s = 0; s < a; s++) i += n;
    }
    return t && (i += "%"), i;
  },
  zeroPadding: function (num, length) {
    let str = num.toString();
    while (str.length < length) {
      str = "0" + str;
    }
    return str;
  },
  formatTime: function (totalSeconds) {
    const seconds = totalSeconds % 60;
    const minutes = Math.floor(totalSeconds / 60) % 60;
    const hours = Math.floor(totalSeconds / (60 * 60)) % 24;
    const days = Math.floor(totalSeconds / (60 * 60 * 24));
    return { days, hours, minutes, seconds };
  },
  /**
   *  totalSeconds  秒
   */
  convertToRemainingTime: function (totalSeconds, type) {
    const formattedTime = BsyUtils.formatTime(totalSeconds);
    const days = formattedTime.days;
    const hours = formattedTime.hours;
    const minutes = formattedTime.minutes;
    const seconds = formattedTime.seconds.toFixed(0);
    let str = "";
    switch (type) {
      case "day": {
        if (days > 0) str = `${days}` + React.language("days");
        break;
      }
      case "hour": {
        if (days > 0) str = `${days}` + React.language("days");
        if (hours > 0)
          str += `${BsyUtils.zeroPadding(hours, 2)}${React.language(
            "to.hour"
          )}`;
        break;
      }
      case "minute": {
        if (days > 0) str = `${days}` + React.language("days");
        if (hours > 0)
          str += `${BsyUtils.zeroPadding(hours, 2)}${React.language(
            "to.hour"
          )}`;
        if (minutes > 0)
          str += `${BsyUtils.zeroPadding(minutes, 2)}${React.language(
            "to.minute"
          )}`;
        break;
      }
      default: {
        if (days > 0) str = `${days}` + React.language("days");
        if (hours > 0)
          str += `${BsyUtils.zeroPadding(hours, 2)}${React.language(
            "to.hour"
          )}`;
        if (minutes > 0)
          str += `${BsyUtils.zeroPadding(minutes, 2)}${React.language(
            "to.minute"
          )}`;
        if (seconds > 0)
          str += `${BsyUtils.zeroPadding(seconds, 2)}${React.language(
            "second"
          )}`;
      }
    }
    return str;
  },
  numberFormatValue: function (value, opt) {
    let valobj = {
      value: value,
      text: null,
    };

    valobj.value = BsyUtils.toNumberString(valobj.value);
    if (!opt) {
      valobj.text = valobj.value;
      return valobj;
    }

    if (value === "") {
      valobj.text = value;
      return valobj;
    }
    valobj.value = BsyUtils.formatValue(valobj.value, opt);
    let a = opt;
    let s = "";
    let format = opt.format || "";
    if (a.formatType) {
      format = opt.format || "";
    } else if (a.displayMode) {
      format = BsyUtils.numberFormatStr(a);
    }
    // valobj.value = BsyUtils.fixDecimalPrecision(valobj.value)
    valobj.text = BsyUtils.num2Str(valobj.value, format || opt.format);
    return valobj;
  },
  getValidFilters: (t) => {
    let e = [];
    BsyUtils.forEach(t.cond, function (t, i) {
      BsyUtils.checkFilterValid(i) && e.push(i);
    });
    return {
      cond: e,
      rel: t.rel,
    };
  },
  validateIdCard: (id, backInfo) => {
    let info = {
      y: "1900",
      m: "01",
      d: "01",
      sex: "male",
      valid: false,
      length: 0,
    },
      initDate = function (length) {
        info.length = length;
        let a = length === 15 ? 0 : 2, // 15:18
          temp;
        info.y = (a ? "" : "19") + id.substring(6, 8 + a);
        info.m = id.substring(8 + a, 10 + a);
        info.d = id.substring(10 + a, 12 + a);
        info.sex = id.substring(14, 15 + a) % 2 === 0 ? "female" : "male";
        temp = new Date(info.y, info.m - 1, info.d);
        return (
          temp.getFullYear() == info.y * 1 &&
          temp.getMonth() + 1 == info.m * 1 &&
          temp.getDate() == info.d * 1
        );
      },
      back = function () {
        return backInfo ? info : info.valid;
      };
    if (typeof id !== "string") return back();
    // 18
    if (/^\d{17}[0-9x]$/i.test(id)) {
      if (!initDate(18)) return back();
      id = id.toLowerCase().split("");
      let wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
        y = "10x98765432".split(""),
        sum = 0;
      for (let i = 0; i < 17; i++) sum += wi[i] * id[i];
      if (y[sum % 11] === id.pop().toLowerCase()) info.valid = true;
      return back();
    }
    // 15
    else if (/^\d{15}$/.test(id)) {
      if (initDate(15)) info.valid = true;
      return back();
    } else {
      return back();
    }
  },
  checkFilterValid: (t) => {
    let e = BsyConfig().CONST.FILTER_METHOD;
    switch (t.type) {
      case "address":
        switch (t.method) {
          case e.ALL:
          case e.NIN:
            return !BsyUtils.isObjectEmpty(t.value);
          default:
            return !0;
        }
      case "dept":
      case "flowcreator":
      case "user":
        switch (t.method) {
          case e.EP:
          case e.NEP:
            return !0;
          default:
            return (
              !BsyUtils.isObjectEmpty(t.value) ||
              t.hasEmpty ||
              t.hasCurrentUser ||
              t.hasCurrentDept ||
              t.hasCurrentSubDept ||
              t.hasCurrentParDept ||
              !BsyUtils.isObjectEmpty(t.parentDepts)
            );
        }
      case "deptgroup":
      case "usergroup":
        switch (t.method) {
          case e.EP:
          case e.NEP:
            return !0;
          default:
            return (
              !BsyUtils.isObjectEmpty(t.value) ||
              t.hasEmpty ||
              t.hasCurrentDept ||
              t.hasCurrentUser ||
              t.hasCurrentParDept ||
              t.hasCurrentSubDept ||
              !BsyUtils.isObjectEmpty(t.parentDepts)
            );
        }
      case "combocheck":
        switch (t.method) {
          case e.EP:
          case e.NEP:
            return !0;
          default:
            return !BsyUtils.isObjectEmpty(t.value);
        }
      case "date":
      case "number":
        switch (t.method) {
          case e.RG:
            return !BsyUtils.isObjectEmpty(t.value);
          case e.EP:
          case e.NEP:
            return !0;
          default:
            return !BsyUtils.isObjectEmpty(t.value);
        }
      case "textarea":
        switch (t.method) {
          case e.EP:
          case e.NEP:
            return !0;
          default:
            return !BsyUtils.isObjectEmpty(t.value);
        }
      case "phone":
        switch (t.method) {
          case e.EP:
          case e.NEP:
          case e.VF:
          case e.NVF:
            return !0;
          default:
            return !BsyUtils.isObjectEmpty(t.value);
        }
      default:
        switch (t.method) {
          case e.IN:
          case e.NIN:
            return !BsyUtils.isObjectEmpty(t.value) || t.hasEmpty;
          case e.EP:
          case e.NEP:
            return !0;
          default:
            return !BsyUtils.isObjectEmpty(t.value);
        }
    }
  },
  parseDate: function (t) {
    if (BsyUtils.isNull(t)) return null;
    if (BsyUtils.isNumber(t)) return BsyUtils.getValidDate(new Date(t));
    if (BsyUtils.isString(t)) {
      if (t.match(/^[\d-]+T[\d:.]+Z$/))
        return BsyUtils.getValidDate(new Date(t));
      var e = t.trim().split(" ");
      if (e) {
        var i = e[0] && e[0].split("-"),
          a = i[0];
        if (!BsyUtils.isNumber(a)) return null;
        var n,
          s,
          o,
          r,
          l = BsyUtils.isNumber(i[1]) ? i[1] - 1 : 0,
          i = BsyUtils.isNumber(i[2]) ? i[2] : 1;
        return e[1]
          ? ((e = e[1].split(":")),
            (n = BsyUtils.isNumber(e[0]) ? e[0] : 0),
            (s = BsyUtils.isNumber(e[1]) ? e[1] : 0),
            (o = BsyUtils.isNumber(e[2]) ? e[2] : 0),
            (r = 0),
            /\./.test(e[2]) &&
            ((e = e[2].split(".")),
              (o = BsyUtils.isNumber(e[0]) ? e[0] : 0),
              (r = BsyUtils.isNumber(e[1]) ? e[1] : 0)),
            new Date(a, l, i, n, s, o, r))
          : new Date(a, l, i);
      }
      return null;
    }
    return BsyUtils.getValidDate(new Date(t));
  },
  getValidDate: function (t) {
    return BsyUtils.isDate(t) && !isNaN(t.getTime()) ? t : null;
  },
  // parseDate: function (t) {
  //     // let r = null;
  //     // // if(isNaN(a))
  //     // // {
  //     // //
  //     // // }
  //     // // else
  //     //    r = new Date(a)
  //     if (BsyUtils.isNull(t))
  //         return null;
  //     if (BsyUtils.isNumber(t))
  //         return new Date(t);
  //     if (BsyUtils.isString(t)) {
  //         let e = t.match(/^(\d{4})-?(\d{1,2})-?(\d{0,2})(.*?(\d{1,2}):(\d{1,2}):(\d{1,2}))?.?(\d{1,3})?$/);
  //         if (!e)
  //             e = t.match(/^(\d{4})\/?(\d{1,2})\/?(\d{0,2})(.*?(\d{1,2}):(\d{1,2}):(\d{1,2}))?.?(\d{1,3})?$/);
  //         if (e) {
  //             if (t.indexOf('T') > -1 && t.indexOf('Z') > -1) {
  //                 return new Date(t)
  //             }
  //         }
  //         return e ? new Date(e[1], e[2] - 1, e[3], e[5] || 0, e[6] || 0, e[7] || 0, e[8] || 0) : null
  //     }
  //     return new Date(t)
  //     // return r;
  // },
  getWeekOfDate: function (t) {
    let e = new Date(t.getFullYear(), t.getMonth(), t.getDate());
    e.setDate(e.getDate() + 4 - (e.getDay() || 7));
    let i = new Date(e.getFullYear(), 0, 1),
      a = Math.ceil(((e - i) / 864e5 + 1) / 7);
    return e.getFullYear() < t.getFullYear() && (a *= -1), a;
  },
  getMonthDays: function (t) {
    let e = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      i = new Date(),
      a = i.getFullYear();
    return (
      void 0 === t && (t = i.getMonth()),
      0 !== a % 4 || (0 === a % 100 && 0 !== a % 400) || 1 !== t ? e[t] : 29
    );
  },
  getWeekStartDate: function (a) {
    let b = a.getDay();
    return (
      0 === b && (b = 7),
      new Date(a.getFullYear(), a.getMonth(), a.getDate() - (b - 1))
    );
  },
  getWeekEndDate: function (a) {
    let b = a.getDay();
    return (
      0 === b && (b = 7),
      new Date(a.getFullYear(), a.getMonth(), a.getDate() + (7 - b))
    );
  },
  getMonthStartDate: function (a) {
    return new Date(a.getFullYear(), a.getMonth(), 1);
  },
  getMonthEndDate: function (a) {
    return new Date(a.getFullYear(), a.getMonth() + 1, 0);
  },
};

window.FX.Keys = {
  ENTER: 13,
  BACKSPACE: 8,
  COMMA: 188,
  DELETE: 46,
  DOWN: 40,
  END: 35,
  ESCAPE: 27,
  HOME: 36,
  LEFT: 37,
  PAGE_DOWN: 34,
  PAGE_UP: 33,
  PERIOD: 190,
  RIGHT: 39,
  SPACE: 32,
  TAB: 9,
  UP: 38,
};

//简单封装类似jq的操作，方便进行一个常规的元素操作
//事件绑定兼容写法
function _addEvent(target, type, handler) {
  if (target.addEventListener) {
    target.addEventListener(
      type,
      function (e) {
        //如果事件函数中出现 return false;则阻止默认事件和阻止冒泡
        if (typeof handler == "function" && handler(e) === false) {
          e.preventDefault();
          e.cancelBubble = true;
        }
      },
      false
    );
  } else {
    target.attachEvent("on" + type, function (event) {
      if (typeof handler == "function" && handler(event) === false) {
        event.cancelBubble = true;
        event.returnValue = false;
      }
      return handler.call(target, event);
    });
  }
}
//获取计算样式兼容写法
function _getCSS(obj, style) {
  if (window.getComputedStyle) {
    return getComputedStyle(obj)[style];
  }
  return obj.currentStyle[style];
}
//将类数组转换成数组
function _toArray(arrayLike) {
  return Array.prototype.slice.call(arrayLike);
}
//构造函数
function Mquery(arg) {
  //保存所选择的元素
  this.elements = [];
  switch (typeof arg) {
    //当参数是函数时，如$(function(){})()，直接运行里面的代码
    case "function":
      _addEvent(window, "load", arg);
      break;
    //当参数是字符串时，选择元素
    case "string":
      this.elements = _toArray(document.querySelectorAll(arg));
      break;
    //当参数是DOM对象时，将DOM对象转换为$对象
    case "object":
      if (arg.constructor == Array) {
        this.elements = arg;
      } else {
        this.elements.push(arg);
      }
      break;
    default: {
      break;
    }
  }
}
//根据索引选择元素
Mquery.prototype.eq = function (number) {
  return $Bsy(this.elements[number]);
};
//根据元素获取索引
Mquery.prototype.index = function () {
  let elements = this.elements[0].parentNode.children;
  for (let i = 0; i < elements.length; i++) {
    if (elements[i] === this.elements[0]) {
      return i;
    }
  }
};
//筛选出当前匹配的元素集合中每个元素的后代
Mquery.prototype.find = function (str) {
  let arr = [];
  for (let i = 0; i < this.elements.length; i++) {
    Array.prototype.push.apply(arr, this.elements[i].querySelectorAll(str));
  }
  return $Bsy(arr);
};
//CSS获取与设置
Mquery.prototype.css = function (attr, value) {
  //如果是对象的形式，以对象的形式设置
  if (typeof attr == "object") {
    for (let att in attr) {
      for (let j = 0; j < this.elements.length; j++) {
        this.elements[j].style[att] = attr[att];
      }
    }
    //如果不是对象的形式
  } else {
    //设置
    if (arguments.length == 2) {
      for (let i = 0; i < this.elements.length; i++) {
        this.elements[i].style[attr] = value;
      }
      //获取
    } else if (arguments.length == 1) {
      return _getCSS(this.elements[0], attr);
    }
  }
  return this;
};
//attr获取与设置
Mquery.prototype.attr = function (attr, value) {
  //如果是对象的形式
  if (typeof attr == "object") {
    for (let att in attr) {
      for (let j = 0; j < this.elements.length; j++) {
        this.elements[j].setAttribute(att, attr[att]);
      }
    }
    //如果不是对象的形式
  } else {
    //设置
    if (arguments.length == 2) {
      for (let i = 0; i < this.elements.length; i++) {
        this.elements[i].setAttribute(attr, value);
      }
      //获取
    } else if (arguments.length == 1) {
      if (this.elements.length) return this.elements[0].getAttribute(attr);
    }
  }
  return this;
};
//HTML获取与设置
Mquery.prototype.html = function (str) {
  //设置
  if (str) {
    for (let i = 0; i < this.elements.length; i++) {
      this.elements[i].innerHTML = str;
    }
    //获取
  } else {
    return this.elements[0].innerHTML;
  }
  return this;
};
//隐藏
Mquery.prototype.hide = function () {
  for (let i = 0; i < this.elements.length; i++) {
    //保存当前元素的display值
    this.elements[i].displayValue = this.elements[i].style.display;
    this.elements[i].style.display = "none";
  }
  return this;
};
//显示
Mquery.prototype.show = function () {
  for (let i = 0; i < this.elements.length; i++) {
    this.elements[i].style.display = this.elements[i].displayValue;
    //删除保存的元素的display值
    delete this.elements[i].displayValue;
  }
  return this;
};

//隐藏
Mquery.prototype.hide = function () {
  for (let i = 0; i < this.elements.length; i++) {
    //保存当前元素的display值
    this.elements[i].displayValue = this.elements[i].style.display;
    this.elements[i].style.display = "none";
  }
  return this;
};
//添加样式
Mquery.prototype.addClass = function (name) {
  for (let i = 0; i < this.elements.length; i++) {
    //保存当前元素的display值
    this.elements[i].classList.add(name);
  }
  return this;
};
//移除样式
Mquery.prototype.removeClass = function (name) {
  for (let i = 0; i < this.elements.length; i++) {
    //保存当前元素的display值
    this.elements[i].classList.remove(name);
  }
  return this;
};
//事件绑定
Mquery.prototype.on = function (eventType, fn) {
  for (let i = 0; i < this.elements.length; i++) {
    _addEvent(this.elements[i], eventType, fn.bind(this.elements[i]));
  }
  return this;
};
//click简写
Mquery.prototype.click = function (fn) {
  this.on("click", fn);
  return this;
};
//鼠标移入移出
Mquery.prototype.hover = function (fnOver, fnOut) {
  this.on("mouseover", fnOver);
  this.on("mouseout", fnOut);
  return this;
};
$Bsy.extend = function (json) {
  for (let attr in json) {
    $Bsy[attr] = json[attr];
  }
};
$Bsy.fn = {};
$Bsy.fn.extend = function (json) {
  for (let attr in json) {
    Mquery.prototype[attr] = json[attr];
  }
};

export function $Bsy(arg) {
  return new Mquery(arg);
}

const checkInPage = (el) => {
  const pageHeight = document.documentElement.clientHeight;
  const contentTop = el.getBoundingClientRect().top;
  const contentHeight = el.offsetHeight;
  return (
    (contentTop < pageHeight && contentTop >= 0) ||
    (contentTop < 0 && contentTop + contentHeight > 0)
  );
};
